/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: FetchArgs;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: FetchArgs;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: <TData, TStatus extends number>(
        response: FetchResponse<TData, TStatus>,
      ) => FetchResponse<TData, TStatus> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    const uniqMiddlewares = <
      T extends
        | Configuration["requestMiddlewares"]
        | Configuration["responseMiddlewares"],
    >(
      oldMiddlewares: T,
      newMiddlewares: T,
    ): T => {
      return [
        ...(oldMiddlewares?.filter(
          middleware => !newMiddlewares?.some(m => m.name === middleware.name),
        ) ?? []),
        ...(newMiddlewares ?? []),
      ] as T;
    };
  
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: uniqMiddlewares(CONFIG.requestMiddlewares, configuration.requestMiddlewares),
      responseMiddlewares: uniqMiddlewares(CONFIG.responseMiddlewares, configuration.responseMiddlewares),
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        request = middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<TData, TStatus extends number>(
    response: FetchResponse<TData, TStatus>,
  ): FetchResponse<TData, TStatus | 0> {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } satisfies FetchResponseOfError;
        }
        response = middlewareResponse;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchArgsOptions = Omit<RequestInit, "method" | "redirect" | "body">;

  export type FetchArgs = {
    url: string;
    options: RequestInit;
  }

  export type UriComponent = string | number | boolean;
  export type ParamsObject = {
    [key: string]: UriComponent | UriComponent[] | undefined | null;
  };

  export async function fetchJson<TData>(args: FetchArgs): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
    const errorResponse = (error: StandardError, status: number, args: FetchArgs) => {  
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    const errorStatus = (args: FetchArgs) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } satisfies FetchResponseOfError;

        return processResponseWithMiddlewares(terminationResponse);
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response);
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              }
              if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val);
              }
          }
      });
    }
  
    return formData;
  }

  
function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = (request instanceof FormData) ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return { options: requestOptions, url: `${url}${maybeQueryString}` } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("POST", request, options, url, paramsObject));
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("GET", undefined, options, url, paramsObject));
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PUT", request, options, url, paramsObject));
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("DELETE", undefined, options, url, paramsObject));
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PATCH", request, options, url, paramsObject));
}
// INFRASTRUCTURE END

export type AccessRoleWithPermissionsDto = {
	accessRoleID: number;
	code: string;
	name: string;
	accessRights: AccessRightPermissionDto[];
};

export type AccessRightPermissionDto = {
	accessRightID: number;
	code: string;
	canRead: boolean;
	canCreate: boolean;
	canUpdate: boolean;
	canDelete: boolean;
	canExport: boolean;
};

export type ProblemDetails = {
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	extensions: unknown;
};

export type SignInResult = {
	userStatus: UserStatus;
	status: SignInStatus;
	token?: string | null;
	login?: string | null;
	userID: number;
	userPublicID: string;
	firstName?: string | null;
	lastName?: string | null;
	userIdentityProviders: IdentityProvider[];
	error: AuthError;
	errorMessage?: string | null;
	accessRoleCode?: string | null;
	accessRights: AccessRightWithPermissionsDto[];
	isFirstSignIn: boolean;
	profilePicture?: string | null;
	activeContextPublicID?: string | null;
	partyPublicID: string;
	partyType: PartyType;
	version?: Version | null;
	isQuickPaymentEnabled: boolean;
	isBalanceVisible: boolean;
	migrationRequired: boolean;
	regionRequired: boolean;
	region?: Region | null;
	activeIdentityUserPublicID?: string | null;
};

export enum UserStatus {
	Unknown = "Unknown",
	InvitedWaitingForConfirmation = "InvitedWaitingForConfirmation",
	Active = "Active",
	WaitingForEmailConfirmation = "WaitingForEmailConfirmation",
	Deactivated = "Deactivated",
	BlockedFinances = "BlockedFinances",
	Anonymous = "Anonymous",
	Onboarding = "Onboarding",
	EmailConfirmed = "EmailConfirmed",
	RoleSelection = "RoleSelection"
};

export enum SignInStatus {
	Success = "Success",
	CodeVerificationStep = "CodeVerificationStep",
	Failed = "Failed",
	UnsafeSuccess = "UnsafeSuccess"
};

export enum IdentityProvider {
	Application = "Application",
	Google = "Google",
	BankID = "BankID",
	Apple = "Apple"
};

export enum AuthError {
	BankIDTokenError = "BankIDTokenError",
	BankIDUserInfoError = "BankIDUserInfoError",
	ApplicationVerification = "ApplicationVerification",
	InvalidCredentials = "InvalidCredentials",
	AccountIsDeactivated = "AccountIsDeactivated",
	AccountNotFound = "AccountNotFound",
	PhoneNumberNotFound = "PhoneNumberNotFound",
	SmsSendingFailed = "SmsSendingFailed",
	InvalidToken = "InvalidToken",
	AccountWaitingForEmailConfirmation = "AccountWaitingForEmailConfirmation"
};

export type AccessRightWithPermissionsDto = {
	code: string;
	canRead: boolean;
	canCreate: boolean;
	canUpdate: boolean;
	canDelete: boolean;
	canExport: boolean;
};

export enum PartyType {
	NaturalPerson = "NaturalPerson",
	LegalEntity = "LegalEntity",
	SelfEmployed = "SelfEmployed"
};

export enum Version {
	MooneLite = "MooneLite",
	FullMoone = "FullMoone"
};

export enum Region {
	CZ = "CZ",
	SK = "SK"
};

export type ApiProblemDetails = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	extensions: unknown;
};

export type ErrorDetail = {
	code: ErrorCode;
	message?: string | null;
};

export enum ErrorCode {
	Unspecified = "Unspecified",
	OutOfRange = "OutOfRange",
	NotFound = "NotFound",
	Invalid = "Invalid",
	Forbidden = "Forbidden",
	TooManyRequests = "TooManyRequests",
	Conflict = "Conflict",
	NullOrEmpty = "NullOrEmpty",
	Unauthorized = "Unauthorized",
	ExternalProviderNotAvailable = "ExternalProviderNotAvailable",
	InternalError = "InternalError",
	ExternalServiceError = "ExternalServiceError",
	NoContent = "NoContent",
	ExternalServiceUnavailable = "ExternalServiceUnavailable"
};

export type SignInCommand = {
	login: string;
	password: string;
};

export type SignUpCommandResult = {
	status: SignUpCommandResultStatus;
};

export enum SignUpCommandResultStatus {
	Success = "Success",
	UserExists = "UserExists",
	WeakPassword = "WeakPassword",
	RestrictedRole = "RestrictedRole",
	AnonymousUserConverted = "AnonymousUserConverted"
};

export type SignUpCommand = {
	login: string;
	password: string;
	affiliateCode?: string | null;
	partyType: PartyType;
	accessRoleCode?: string | null;
	roleIntent?: SignUpRoleIntent | null;
};

export enum SignUpRoleIntent {
	Hunter = "Hunter",
	Merchant = "Merchant"
};

export type PasswordlessSignUpCommandResult = {
	status: PasswordlessSignUpCommandResultStatus;
	signInResult?: SignInResult | null;
	subsidyFiatAmount?: number | null;
	subsidyFiatCurrencyCode?: string | null;
};

export enum PasswordlessSignUpCommandResultStatus {
	UserExists = "UserExists",
	UserCreated = "UserCreated"
};

export type PasswordlessSignUpCommand = {
	login: string;
	voucherCode?: string | null;
	isAnonymous: boolean;
	transactionPublicID?: string | null;
	campaignCode?: string | null;
	affiliateCode?: string | null;
};

export type EmailVerificationCommandResult = {
	signInResult?: SignInResult | null;
	status: EmailVerificationCommandResultStatus;
};

export enum EmailVerificationCommandResultStatus {
	NotFound = "NotFound",
	Success = "Success"
};

export type EmailVerificationCommand = {
	token: string;
};

export type ResendVerificationEmailCommandResult = {
	status: ResendVerificationEmailCommandResultStatus;
};

export enum ResendVerificationEmailCommandResultStatus {
	Success = "Success"
};

export type ResendVerificationEmailCommand = {
	email: string;
};

export type SsoSignInRequest = {
	token: string;
	affiliateCode?: string | null;
	anonymousLogin?: string | null;
	roleIntent?: SignUpRoleIntent | null;
	identityProvider: IdentityProvider;
	appleFlow?: AppleFlow | null;
};

export enum AppleFlow {
	Web = "Web",
	Native = "Native",
	Redirect = "Redirect"
};

export type UserInfoQueryResult = {
	token: string;
	login: string;
	userID: number;
	userPublicID: string;
	ssoSubject?: string | null;
	firstName: string;
	lastName: string;
	profilePicture?: string | null;
	isFirstSignIn: boolean;
	userIdentityProviders: IdentityProvider[];
	accessRoleCode?: string | null;
	accessRights: AccessRightWithPermissionsDto[];
	status: UserStatus;
	version?: Version | null;
	partyType: PartyType;
	partyPublicID: string;
	isQuickPaymentEnabled: boolean;
	isBalanceVisible: boolean;
	migrationRequired: boolean;
	regionRequired: boolean;
	region?: Region | null;
	activeContextPublicID?: string | null;
	handle?: string | null;
	handleRequired: boolean;
	isProfilePublic: boolean;
	bio?: string | null;
	stardustParticipation: ProgramParticipationState;
	thanksToYouParticipation: ProgramParticipationState;
};

export enum ProgramParticipationState {
	NotAsked = "NotAsked",
	OptedIn = "OptedIn",
	OptedOut = "OptedOut",
	Withdrawn = "Withdrawn"
};

export type LinkToCustomerCommand = {
	login: string;
	password: string;
};

export type LinkToCustomerSsoCommand = {
	identityProvider: IdentityProvider;
	token: string;
	appleFlow?: AppleFlow | null;
};

export type CreateIdentityFromUserCommand = {};

export type MerchantPersonCandidatesDto = {
	companyName?: string | null;
	companyNumber?: string | null;
	relatedPartyCandidates: RelatedPartyCandidateDto[];
};

export type RelatedPartyCandidateDto = {
	relatedPartyPublicID: string;
	firstName?: string | null;
	lastName?: string | null;
	birthDate?: string | null;
	relationType: RelationType;
	isAlreadyLinkedToIdentity: boolean;
};

export enum RelationType {
	BeneficialOwner = "BeneficialOwner",
	ProxyHolder = "ProxyHolder",
	BranchManager = "BranchManager",
	Mayor = "Mayor",
	Governor = "Governor",
	CityMayor = "CityMayor",
	ContactPerson = "ContactPerson",
	HuntersHunter = "HuntersHunter",
	HuntersMerchant = "HuntersMerchant",
	HuntersCustomer = "HuntersCustomer",
	CustomersCustomer = "CustomersCustomer",
	MerchantsCustomer = "MerchantsCustomer",
	MerchantsEmployee = "MerchantsEmployee",
	StatutoryBody = "StatutoryBody",
	InsolvencyAdministrator = "InsolvencyAdministrator",
	Liquidator = "Liquidator",
	ForcedAdministrator = "ForcedAdministrator",
	BranchOfficeManager = "BranchOfficeManager",
	ManagingDirector = "ManagingDirector",
	BoardChairman = "BoardChairman",
	BoardMember = "BoardMember",
	SupervisoryBoardChairman = "SupervisoryBoardChairman",
	SupervisoryBoardMember = "SupervisoryBoardMember",
	Partner = "Partner",
	GeneralPartner = "GeneralPartner",
	Chairman = "Chairman",
	CommitteeMember = "CommitteeMember",
	TrustManager = "TrustManager"
};

export type CreateIdentityFromMerchantCommand = {
	relatedPartyPublicID?: string | null;
	manualPerson?: ManualPersonInputDto | null;
	statutoryDeclarationConfirmed: boolean;
};

export type ManualPersonInputDto = {
	firstName?: string | null;
	lastName?: string | null;
	birthDate?: string | null;
	phone?: string | null;
	gender?: Gender | null;
};

export enum Gender {
	NotSet = "NotSet",
	Male = "Male",
	Female = "Female"
};

export type GetContextsResponse = {
	contexts: ContextDto[];
	activeIdentityUserPublicID?: string | null;
};

export type ContextDto = {
	identityUserPublicID: string;
	accessRoleCode: string;
	status: IdentityUserStatus;
	partyPublicID?: string | null;
	partyType?: PartyType | null;
	partyFirstName?: string | null;
	partyLastName?: string | null;
	partyCompanyName?: string | null;
	partyEmail?: string | null;
	identityFirstName?: string | null;
	identityLastName?: string | null;
	profilePicture?: string | null;
};

export enum IdentityUserStatus {
	Active = "Active",
	Pending = "Pending",
	Suspended = "Suspended",
	Deactivated = "Deactivated",
	Onboarding = "Onboarding"
};

export type GetMerchantContextsResponse = {
	merchants: MerchantContextDetailDto[];
	activeIdentityUserPublicID?: string | null;
};

export type MerchantContextDetailDto = {
	identityUserPublicID: string;
	identityUserStatus: IdentityUserStatus;
	merchantPublicID: string;
	merchantStatus: MerchantStatus;
	party: MerchantContextPartyDto;
	facilities: MerchantContextFacilityDto[];
};

export enum MerchantStatus {
	InDraft = "InDraft",
	InvitedWaitingForConfirmation = "InvitedWaitingForConfirmation",
	Onboarding = "Onboarding",
	WaitingForPaymentTerminal = "WaitingForPaymentTerminal",
	Active = "Active",
	BlockedFinancialServices = "BlockedFinancialServices"
};

export type MerchantContextPartyDto = {
	publicID: string;
	type: PartyType;
	companyName?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	companyNumber?: string | null;
	taxNumber?: string | null;
	isVATPayer?: boolean | null;
	headquarters?: MerchantContextAddressDto | null;
	hasContactPerson: boolean;
	phone: PhoneNumber;
};

export type MerchantContextAddressDto = {
	street?: string | null;
	streetNumber?: string | null;
	orientationNumber?: string | null;
	municipality?: string | null;
	postalCode?: string | null;
};

export type PhoneNumber = {
	prefix: string;
	number: string;
};

export type MerchantContextFacilityDto = {
	publicID: string;
	name: string;
	isPublic: boolean;
	address?: MerchantContextAddressDto | null;
};

export type SwitchContextRequest = {
	identityUserPublicID: string;
};

export type SetRegionCommand = {
	region: Region;
};

export type SendPhoneVerificationRequest = {
	phone: PhoneNumber;
	language?: string | null;
};

export type VerifyPhoneCodeRequest = {
	code: string;
};

export type PhoneVerificationStatusDto = {
	phone: PhoneNumber;
	isVerified: boolean;
};

export type ResetPasswordCommandResult = {
	status: ResetPasswordCommandResultStatus;
};

export enum ResetPasswordCommandResultStatus {
	Success = "Success",
	Fail = "Fail"
};

export type ResetPasswordCommand = {
	login: string;
};

export type SetPasswordCommand = {
	token: string;
	password: string;
};

export type SetRoleCommandResult = {
	accessRoleCode: string;
	status: UserStatus;
};

export type SetRoleRequest = {
	accessRoleCode: string;
};

export type IdentityLookupDto = {
	exists: boolean;
	isFullyVerified?: boolean | null;
	customerActive?: boolean | null;
	hasMerchantRoleForParty?: boolean | null;
	hasEmployeeRoleForParty?: boolean | null;
	isBackOffice: boolean;
};

export enum BankEnvironment {
	CSOB_SANDBOX = "CSOB_SANDBOX",
	CSOB_PROD = "CSOB_PROD",
	CSAS_SANDBOX = "CSAS_SANDBOX",
	CSAS_PROD = "CSAS_PROD",
	KB_SANDBOX = "KB_SANDBOX",
	KB_PROD = "KB_PROD",
	AirBank_SANDBOX = "AirBank_SANDBOX",
	AirBank_PROD = "AirBank_PROD",
	UCB_SANDBOX = "UCB_SANDBOX",
	UCB_PROD = "UCB_PROD",
	MONETA_SANDBOX = "MONETA_SANDBOX",
	MONETA_PROD = "MONETA_PROD",
	FIO_SANDBOX = "FIO_SANDBOX",
	FIO_PROD = "FIO_PROD",
	MBANK_PROD = "MBANK_PROD",
	MBANK_SANDBOX = "MBANK_SANDBOX",
	RB_SANDBOX = "RB_SANDBOX",
	RB_PROD = "RB_PROD",
	Citfin_PROD = "Citfin_PROD",
	TRINITY_PROD = "TRINITY_PROD",
	PenezniDum_PROD = "PenezniDum_PROD",
	Artesa_PROD = "Artesa_PROD",
	CREDITAS_PROD = "CREDITAS_PROD",
	NEY_PROD = "NEY_PROD",
	MaxBanka_PROD = "MaxBanka_PROD",
	NRB_PROD = "NRB_PROD",
	JandT_PROD = "JandT_PROD",
	PPF_PROD = "PPF_PROD",
	Oberbank_PROD = "Oberbank_PROD",
	PartnersBank_PROD = "PartnersBank_PROD",
	CNB_PROD = "CNB_PROD",
	Revolut_SANDBOX = "Revolut_SANDBOX",
	Revolut_PROD = "Revolut_PROD",
	CZKT_SANDBOX = "CZKT_SANDBOX",
	CZKT_PROD = "CZKT_PROD"
};

export type GetChatTokenQueryResult = {
	token: string;
	userId: string;
	userName: string;
	apiKey: string;
};

export type CreateChatChannelCommandResult = {
	channelId: string;
};

export type CreateChatChannelRequest = {
	memberIdentityUserPublicIDs: string[];
	name?: string | null;
	kind: ChatChannelKind;
	eligibility: ChatChannelEligibility;
};

export enum ChatChannelKind {
	Direct = "Direct",
	Group = "Group"
};

export enum ChatChannelEligibility {
	Anyone = "Anyone",
	FullMooneOnly = "FullMooneOnly"
};

export type RenameChannelRequest = {
	name: string;
};

export type AddChatChannelMemberRequest = {
	identityUserPublicIDs: string[];
};

export type GetCodeListCollectionQueryResult = {
	countries: CountryCode[];
	regions: Region[];
	enabledRegions: Region[];
	currencies: CurrencyCode[];
	enabledCurrencies: CurrencyCode[];
	phoneFormats: CountryPhoneFormatDto[];
	products: ProductDto[];
	systemSettings: SystemSettingDto[];
	facilityCategories: FacilityCategoryDto[];
	paymentErrorCodes: PaymentErrorCode[];
};

export enum CountryCode {
	AF = "AF",
	AL = "AL",
	AQ = "AQ",
	DZ = "DZ",
	AS = "AS",
	AD = "AD",
	AO = "AO",
	AG = "AG",
	AZ = "AZ",
	AR = "AR",
	AU = "AU",
	AT = "AT",
	BS = "BS",
	BH = "BH",
	BD = "BD",
	AM = "AM",
	BB = "BB",
	BE = "BE",
	BM = "BM",
	BT = "BT",
	BO = "BO",
	BA = "BA",
	BW = "BW",
	BV = "BV",
	BR = "BR",
	BZ = "BZ",
	IO = "IO",
	SB = "SB",
	VG = "VG",
	BN = "BN",
	BG = "BG",
	MM = "MM",
	BI = "BI",
	BY = "BY",
	KH = "KH",
	CM = "CM",
	CA = "CA",
	CV = "CV",
	KY = "KY",
	CF = "CF",
	LK = "LK",
	TD = "TD",
	CL = "CL",
	CN = "CN",
	TW = "TW",
	CX = "CX",
	CC = "CC",
	CO = "CO",
	KM = "KM",
	YT = "YT",
	CG = "CG",
	CD = "CD",
	CK = "CK",
	CR = "CR",
	HR = "HR",
	CU = "CU",
	CY = "CY",
	CZ = "CZ",
	BJ = "BJ",
	DK = "DK",
	DM = "DM",
	DO = "DO",
	EC = "EC",
	SV = "SV",
	GQ = "GQ",
	ET = "ET",
	ER = "ER",
	EE = "EE",
	FO = "FO",
	FK = "FK",
	GS = "GS",
	FJ = "FJ",
	FI = "FI",
	AX = "AX",
	FR = "FR",
	GF = "GF",
	PF = "PF",
	TF = "TF",
	DJ = "DJ",
	GA = "GA",
	GE = "GE",
	GM = "GM",
	PS = "PS",
	DE = "DE",
	GH = "GH",
	GI = "GI",
	KI = "KI",
	GR = "GR",
	GL = "GL",
	GD = "GD",
	GP = "GP",
	GU = "GU",
	GT = "GT",
	GN = "GN",
	GY = "GY",
	HT = "HT",
	HM = "HM",
	VA = "VA",
	HN = "HN",
	HK = "HK",
	HU = "HU",
	IS = "IS",
	IN = "IN",
	ID = "ID",
	IR = "IR",
	IQ = "IQ",
	IE = "IE",
	IL = "IL",
	IT = "IT",
	CI = "CI",
	JM = "JM",
	JP = "JP",
	KZ = "KZ",
	JO = "JO",
	KE = "KE",
	KP = "KP",
	KR = "KR",
	KW = "KW",
	KG = "KG",
	LA = "LA",
	LB = "LB",
	LS = "LS",
	LV = "LV",
	LR = "LR",
	LY = "LY",
	LI = "LI",
	LT = "LT",
	LU = "LU",
	MO = "MO",
	MG = "MG",
	MW = "MW",
	MY = "MY",
	MV = "MV",
	ML = "ML",
	MT = "MT",
	MQ = "MQ",
	MR = "MR",
	MU = "MU",
	MX = "MX",
	MC = "MC",
	MN = "MN",
	MD = "MD",
	ME = "ME",
	MS = "MS",
	MA = "MA",
	MZ = "MZ",
	OM = "OM",
	NA = "NA",
	NR = "NR",
	NP = "NP",
	NL = "NL",
	CW = "CW",
	AW = "AW",
	SX = "SX",
	BQ = "BQ",
	NC = "NC",
	VU = "VU",
	NZ = "NZ",
	NI = "NI",
	NE = "NE",
	NG = "NG",
	NU = "NU",
	NF = "NF",
	NO = "NO",
	MP = "MP",
	UM = "UM",
	FM = "FM",
	MH = "MH",
	PW = "PW",
	PK = "PK",
	PA = "PA",
	PG = "PG",
	PY = "PY",
	PE = "PE",
	PH = "PH",
	PN = "PN",
	PL = "PL",
	PT = "PT",
	GW = "GW",
	TL = "TL",
	PR = "PR",
	QA = "QA",
	RE = "RE",
	RO = "RO",
	RU = "RU",
	RW = "RW",
	BL = "BL",
	SH = "SH",
	KN = "KN",
	AI = "AI",
	LC = "LC",
	MF = "MF",
	PM = "PM",
	VC = "VC",
	SM = "SM",
	ST = "ST",
	SA = "SA",
	SN = "SN",
	RS = "RS",
	SC = "SC",
	SL = "SL",
	SG = "SG",
	SK = "SK",
	VN = "VN",
	SI = "SI",
	SO = "SO",
	ZA = "ZA",
	ZW = "ZW",
	ES = "ES",
	SS = "SS",
	SD = "SD",
	EH = "EH",
	SR = "SR",
	SJ = "SJ",
	SZ = "SZ",
	SE = "SE",
	CH = "CH",
	SY = "SY",
	TJ = "TJ",
	TH = "TH",
	TG = "TG",
	TK = "TK",
	TO = "TO",
	TT = "TT",
	AE = "AE",
	TN = "TN",
	TR = "TR",
	TM = "TM",
	TC = "TC",
	TV = "TV",
	UG = "UG",
	UA = "UA",
	MK = "MK",
	EG = "EG",
	GB = "GB",
	GG = "GG",
	JE = "JE",
	IM = "IM",
	TZ = "TZ",
	US = "US",
	VI = "VI",
	BF = "BF",
	UY = "UY",
	UZ = "UZ",
	VE = "VE",
	WF = "WF",
	WS = "WS",
	YE = "YE",
	ZM = "ZM"
};

export enum CurrencyCode {
	CNY = "CNY",
	CZK = "CZK",
	VND = "VND",
	USD = "USD",
	EUR = "EUR",
	UAH = "UAH",
	PLN = "PLN"
};

export type CountryPhoneFormatDto = {
	countryCode: CountryCode;
	prefix: string;
	minDigits: number;
	maxDigits: number;
};

export type ProductDto = {
	productID: number;
	code: ProductCode;
	name: string;
	description: string;
	nfcPayPointsLimit: number;
	terminalContractType?: MerchantTerminalContractType | null;
};

export enum ProductCode {
	OrbitS = "OrbitS",
	OrbitM = "OrbitM",
	OrbitL = "OrbitL",
	SoftPos = "SoftPos"
};

export enum MerchantTerminalContractType {
	UCB = "UCB",
	COMGATE = "COMGATE",
	ELCOM = "ELCOM"
};

export type SystemSettingDto = {
	type: SystemSettingType;
	value: string;
};

export enum SystemSettingType {
	SendinblueEmails = "SendinblueEmails",
	LeadRewardForBoth = "LeadRewardForBoth",
	WithdrawalStaticFeeSat = "WithdrawalStaticFeeSat",
	MaxInvitationCount = "MaxInvitationCount"
};

export type FacilityCategoryDto = {
	code: string;
	name: string;
};

export enum PaymentErrorCode {
	None = "None",
	Unknown = "Unknown",
	InsufficientBalance = "InsufficientBalance",
	LimitExceeded = "LimitExceeded",
	Rejected = "Rejected",
	UserCancelled = "UserCancelled",
	Expired = "Expired",
	Unauthorized = "Unauthorized",
	Technical = "Technical"
};

export type GetHunterPrerequisitesQueryResult = {
	items: HunterPrerequisiteItemDto[];
	completedCount: number;
	totalCount: number;
	hasUsedFreeMerchantRegistration: boolean;
};

export type HunterPrerequisiteItemDto = {
	prerequisiteType: HunterPrerequisiteType;
	completionStatus: PrerequisiteCompletionStatus;
	note?: string | null;
};

export enum HunterPrerequisiteType {
	RegisterAsMerchant = "RegisterAsMerchant",
	InviteUserViaAffiliate = "InviteUserViaAffiliate",
	BanksAndPayments = "BanksAndPayments",
	OfflineTraining = "OfflineTraining",
	BringMerchantsWithHunter = "BringMerchantsWithHunter"
};

export enum PrerequisiteCompletionStatus {
	NotCompleted = "NotCompleted",
	Manual = "Manual",
	Automatic = "Automatic"
};

export type UpdateHunterPrerequisiteItemRequest = {
	prerequisiteType: HunterPrerequisiteType;
	isCompleted: boolean;
	note?: string | null;
};

export type EntityListOfMerchantListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: MerchantListItemDto[];
};

export type MerchantListItemDto = {
	publicID: string;
	party: PartyDto;
	merchantStatus: MerchantStatus;
	registrationSource: MerchantRegistrationSource;
	license: MerchantLicenseDto;
	transactionsCount: number;
	dateCreated: string;
};

export type PartyDto = {
	publicID?: string | null;
	type: PartyType;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	taxNumber?: string | null;
	vatNumber: string;
	vatStatus: VatStatus;
	vatVerifiedAtUtc?: string | null;
	companyNumber?: string | null;
	personalNumber?: string | null;
	birthDate?: string | null;
	gender: Gender;
	birthPlace?: string | null;
	nationality?: CountryCode | null;
	otherNationalities: CountryCode[];
	region?: Region | null;
	isForeigner: boolean;
	isVATPayer?: boolean | null;
	phone: PhoneNumber;
	verifiedPhone: PhoneNumber;
	email?: string | null;
	partyIdentification?: PartyIdentificationDto | null;
	companyRepresentativeFirstName?: string | null;
	companyRepresentativeLastName?: string | null;
	companyRepresentativeBirthDate?: string | null;
	licenses: PartyLicenseDto[];
	addresses: AddressDto[];
	relatedParties: RelatedPartyDto[];
	hasIdentificationsUploaded?: boolean | null;
	settlementStatus?: SettlementStatus | null;
	clientIdentifier?: string | null;
};

export enum VatStatus {
	Unknown = "Unknown",
	NotRegistered = "NotRegistered",
	Registered = "Registered",
	Payer = "Payer",
	RegisteredNonPayer = "RegisteredNonPayer"
};

export type PartyIdentificationDto = {
	identification?: IdentificationType | null;
	identificationNumber?: string | null;
	identificationValidFrom?: string | null;
	identificationValidTo?: string | null;
	identificationIssuer?: string | null;
	isIDCardApprovedByClient?: boolean | null;
	secondIdentification?: IdentificationType | null;
	secondIdentificationNumber?: string | null;
	secondIdentificationValidFrom?: string | null;
	secondIdentificationValidTo?: string | null;
	secondIdentificationIssuer?: string | null;
	identificationVerdict?: IdentityDocumentVerdict | null;
	secondIdentificationVerdict?: IdentityDocumentVerdict | null;
};

export enum IdentificationType {
	IDCard = "IDCard",
	Passport = "Passport",
	DrivingLicense = "DrivingLicense",
	Other = "Other"
};

export enum IdentityDocumentVerdict {
	NotChecked = "NotChecked",
	Approved = "Approved",
	Declined = "Declined",
	InReview = "InReview",
	Unavailable = "Unavailable"
};

export type PartyLicenseDto = {
	publicID: string;
	code: LicenseCode;
	licenseNo?: string | null;
	region: Region;
	transactionPublicID?: string | null;
	paymentStatus: LicensePaymentStatus;
	paymentDate?: string | null;
	subscriptionPeriodicity?: SubscriptionPeriodicity | null;
	ownWallet: OwnershipType;
	walletAddress?: string | null;
	invoiceEmailSent: boolean;
};

export enum LicenseCode {
	Standard = "Standard",
	Bronze = "Bronze",
	Silver = "Silver",
	Gold = "Gold"
};

export enum LicensePaymentStatus {
	Initiated = "Initiated",
	Processing = "Processing",
	Success = "Success",
	Fail = "Fail",
	Cancelled = "Cancelled"
};

export enum SubscriptionPeriodicity {
	Monthly = "Monthly",
	Yearly = "Yearly"
};

export enum OwnershipType {
	NonCustodial = "NonCustodial",
	Custodial = "Custodial"
};

export type AddressDto = {
	addressID?: number | null;
	type: AddressType;
	street?: string | null;
	streetNumber?: string | null;
	orientationNumber?: string | null;
	postalCode?: string | null;
	municipality?: string | null;
};

export enum AddressType {
	Permanent = "Permanent",
	Mail = "Mail",
	Headquarters = "Headquarters"
};

export type RelatedPartyDto = {
	publicID?: string | null;
	relationType: RelationType;
	relatedPartyPublicID: string;
};

export enum SettlementStatus {
	Paid = "Paid",
	Unpaid = "Unpaid",
	Overdue = "Overdue"
};

export enum MerchantRegistrationSource {
	HunterRegistered = "HunterRegistered",
	SelfRegistered = "SelfRegistered"
};

export type MerchantLicenseDto = {
	publicID?: string | null;
	code?: LicenseCode | null;
	licenseNo?: string | null;
	companyName?: string | null;
};

export type EntityListOfLicenseShareDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: LicenseShareDto[];
};

export type LicenseShareDto = {
	publicID: string;
	merchantPublicID: string;
	companyName: string;
	licenseNumber: string;
	sharePercentage: number;
	phone: PhoneNumber;
	email: string;
	settlementStatus?: SettlementStatus | null;
	transactionsCount: number;
};

export type PendingRoleIntentsResult = {
	items: PendingRoleIntentDto[];
};

export type PendingRoleIntentDto = {
	accessRoleCode: string;
	affiliateCode?: string | null;
};

export type AddRoleResult = {
	identityUserPublicID: string;
	accessRoleCode: string;
	partyPublicID: string;
};

export type AddRoleRequest = {
	company?: CreatePartyDto | null;
	affiliateCode?: string | null;
};

export type CreatePartyDto = {
	type?: PartyType | null;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	taxNumber?: string | null;
	vatNumber: string;
	companyNumber?: string | null;
	personalNumber?: string | null;
	birthDate?: string | null;
	gender: Gender;
	birthPlace?: string | null;
	nationality?: CountryCode | null;
	otherNationalities: CountryCode[];
	region?: Region | null;
	isForeigner?: boolean | null;
	isVATPayer?: boolean | null;
	phone: PhoneNumber;
	email?: string | null;
	partyIdentification?: PartyIdentificationDto | null;
	companyRepresentativeFirstName?: string | null;
	companyRepresentativeLastName?: string | null;
	companyRepresentativeBirthDate?: string | null;
	addresses?: AddressDto[] | null;
};

export type AffiliateReferrerDto = {
	hasReferrer: boolean;
	code: string;
	publisherDisplayName: string;
};

export type ApplyAffiliateCodeRequest = {
	code: string;
};

export type CompleteRoleOnboardingResult = {
	identityUserPublicID: string;
	accessRoleCode: string;
};

export type MyInvitationsResult = {
	items: MyInvitationDto[];
};

export type MyInvitationDto = {
	publicID: string;
	accessRoleCode: string;
	merchantPublicID?: string | null;
	merchantCompanyName?: string | null;
	inviterDisplayName: string;
	expiresAt: string;
	createdAt: string;
	isAcceptable: boolean;
	blockedReason?: InvitationBlockedReason | null;
};

export enum InvitationBlockedReason {
	KycRequired = "KycRequired"
};

export type AcceptInvitationResult = {
	identityUserPublicID: string;
};

export type EntityListOfInvoiceListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: InvoiceListItemDto[];
};

export type InvoiceListItemDto = {
	invoiceID: number;
	askAmount: number;
	askCurrencyID: number;
	askCurrencyCode: string;
	status: InvoiceStatus;
	paymentReference: number;
	payerReference: string;
	accountNumber: string;
	iban: string;
};

export enum InvoiceStatus {
	New = "New",
	Paid = "Paid",
	Processed = "Processed",
	WaitingForRateConfirmation = "WaitingForRateConfirmation",
	WaitingForRateConfirmationAndPaid = "WaitingForRateConfirmationAndPaid",
	DeclinedBecauseRateConfirmation = "DeclinedBecauseRateConfirmation",
	AcceptedBecauseRateConfirmation = "AcceptedBecauseRateConfirmation"
};

export type CreateInvoiceCommandResult = {
	status: CreateInvoiceCommandResultStatus;
	invoiceID: number;
};

export enum CreateInvoiceCommandResultStatus {
	Success = "Success",
	Failed = "Failed"
};

export type CreateInvoiceRequest = {
	currencyCode: CurrencyCode;
	priceWithTax: number;
	priceWithoutTax: number;
	taxRate?: number | null;
	itemName: string;
	items?: CreateInvoiceItemRequest[] | null;
	variableSymbol?: number | null;
	bidCurrencyCode: string;
	ownershipType: XeOwnershipType;
	cryptoAddress?: string | null;
	customerPartyID: number;
	supplierPartyID: number;
	transactionID: number;
	supplierIBAN?: string | null;
	invoiceDate: string;
	paymentDate?: string | null;
	dueDate?: string | null;
	taxSupplyEffectiveDate?: string | null;
	invoiceStatus?: InvoiceStatus | null;
	merchantInvoice: boolean;
	isInitiallyPaid?: boolean | null;
	number?: number | null;
	invoiceForHunterByLicenseOrder?: InvoiceForHunterByLicenseOrder | null;
};

export type CreateInvoiceItemRequest = {
	name: string;
	priceWithTax: number;
	priceWithoutTax: number;
	taxRate?: number | null;
	vatMode: InvoiceItemVatMode;
};

export enum InvoiceItemVatMode {
	Standard = "Standard",
	ExemptPar54d = "ExemptPar54d",
	ExemptPar54e = "ExemptPar54e",
	OutsideScope = "OutsideScope"
};

export enum XeOwnershipType {
	NonCustodial = "NonCustodial",
	Custodial = "Custodial"
};

export type InvoiceForHunterByLicenseOrder = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	invoiceForHunterByLicenseOrderID: number;
	invoiceID: number;
	invoice?: Invoice | null;
	partyLicenseID: number;
	partyLicense?: PartyLicense | null;
};

export type Invoice = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	invoiceID: number;
	status: InvoiceStatus;
	number: number;
	invoiceDate: string;
	dueDate?: string | null;
	taxSupplyEffectiveDate?: string | null;
	paymentDate?: string | null;
	issuer?: string | null;
	variableSymbol?: number | null;
	constantSymbol?: number | null;
	specificSymbol?: number | null;
	isInitiallyPaid?: boolean | null;
	emailSent: boolean;
	publicID: string;
	currencyCode: CurrencyCode;
	supplierPartyID: number;
	supplier?: Party | null;
	supplierIBAN?: string | null;
	customerPartyID: number;
	customer?: Party | null;
	priceWithoutTax: number;
	priceWithTax: number;
	tax: number;
	taxRate: number;
	fixedRate?: number | null;
	transactionID: number;
	transaction?: Transaction | null;
	items: InvoiceItem[];
	invoiceForHunterByLicenseOrder?: InvoiceForHunterByLicenseOrder | null;
};

export type Party = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	partyID: number;
	publicID: string;
	type: PartyType;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	taxNumber?: string | null;
	vatNumber: string;
	vatStatus: VatStatus;
	vatVerifiedAtUtc?: string | null;
	viesRequestIdentifier: string;
	companyNumber?: string | null;
	companyNumberParsed?: number | null;
	isVATPayer?: boolean | null;
	personalNumber?: string | null;
	birthDate?: string | null;
	gender: Gender;
	birthPlace?: string | null;
	nationality?: CountryCode | null;
	otherNationalities: CountryCode[];
	region?: Region | null;
	isForeigner: boolean;
	phone: PhoneNumber;
	verifiedPhone: PhoneNumber;
	email: string;
	companyRepresentativeFirstName?: string | null;
	companyRepresentativeLastName?: string | null;
	companyRepresentativeBirthDate?: string | null;
	partyIdentification?: PartyIdentification | null;
	partyInfo?: PartyInfo | null;
	addresses: PartyAddress[];
	relatedParties: RelatedParty[];
	partyLicenses: PartyLicense[];
	payPoints: PayPoint[];
	settlements: PartyRecordSettlement[];
};

export type PartyIdentification = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	partyIdentificationID: number;
	partyID: number;
	party?: Party | null;
	firstIDCardFrontSideExtension?: string | null;
	firstIDCardBackSideExtension?: string | null;
	secondIDCardFrontSideExtension?: string | null;
	secondIDCardBackSideExtension?: string | null;
	firstIDCardFrontSidePath?: string | null;
	firstIDCardBackSidePath?: string | null;
	secondIDCardFrontSidePath?: string | null;
	secondIDCardBackSidePath?: string | null;
	identification?: IdentificationType | null;
	identificationNumber?: string | null;
	identificationValidFrom?: string | null;
	identificationValidTo?: string | null;
	identificationIssuer?: string | null;
	isIDCardApprovedByClient?: boolean | null;
	secondIdentification?: IdentificationType | null;
	secondIdentificationNumber?: string | null;
	secondIdentificationValidFrom?: string | null;
	secondIdentificationValidTo?: string | null;
	secondIdentificationIssuer?: string | null;
	identificationVerdict: IdentityDocumentVerdict;
	secondIdentificationVerdict: IdentityDocumentVerdict;
};

export type PartyInfo = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	partyInfoID: number;
	partyID: number;
	party?: Party | null;
	affiliateCode: string;
	clientIdentifier: string;
	defaultAffiliateLicenseID?: number | null;
	defaultAffiliateLicense?: PartyLicense | null;
};

export type PartyLicense = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	partyLicenseID: number;
	publicID: string;
	partyID: number;
	party?: Party | null;
	buyerPartyID?: number | null;
	buyerParty?: Party | null;
	licenseID?: number | null;
	license?: License | null;
	region: Region;
	variableSymbol: string;
	paymentStatus: LicensePaymentStatus;
	subscriptionPeriodicity?: SubscriptionPeriodicity | null;
	ownWallet: OwnershipType;
	walletAddress?: string | null;
	licenseNo?: string | null;
	transactionID?: number | null;
	transaction?: Transaction | null;
	couponID?: number | null;
	coupon?: Coupon | null;
	licenseBasePrice?: number | null;
};

export type License = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	licenseID: number;
	code: LicenseCode;
	pricing?: LicensePricing | null;
	region: Region;
	amount: number;
	blockedAmount: number;
};

export type LicensePricing = {
	licensePricingID: number;
	currencyCode: CurrencyCode;
	licenseID: number;
	license?: License | null;
	taxRate?: number | null;
	priceWithoutTax: number;
	priceWithTax: number;
	affiliatePriceWithoutTax: number;
	affiliatePriceWithTax: number;
};

export type Transaction = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	transactionID: number;
	publicID: string;
	amount: Amount;
	tipAmount: number;
	creditorIBAN?: string | null;
	creditorBankAccountID?: number | null;
	creditorBankAccount?: BankAccount | null;
	creditorID: number;
	creditor?: User | null;
	creditorIdentityUserID?: number | null;
	creditorIdentityUser?: IdentityUser | null;
	debtorID?: number | null;
	debtor?: User | null;
	debtorIdentityUserID?: number | null;
	debtorIdentityUser?: IdentityUser | null;
	debtorBankAccountID?: number | null;
	debtorBankAccount?: BankAccount | null;
	status: TransactionStatus;
	paymentID?: number | null;
	payment?: Payment | null;
	processedDate?: string | null;
	paymentReference?: string | null;
	noteForDebtor?: string | null;
	noteForCreditor?: string | null;
	payPointID?: number | null;
	payPoint?: PayPoint | null;
	credentialID?: number | null;
	credential?: PayPointCredential | null;
	externalID?: string | null;
	callbackUrl?: string | null;
	returnUrl?: string | null;
	expirationDate?: string | null;
	relatedTransactionID?: number | null;
	relatedTransaction?: Transaction | null;
	type: TransactionType;
	isPaymentClosed: boolean;
};

export type Amount = {
	value: number;
	currencyCode: CurrencyCode;
};

export type BankAccount = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	bankAccountID: number;
	userID: number;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	environment: BankEnvironment;
	iban: string;
	balance: Amount;
	rank: number;
	productName: string;
	externalID?: string | null;
	isPrimary: boolean;
	status: BankAccountStatus;
	ownersNames?: string[] | null;
	publicID: string;
};

export type User = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userID: number;
	login: string;
	password?: string | null;
	passwordSalt?: string | null;
	status: UserStatus;
	externalID: string;
	userIdentityProviders: UserIdentityProvider[];
	lastSignInDate?: string | null;
	accessRoleID?: number | null;
	accessRole?: AccessRole | null;
	userAccounts: UserAccount[];
	payerReference: number;
	feeRate: number;
	verification?: UserVerification | null;
	transactionLimits: TransactionLimit[];
	notificationSetting?: UserNotificationSetting | null;
	profilePicture?: string | null;
	leads: Lead[];
	partyID?: number | null;
	party?: Party | null;
	version?: Version | null;
	userSettings?: UserSettings | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
};

export type UserIdentityProvider = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userIdentityProviderID: number;
	userID: number;
	user?: User | null;
	identityID?: number | null;
	identity?: Identity | null;
	identityProvider: IdentityProvider;
};

export type Identity = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	identityID: number;
	login: string;
	password?: string | null;
	passwordSalt?: string | null;
	status: IdentityStatus;
	kind: IdentityKind;
	externalID: string;
	lastSignInDate?: string | null;
	signUpRoleIntent?: SignUpRoleIntent | null;
	partyID: number;
	party?: Party | null;
	identityUsers: IdentityUser[];
	userTokens: UserToken[];
	userIdentityProviders: UserIdentityProvider[];
	isBackOffice: boolean;
};

export enum IdentityStatus {
	Active = "Active",
	Deactivated = "Deactivated",
	WaitingForEmailConfirmation = "WaitingForEmailConfirmation"
};

export enum IdentityKind {
	Personal = "Personal",
	BackOffice = "BackOffice"
};

export type IdentityUser = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	identityUserID: number;
	publicID: string;
	identityID: number;
	identity?: Identity | null;
	identityKind: IdentityKind;
	accessRoleID: number;
	accessRole?: AccessRole | null;
	partyID?: number | null;
	party?: Party | null;
	status: IdentityUserStatus;
	handle?: string | null;
	isProfilePublic: boolean;
	bio: string;
	version?: Version | null;
	feeRate: number;
	payerReference: number;
	profilePicture?: string | null;
};

export type AccessRole = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	accessRoleID: number;
	code: string;
	isDeleted: boolean;
	name: string;
	description?: string | null;
	isVisible: boolean;
	accessRoleRights: AccessRoleRight[];
};

export type AccessRoleRight = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	accessRoleRightID: number;
	accessRoleID: number;
	accessRole?: AccessRole | null;
	accessRightID: number;
	accessRight?: AccessRight | null;
	permissions: Permission;
};

export type AccessRight = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	accessRightID: number;
	accessRightCode: string;
	note?: string | null;
	applicationID?: number | null;
};

export enum Permission {
	None = "None",
	Read = "Read",
	Create = "Create",
	Update = "Update",
	Delete = "Delete",
	Export = "Export",
	All = "All"
};

export type UserToken = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userTokenID: number;
	userID: number;
	identityID?: number | null;
	identity?: Identity | null;
	token: string;
	status: UserTokenStatus;
	type: UserTokenType;
	expirationDate: string;
};

export enum UserTokenStatus {
	New = "New",
	UsedSuccessfully = "UsedSuccessfully",
	Revoked = "Revoked"
};

export enum UserTokenType {
	PasswordReset = "PasswordReset",
	SignInVerification = "SignInVerification",
	EmailVerification = "EmailVerification",
	PhoneVerificationRequest = "PhoneVerificationRequest",
	PhoneVerification = "PhoneVerification",
	BankIDRefreshToken = "BankIDRefreshToken",
	ThanksToYouWithdrawal = "ThanksToYouWithdrawal"
};

export type UserAccount = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userAccountID: number;
	userID: number;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	currencyID: number;
	currency?: Currency | null;
	externalID?: string | null;
	cryptoAddresses: CryptoAddress[];
	type: XeOwnershipType;
	availableBalance: number;
	orders: Order[];
};

export type Currency = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	currencyID: number;
	code: string;
	name?: string | null;
	isDeleted: boolean;
};

export type CryptoAddress = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	cryptoAddressID: number;
	userAccountID: number;
	userAccount?: UserAccount | null;
	address: string;
	derivationKey: number;
	type: CryptoAddressType;
	isEmpty: boolean;
};

export enum CryptoAddressType {
	Legacy = "Legacy",
	Segwit = "Segwit",
	SegwitP2SH = "SegwitP2SH",
	TaprootBIP86 = "TaprootBIP86"
};

export type Order = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	orderID: number;
	userAccountID: number;
	userAccount?: UserAccount | null;
	type: OrderType;
	parentOrderID?: number | null;
	parentOrder?: Order | null;
	childOrders: Order[];
	status: OrderStatus;
	side: OrderSide;
	askCurrencyID: number;
	askCurrency?: Currency | null;
	askAmount: number;
	bidCurrencyID: number;
	bidCurrency?: Currency | null;
	bidAmount?: number | null;
	price?: number | null;
	requestedExecutionDateUTC: string;
	executionDateUTC?: string | null;
	invoiceID?: number | null;
	invoiceBankTransactionID?: string | null;
	invoice?: Invoice | null;
	transaction?: XeTransaction | null;
	fee: number;
	orderBatchID?: number | null;
	orderBatch?: OrderBatch | null;
	exchangeWithdrawalID?: number | null;
	exchangeWithdrawal?: ExchangeWithdrawal | null;
	userBankAccountID?: number | null;
	userBankAccount?: UserBankAccount | null;
};

export enum OrderType {
	Atomic = "Atomic",
	Compound = "Compound"
};

export enum OrderStatus {
	Queued = "Queued",
	Executing = "Executing",
	Executed = "Executed",
	Withdrawing = "Withdrawing",
	Filled = "Filled",
	Canceled = "Canceled",
	WaitingForUserAction = "WaitingForUserAction",
	BlockedLimitExceeded = "BlockedLimitExceeded"
};

export enum OrderSide {
	Buy = "Buy",
	Sell = "Sell"
};

export type XeTransaction = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	transactionID: number;
	externalID: string;
	dirtyAmount: number;
	cleanPrice?: number | null;
	cleanAmount?: number | null;
	currency?: Currency | null;
	currencyID: number;
	fee?: number | null;
	type: XeTransactionType;
	senderUserAccountID?: number | null;
	senderUserAccount?: UserAccount | null;
	recipientUserAccountID?: number | null;
	recipientUserAccount?: UserAccount | null;
	recipientAddress?: string | null;
	blockchainTransactionID?: string | null;
	orderID?: number | null;
	order?: Order | null;
	status: XeTransactionStatus;
	withdrawalID?: number | null;
	withdrawal?: Withdrawal | null;
	leadID?: number | null;
	lead?: Lead | null;
	payoutID?: number | null;
	payout?: Payout | null;
	voucherID?: number | null;
	voucher?: Voucher | null;
};

export enum XeTransactionType {
	Buy = "Buy",
	Sell = "Sell",
	Withdrawal = "Withdrawal",
	LeadReward = "LeadReward",
	Voucher = "Voucher",
	Coinback = "Coinback",
	LeadRewardConsumer = "LeadRewardConsumer"
};

export enum XeTransactionStatus {
	Completed = "Completed",
	PendingTrade = "PendingTrade",
	WithdrawRequested = "WithdrawRequested",
	Withdrawn = "Withdrawn",
	PendingPayout = "PendingPayout"
};

export type Withdrawal = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	withdrawalID: number;
	status: WithdrawalStatus;
	priority: WithdrawalPriority;
	noteInternal?: string | null;
};

export enum WithdrawalStatus {
	Queued = "Queued",
	Withdrawn = "Withdrawn",
	Validated = "Validated",
	Failed = "Failed"
};

export enum WithdrawalPriority {
	Low = "Low",
	High = "High"
};

export type Lead = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	leadID: number;
	email: string;
	userID?: number | null;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	status: LeadStatus;
	publisherID: number;
	publisher?: User | null;
	publisherIdentityUserID?: number | null;
	publisherIdentityUser?: IdentityUser | null;
	code: string;
	invitedAsRole?: string | null;
	affiliateRewardTier?: AffiliateRewardTier | null;
};

export enum LeadStatus {
	AnonymousPaymentPerformed = "AnonymousPaymentPerformed",
	Invited = "Invited",
	Registered = "Registered",
	Completed = "Completed",
	CompletedRewardSent = "CompletedRewardSent",
	CompletedRewardApplied = "CompletedRewardApplied",
	Withdrawn = "Withdrawn"
};

export enum AffiliateRewardTier {
	T1 = "T1",
	T2 = "T2",
	T3 = "T3"
};

export type Payout = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	payoutID: number;
	status: PayoutStatus;
	externalID: string;
	commissionValue: number;
	commissionCurrencyID: number;
	commissionCurrency?: Currency | null;
	dateRecorded: string;
	offerLinkID: number;
	offerLink?: OfferLink | null;
	userID: number;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
};

export enum PayoutStatus {
	Pending = "Pending",
	Paid = "Paid"
};

export type OfferLink = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	offerLinkID: number;
	offerID: number;
	offer?: Offer | null;
	linkPattern: string;
	rank: number;
	commissionType: CommissionType;
	commissionValue: number;
	commissionCurrencyID?: number | null;
	commissionCurrency?: Currency | null;
	status: OfferLinkStatus;
	source: OfferLinkSource;
	network?: string | null;
	externalID: string;
};

export type Offer = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	offerID: number;
	name: string;
	webUrl: string;
	status: OfferStatus;
	logoUrl?: string | null;
	source: OfferSource;
	rank: number;
	visibility: OfferVisibility;
	country?: CountryCode | null;
	offerLinks: OfferLink[];
	offerCategories: OfferCategory[];
};

export enum OfferStatus {
	Active = "Active",
	Disabled = "Disabled"
};

export enum OfferSource {
	Import = "Import",
	Manual = "Manual"
};

export enum OfferVisibility {
	Visible = "Visible",
	Hidden = "Hidden",
	Promoted = "Promoted"
};

export type OfferCategory = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	offerCategoryID: number;
	offerID: number;
	offer?: Offer | null;
	categoryID: number;
	category?: Category | null;
};

export type Category = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	categoryID: number;
	name: string;
	code: string;
	rank: number;
	offerCategories: OfferCategory[];
};

export enum CommissionType {
	Percents = "Percents",
	Fiat = "Fiat"
};

export enum OfferLinkStatus {
	Active = "Active",
	Deactivated = "Deactivated"
};

export enum OfferLinkSource {
	Manual = "Manual",
	Ehub = "Ehub",
	TuneTrezor = "TuneTrezor",
	TuneAffiliatePort = "TuneAffiliatePort",
	ScaleoAffiliatePort = "ScaleoAffiliatePort"
};

export type Voucher = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	voucherID: number;
	fiatAmount: number;
	fiatCurrencyID: number;
	fiatCurrency?: Currency | null;
	cryptoCurrencyID: number;
	cryptoCurrency?: Currency | null;
	code: string;
	reference: string;
	type: VoucherType;
	status: VoucherStatus;
	userID?: number | null;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	usagesLeft: number;
	feeRate: number;
};

export enum VoucherType {
	GiftCard = "GiftCard",
	SignUpSubsidy = "SignUpSubsidy",
	GiftCardDigital = "GiftCardDigital"
};

export enum VoucherStatus {
	Designing = "Designing",
	Unused = "Unused",
	InUse = "InUse",
	Used = "Used",
	ToApply = "ToApply"
};

export type OrderBatch = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	orderBatchID: number;
	status: OrderBatchStatus;
	maxRounds: number;
	priceReductionRatePerRound: number;
	timeBetweenExecutions: string;
	currentOrderBatchExecution: OrderBatchExecution;
	orderBatchExecutions: OrderBatchExecution[];
	orders: Order[];
	priceWhenCreated?: number | null;
};

export enum OrderBatchStatus {
	New = "New",
	Processing = "Processing",
	Filled = "Filled",
	Withdrawing = "Withdrawing",
	Withdrawn = "Withdrawn"
};

export type OrderBatchExecution = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	orderBatchExecutionID: number;
	orderBatchID: number;
	orderBatch?: OrderBatch | null;
	orderBatchIndex: number;
	priceReductionRate: number;
	exchangeOrderID?: string | null;
	askAmountRequested?: number | null;
	askAmountExecuted?: number | null;
	askPriceRequested?: number | null;
	currentAskPrice?: number | null;
	averagePrice?: number | null;
	bidAmountRequested?: number | null;
	bidAmountExecuted?: number | null;
	executionDateUTC?: string | null;
	closingDateUTC?: string | null;
	status: OrderBatchExecutionStatus;
	type: OrderBatchExecutionType;
	exchange?: Exchange | null;
};

export enum OrderBatchExecutionStatus {
	New = "New",
	Opened = "Opened",
	ClosedMatchedFully = "ClosedMatchedFully",
	ClosedMatchedPartially = "ClosedMatchedPartially",
	ClosedNotMatched = "ClosedNotMatched"
};

export enum OrderBatchExecutionType {
	Maker = "Maker",
	Taker = "Taker"
};

export enum Exchange {
	Coinbase = "Coinbase",
	CoinMate = "CoinMate",
	Testnet = "Testnet"
};

export type ExchangeWithdrawal = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	exchangeWithdrawalID: number;
	dirtyAmount: number;
	cleanAmount: number;
	fee: number;
	cryptoAddressID: number;
	cryptoAddress?: CryptoAddress | null;
	blockchainTransactionID?: string | null;
	status: ExchangeWithdrawalStatus;
	orders: Order[];
	externalID?: string | null;
	exchange: Exchange;
};

export enum ExchangeWithdrawalStatus {
	Pending = "Pending",
	Completed = "Completed"
};

export type UserBankAccount = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userBankAccountID: number;
	userID: number;
	user?: User | null;
	iban?: string | null;
	status: UserBankAccountStatus;
	externalID: string;
	paymentReference?: number | null;
	invoicingHistory: InvoicingHistory[];
};

export enum UserBankAccountStatus {
	New = "New",
	NewToVerify = "NewToVerify",
	Verified = "Verified",
	VerifiedIBANParsingError = "VerifiedIBANParsingError",
	Rejected = "Rejected"
};

export type InvoicingHistory = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	invoicingHistoryID: number;
	userBankAccountID: number;
	userBankAccount?: UserBankAccount | null;
	invoiceBankTransactionID: string;
	status: InvoicingHistoryStatus;
	accountFromName?: string | null;
};

export enum InvoicingHistoryStatus {
	Accepted = "Accepted",
	Rejected = "Rejected"
};

export type UserVerification = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userVerificationID: number;
	publicID: string;
	userID?: number | null;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	businessActivity?: BusinessActivity | null;
	otherBusinessActivityDetails?: string | null;
	sourcesOfIncome: UserVerificationSourceOfIncome[];
	otherSourceOfIncomeDetails?: string | null;
	uboUnknown: boolean;
	expectedMonthlyRevenue?: ExpectedMonthlyRevenue | null;
	averageTransactionValue?: AverageTransactionValue | null;
	taxResidency?: CountryCode | null;
	hasNonEUNationality?: boolean | null;
	hasNonEUResidence?: boolean | null;
	hasMoneyFromCriminalActivityOrIsFinancingTerrorism: boolean;
	hasConnectionToSanctionedCountry: boolean;
	isPoliticallyExposedPerson: boolean;
	additionalInfoStatus: AdditionalInfoStatus;
	identityVerificationStatus: IdentityVerificationStatus;
	riskProfile: RiskProfileStatus;
	bankVerificationStatus: BankVerificationStatus;
	verificationJson?: string | null;
	externalID?: string | null;
	birthnumberSha256?: string | null;
	legacySourceOfIncome?: string | null;
	verifiedIBAN?: string | null;
	bankVerificationSource?: BankVerificationSource | null;
	bankVerificationDate?: string | null;
	bankVerificationIPAddress?: string | null;
	bankVerificationUserAgent?: string | null;
	bankVerificationRequestID?: string | null;
	verificationLevel: number;
};

export enum BusinessActivity {
	RetailAndGoodsSales = "RetailAndGoodsSales",
	FoodServicesAndGastronomy = "FoodServicesAndGastronomy",
	AccommodationAndTourism = "AccommodationAndTourism",
	BeautyHealthAndWellness = "BeautyHealthAndWellness",
	ConstructionCraftsAndMaintenance = "ConstructionCraftsAndMaintenance",
	TransportAutoAndLogistics = "TransportAutoAndLogistics",
	FinancialLegalAndConsulting = "FinancialLegalAndConsulting",
	EducationSportsAndLeisure = "EducationSportsAndLeisure",
	TechnologyITAndOnline = "TechnologyITAndOnline",
	IndustryManufacturingAndWholesale = "IndustryManufacturingAndWholesale",
	OtherAndPublicServices = "OtherAndPublicServices",
	RetailAndCommerce = "RetailAndCommerce",
	FoodAndBeverageServices = "FoodAndBeverageServices",
	AccommodationAndHospitality = "AccommodationAndHospitality",
	BeautyAndPersonalCare = "BeautyAndPersonalCare",
	HealthcareAndPersonalCare = "HealthcareAndPersonalCare",
	ConstructionAndMaintenance = "ConstructionAndMaintenance",
	TransportationAndLogistics = "TransportationAndLogistics",
	FinancialServicesAndInsurance = "FinancialServicesAndInsurance",
	RealEstateAndPropertyServices = "RealEstateAndPropertyServices",
	LegalAndConsultingServices = "LegalAndConsultingServices",
	EducationAndTraining = "EducationAndTraining",
	ArtsCultureAndEntertainment = "ArtsCultureAndEntertainment",
	SportsAndRecreation = "SportsAndRecreation",
	TechnologyAndITServices = "TechnologyAndITServices",
	ECommerceAndOnlineServices = "ECommerceAndOnlineServices",
	IndustrialProductionAndProcessing = "IndustrialProductionAndProcessing",
	Other = "Other",
	PersonalServices = "PersonalServices"
};

export type UserVerificationSourceOfIncome = {
	userVerificationSourceOfIncomeID: number;
	userVerificationID: number;
	userVerification: UserVerification;
	sourceOfIncome: SourceOfIncome;
};

export enum SourceOfIncome {
	GoodsSalesRevenue = "GoodsSalesRevenue",
	ServiceAndCraftIncome = "ServiceAndCraftIncome",
	HospitalityAndAccommodation = "HospitalityAndAccommodation",
	CommissionsAndLicensing = "CommissionsAndLicensing",
	PropertyAndInvestmentIncome = "PropertyAndInvestmentIncome",
	PublicBudgetsAndGrants = "PublicBudgetsAndGrants",
	OtherBusinessIncome = "OtherBusinessIncome",
	Employment = "Employment",
	SelfEmployment = "SelfEmployment",
	Other = "Other"
};

export enum ExpectedMonthlyRevenue {
	LessThan100K = "LessThan100K",
	From100KTo500K = "From100KTo500K",
	From500KTo1M = "From500KTo1M",
	Over1M = "Over1M"
};

export enum AverageTransactionValue {
	LessThan1K = "LessThan1K",
	From1KTo10K = "From1KTo10K",
	From10KTo50K = "From10KTo50K",
	Over50K = "Over50K"
};

export enum AdditionalInfoStatus {
	NotVerified = "NotVerified",
	Verified = "Verified",
	NeedsInvestigation = "NeedsInvestigation"
};

export enum IdentityVerificationStatus {
	NotVerified = "NotVerified",
	Verified = "Verified",
	Processing = "Processing",
	ToVerify = "ToVerify",
	Expired = "Expired"
};

export enum RiskProfileStatus {
	NotVerified = "NotVerified",
	LowRisk = "LowRisk",
	MediumRisk = "MediumRisk",
	HighRisk = "HighRisk",
	Unacceptable = "Unacceptable"
};

export enum BankVerificationStatus {
	NotVerified = "NotVerified",
	Verified = "Verified",
	InProgress = "InProgress"
};

export enum BankVerificationSource {
	QR = "QR",
	AIS = "AIS"
};

export type TransactionLimit = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	transactionLimitID: number;
	oneTimeSendLimit?: number | null;
	dailySendLimit?: number | null;
	monthlySendLimit?: number | null;
	oneTimeReceiveLimit?: number | null;
	dailyReceiveLimit?: number | null;
	monthlyReceiveLimit?: number | null;
	currencyCode: CurrencyCode;
	userID: number;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
};

export type UserNotificationSetting = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userNotificationSettingID: number;
	userID: number;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	isFilledOrderNotificationActive: boolean;
	isCreatedOrderNotificationActive: boolean;
	isWithdrawalNotificationActive: boolean;
};

export type UserSettings = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	userSettingsID: number;
	userID?: number | null;
	isQuickPaymentEnabled: boolean;
	isBalanceVisible: boolean;
	terminalPinHash?: string | null;
	terminalPinEncrypted?: string | null;
	terminalPinFailedAttempts: number;
	terminalPinLockedUntil?: string | null;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
};

export enum BankAccountStatus {
	Inactive = "Inactive",
	AwaitingVerification = "AwaitingVerification",
	Rejected = "Rejected",
	Active = "Active",
	Restricted = "Restricted",
	PreApproved = "PreApproved"
};

export enum TransactionStatus {
	Created = "Created",
	Initiated = "Initiated",
	Processing = "Processing",
	Success = "Success",
	Fail = "Fail",
	Cancelled = "Cancelled",
	InvestigationNeeded = "InvestigationNeeded"
};

export type Payment = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	paymentID: number;
	instructionIdentification: string;
	userID: number;
	user: User;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	transactionID?: number | null;
	amount: Amount;
	debtorIBAN: string;
	creditorIBAN: string;
	environment: BankEnvironment;
	log: PaymentLog;
	statusLogs: PaymentStatusLog[];
	instructionStatus: PaymentInstructionStatus;
	failureReason: PaymentErrorCode;
	paymentReference?: string | null;
	note?: string | null;
	noteForCreditor?: string | null;
	batchPaymentID?: number | null;
	batchPayment?: BatchPayment | null;
};

export type PaymentLog = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	paymentLogID: number;
	balanceCheckRequest?: JsonDocument | null;
	balanceCheckRequestSpecific?: JsonDocument | null;
	balanceCheckHeaders?: JsonDocument | null;
	balanceCheckResponse?: JsonDocument | null;
	balanceCheckStatus?: PaymentStatus | null;
	balanceCheckUrl?: string | null;
	balanceCheckAccessTokenID?: number | null;
	balanceCheckAccessToken?: BankToken | null;
	balanceCheckDateStarted?: string | null;
	balanceCheckDateFinished?: string | null;
	balanceCheckResponseIdentification?: string | null;
	balanceCheckExchangeIdentification?: string | null;
	balanceCheckResultStatus?: BalanceCheckStatus | null;
	initializationRequest?: JsonDocument | null;
	initializationRequestSpecific?: JsonDocument | null;
	initializationHeaders?: JsonDocument | null;
	initializationResponse?: JsonDocument | null;
	initializationStatus?: PaymentStatus | null;
	initializationUrl?: string | null;
	initializationAccessTokenID?: number | null;
	initializationAccessToken?: BankToken | null;
	initializationRefreshTokenID?: number | null;
	initializationRefreshToken?: BankToken | null;
	initializationDateStarted?: string | null;
	initializationDateFinished?: string | null;
	authorizationUrl?: string | null;
	authorizationHeaders?: JsonDocument | null;
	authorizationRequest?: JsonDocument | null;
	authorizationResponse?: JsonDocument | null;
	authorizationStatus?: PaymentStatus | null;
	authorizationAccessTokenID?: number | null;
	authorizationAccessToken?: BankToken | null;
	authorizationDateStarted?: string | null;
	authorizationDateFinished?: string | null;
	signingUrl?: string | null;
	signatureStatus?: SignatureStatus | null;
	signID?: string | null;
	hash?: string | null;
	signatureDateStarted?: string | null;
	signatureDateFinished?: string | null;
	nextStatusCheckDate?: string | null;
	processResponse?: JsonDocument | null;
	processedDateStarted?: string | null;
	processedDateFinished?: string | null;
};

export type JsonDocument = {
	rootElement: any;
};

export enum PaymentStatus {
	None = "None",
	Success = "Success",
	Fail = "Fail"
};

export type BankToken = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	bankTokenID: number;
	token: string;
	expirationDate: string;
	userID: number;
	user: User;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	environment: BankEnvironment;
	type: BankTokenType;
	consentId?: string | null;
	scopeTimeLimit?: string | null;
	isInvalid: boolean;
	bankTokenAccounts?: BankTokenAccount[] | null;
};

export enum BankTokenType {
	OAuth2Code = "OAuth2Code",
	AccessToken = "AccessToken",
	RefreshToken = "RefreshToken",
	AccessTokenAISP = "AccessTokenAISP",
	AccessTokenPISP = "AccessTokenPISP",
	RefreshTokenAISP = "RefreshTokenAISP",
	RefreshTokenPISP = "RefreshTokenPISP"
};

export type BankTokenAccount = {
	bankTokenAccountID: number;
	accountID: string;
	accountNumber: string;
	bankTokenID: number;
	bankToken?: BankToken | null;
};

export enum BalanceCheckStatus {
	APPR = "APPR",
	DECL = "DECL"
};

export enum SignatureStatus {
	Success = "Success",
	None = "None",
	Fail = "Fail"
};

export type PaymentStatusLog = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	paymentStatusLogID: number;
	url?: string | null;
	requestHeaders?: JsonDocument | null;
	response?: JsonDocument | null;
	status?: PaymentInstructionStatus | null;
	checkDateStarted?: string | null;
	checkDateFinished?: string | null;
	paymentID: number;
	payment?: Payment | null;
};

export enum PaymentInstructionStatus {
	None = "None",
	AcceptedTechnicalValidation = "AcceptedTechnicalValidation",
	AcceptedCustomerProfile = "AcceptedCustomerProfile",
	AcceptedSettlementCompleted = "AcceptedSettlementCompleted",
	Rejected = "Rejected",
	AcceptedWithChange = "AcceptedWithChange"
};

export type BatchPayment = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	batchPaymentID: number;
	publicID: string;
	userID: number;
	user: User;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	bankAccountID: number;
	bankAccount: BankAccount;
	status: BatchPaymentStatus;
	transactionIdentification?: number | null;
	signId?: number | null;
	signingUrl?: string | null;
	authorizedAt?: string | null;
	completedAt?: string | null;
	creationResponse?: JsonDocument | null;
	authorizationResponse?: JsonDocument | null;
	payments: Payment[];
};

export enum BatchPaymentStatus {
	Created = "Created",
	Initiated = "Initiated",
	Processing = "Processing",
	Success = "Success",
	Fail = "Fail",
	Cancelled = "Cancelled"
};

export type PayPoint = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	payPointID: number;
	publicID: string;
	type: PayPointType;
	name?: string | null;
	description?: string | null;
	partyID: number;
	party?: Party | null;
	transactions: Transaction[];
	productID?: number | null;
	product?: Product | null;
	merchantPricingID?: number | null;
	merchantPricing?: MerchantPricing | null;
	externalID?: string | null;
	nfcCardNo?: string | null;
	employees: EmployeePayPoint[];
	merchantFacilityID?: number | null;
	merchantFacility?: MerchantFacility | null;
	bankAccountID?: number | null;
	bankAccount?: BankAccount | null;
	credentialID?: number | null;
	credential?: PayPointCredential | null;
	settings?: PayPointSettings | null;
};

export enum PayPointType {
	Virtual = "Virtual",
	NFC = "NFC",
	Terminal = "Terminal",
	Gateway = "Gateway"
};

export type Product = {
	productID: number;
	code: ProductCode;
	name: string;
	description: string;
	nfcPayPointsLimit: number;
	terminalContractType?: MerchantTerminalContractType | null;
};

export type MerchantPricing = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantPricingID: number;
	publicID: string;
	productName: string;
	merchantPricingVariant?: MerchantPricingVariant | null;
	productCode?: ProductCode | null;
	terminalFinancing?: TerminalFinancing | null;
	moonePlatformFee: number;
	hunterLicenseDirectFee: number;
	hunterRewardPoolFee: number;
	hunterValorRewardPoolFee: number;
	userRewardPoolFee: number;
	totalFee: number;
	fixedTransactionCost: number;
	minAverageTransactionAmount: number;
	currencyID: number;
	currency?: Currency | null;
	includesVAT: boolean;
	isEnabled: boolean;
};

export enum MerchantPricingVariant {
	Variant1 = "Variant1",
	Variant2 = "Variant2",
	Variant3 = "Variant3",
	Variant4 = "Variant4",
	Variant5 = "Variant5",
	Variant6 = "Variant6",
	Individual = "Individual"
};

export enum TerminalFinancing {
	Moone = "Moone",
	Hunter = "Hunter"
};

export type EmployeePayPoint = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	employeePayPointID: number;
	employeeID: number;
	employee?: Employee | null;
	payPointID: number;
	payPoint?: PayPoint | null;
};

export type Employee = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	employeeID: number;
	merchantID: number;
	partyID: number;
	merchant?: Merchant | null;
	party?: Party | null;
	status: EmployeeStatus;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	payPoints: EmployeePayPoint[];
	publicID: string;
};

export type Merchant = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantID: number;
	partyID: number;
	partyLicenseID?: number | null;
	partyLicense?: PartyLicense | null;
	party?: Party | null;
	status: MerchantStatus;
	note?: string | null;
	facilities: MerchantFacility[];
	terminalContracts: MerchantTerminalContract[];
	fees: MerchantFee[];
	applicationProducts: MerchantAppProduct[];
	invoiceNumberInit?: number | null;
	publicID: string;
	externalID?: string | null;
	registrationSource: MerchantRegistrationSource;
};

export type MerchantFacility = {
	publicID: string;
	merchantFacilityID: number;
	merchantID: number;
	merchant?: Merchant | null;
	name: string;
	providedServices?: string | null;
	responsiblePerson: string;
	phone: PhoneNumber;
	email?: string | null;
	openSince?: string | null;
	addressID?: number | null;
	address?: Address | null;
	yearlyTurnover?: number | null;
	estimatedTurnover?: number | null;
	realCardTurnover?: number | null;
	averageTransactionValue?: number | null;
	turnoverCurrencyCode: CurrencyCode;
	isPublic: boolean;
	description?: string | null;
	logoFileName?: string | null;
	facilityCategories: MerchantFacilityMerchantFacilityCategory[];
	hours: MerchantFacilityHours[];
	specialHours: MerchantFacilitySpecialHours[];
	photoOutside?: string | null;
	photoOutsideExtension?: string | null;
	photoInside?: string | null;
	photoInsideExtension?: string | null;
	terminalCount?: number | null;
	softPosCount?: number | null;
	tmsOrgUnitCode?: string | null;
};

export type Address = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	addressID: number;
	type: AddressType;
	street?: string | null;
	streetNumber?: string | null;
	orientationNumber?: string | null;
	postalCode?: string | null;
	municipality?: string | null;
};

export type MerchantFacilityMerchantFacilityCategory = {
	merchantFacilityMerchantFacilityCategoryID: number;
	merchantFacilityID: number;
	merchantFacility?: MerchantFacility | null;
	merchantFacilityCategoryID: number;
	merchantFacilityCategory?: MerchantFacilityCategory | null;
};

export type MerchantFacilityCategory = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantFacilityCategoryID: number;
	code: string;
	name: string;
	mcc?: string | null;
	isDeleted: boolean;
};

export type MerchantFacilityHours = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantFacilityHoursID: number;
	merchantFacilityID: number;
	facility?: MerchantFacility | null;
	weekday: number;
	openTime?: string | null;
	closeTime?: string | null;
	isClosedAllDay: boolean;
	isOpenAllDay: boolean;
};

export type MerchantFacilitySpecialHours = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantFacilitySpecialHoursID: number;
	merchantFacilityID: number;
	facility?: MerchantFacility | null;
	date: string;
	openTime?: string | null;
	closeTime?: string | null;
	isClosedAllDay: boolean;
	isOpenAllDay: boolean;
};

export type MerchantTerminalContract = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantTerminalContractID: number;
	type: MerchantTerminalContractType;
	merchantID: number;
	merchant?: Merchant | null;
	ucbTerminalContractDetailID?: number | null;
	ucbTerminalContractDetail?: UCBTerminalContractDetail | null;
	comgateTerminalContractDetailID?: number | null;
	comgateTerminalContractDetail?: ComgateTerminalContractDetail | null;
	externalMerchantID?: string | null;
	publicID: string;
};

export type UCBTerminalContractDetail = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	ucbTerminalContractDetailID: number;
	merchantTerminalContractID: number;
	merchantTerminalContract?: MerchantTerminalContract | null;
	gprsCount?: number | null;
	softPosCount?: number | null;
	file: string;
};

export type ComgateTerminalContractDetail = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	comgateTerminalContractDetailID: number;
	merchantTerminalContractID: number;
	merchantTerminalContract?: MerchantTerminalContract | null;
	comgateMID?: string | null;
	comgateStatus?: string | null;
	contractFilePath?: string | null;
	contractDownloadedAt?: string | null;
	contractAcceptedAt?: string | null;
	contractAcceptedByUserID?: number | null;
	paymentServicesContractFilePath?: string | null;
	paymentServicesDownloadedAt?: string | null;
	handoverProtocolFilePath?: string | null;
	handoverConfirmedAt?: string | null;
	handoverConfirmedByUserID?: number | null;
	terminalCount: number;
	softPosCount: number;
	currencies: string;
	tariff?: string | null;
	financingModel: TerminalFinancingModel;
	submittedToComgateAt?: string | null;
	verificationPaymentData?: string | null;
	lastStatusCheckAt?: string | null;
	comgateStatusChangedAt?: string | null;
	merchantTerminalData?: string | null;
	rejectedMessagesJson?: string | null;
	tmsRegistrationCompletedAt?: string | null;
	payoutIBAN?: string | null;
	payoutBIC?: string | null;
	payoutCurrency?: string | null;
	payoutAccountNumber?: string | null;
	auditRecords: ComgateContractAuditRecord[];
	tids: ComgateTerminalTid[];
};

export enum TerminalFinancingModel {
	Legione = "Legione",
	Hunter = "Hunter"
};

export type ComgateContractAuditRecord = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	comgateContractAuditRecordID: number;
	comgateTerminalContractDetailID: number;
	comgateTerminalContractDetail?: ComgateTerminalContractDetail | null;
	acceptedByUserID: number;
	acceptedByUserName: string;
	acceptedByUserEmail: string;
	acceptedAt: string;
	contractFileHash: string;
	ipAddress?: string | null;
	userAgent?: string | null;
	kycPackageId?: string | null;
	signingAttestationFilePath?: string | null;
};

export type ComgateTerminalTid = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	comgateTerminalTidID: number;
	comgateTerminalContractDetailID: number;
	comgateTerminalContractDetail?: ComgateTerminalContractDetail | null;
	tid: string;
	storeName?: string | null;
	merchantFacilityID?: number | null;
	merchantFacility?: MerchantFacility | null;
	terminalType?: TerminalType | null;
	isTypeManual: boolean;
};

export enum TerminalType {
	Physical = "Physical",
	SoftPos = "SoftPos"
};

export type MerchantFee = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantFeeID: number;
	merchantID: number;
	partyLicenseID?: number | null;
	partyLicense?: PartyLicense | null;
	merchantPricingID?: number | null;
	merchantPricing?: MerchantPricing | null;
	partyLicenseShareAmount?: number | null;
	publicID: string;
};

export type MerchantAppProduct = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	merchantAppProductID: number;
	merchantID: number;
	merchant?: Merchant | null;
	productID: number;
	product?: Product | null;
};

export enum EmployeeStatus {
	Created = "Created",
	InvitedWaitingForConfirmation = "InvitedWaitingForConfirmation",
	Active = "Active",
	Inactive = "Inactive"
};

export type PayPointCredential = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	payPointCredentialID: number;
	publicID: string;
	name: string;
	keyHash: string;
	userID: number;
	user?: User | null;
	identityUserID?: number | null;
	identityUser?: IdentityUser | null;
	lastUsedAt?: string | null;
	revokedAt?: string | null;
	payPoint?: PayPoint | null;
};

export type PayPointSettings = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	payPointSettingsID: number;
	payPointID: number;
	payPoint?: PayPoint | null;
	mode: PayPointMode;
	predefinedAmount?: number | null;
	predefinedAmountCurrencyCode?: CurrencyCode | null;
	tipsEnabled: boolean;
	redirectUrl?: string | null;
};

export enum PayPointMode {
	Standard = "Standard",
	Collector = "Collector",
	Link = "Link",
	TableService = "TableService"
};

export enum TransactionType {
	Payment = "Payment",
	Transfer = "Transfer",
	Settlement = "Settlement",
	Internal = "Internal",
	Refund = "Refund",
	License = "License",
	Campaign = "Campaign"
};

export type Coupon = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	couponID: number;
	code: string;
	discount: number;
	discountType: CouponDiscountType;
	expirationDate: string;
	type: CouponType;
	region: Region;
	initialStock: number;
	currentStock: number;
};

export enum CouponDiscountType {
	Percentage = "Percentage",
	FixedAmount = "FixedAmount"
};

export enum CouponType {
	HunterLicense = "HunterLicense"
};

export type PartyAddress = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	partyAddressID: number;
	partyID: number;
	party?: Party | null;
	addressID: number;
	address?: Address | null;
};

export type RelatedParty = {
	isDeleted: boolean;
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	relatedPartyID: number;
	publicID: string;
	primaryPartyID: number;
	primaryParty: Party;
	relatedToPartyID: number;
	relatedToParty: Party;
	relationType: RelationType;
};

export type PartyRecordSettlement = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	partyRecordSettlementID: number;
	partyID: number;
	party?: Party | null;
	sum: number;
	payoutAmount?: number | null;
	settlementPeriodID: number;
	settlementPeriod?: SettlementPeriod | null;
	isPaid: boolean;
	transactionID?: number | null;
	transaction?: Transaction | null;
	type: PartyRecordSettlementType;
	region: Region;
	paidDate?: string | null;
	processedInSettlementPeriodID?: number | null;
	processedInSettlementPeriod?: SettlementPeriod | null;
};

export type SettlementPeriod = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	settlementPeriodID: number;
	publicID: string;
	recordSettlementDate?: string | null;
	isClosed: boolean;
	poolBoosts: SettlementPoolBoost[];
};

export type SettlementPoolBoost = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	settlementPoolBoostID: number;
	settlementPeriodID: number;
	settlementPeriod?: SettlementPeriod | null;
	region: Region;
	loyaltyPointType: LoyaltyPointType;
	boostAmount: Amount;
	hunterPoolRatioPercent?: number | null;
	valorPoolRatioPercent?: number | null;
};

export enum LoyaltyPointType {
	Valor = "Valor",
	Stardust = "Stardust"
};

export enum PartyRecordSettlementType {
	ServiceFee = "ServiceFee",
	Payout = "Payout",
	LoyaltyProgramPayout = "LoyaltyProgramPayout",
	CommissionPayout = "CommissionPayout",
	AffiliateReward = "AffiliateReward",
	HunterCommissionFunding = "HunterCommissionFunding"
};

export type InvoiceItem = {
	dateCreated: string;
	createdBy: number;
	createdByIdentityUserID?: number | null;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	updatedByIdentityUserID?: number | null;
	invoiceItemID: number;
	invoiceID: number;
	invoice?: Invoice | null;
	name?: string | null;
	amount: number;
	priceWithoutTax: number;
	priceWithTax: number;
	tax: number;
	taxRate: number;
	originalTaxRate: number;
	vatMode: InvoiceItemVatMode;
};

export type GetInvoiceRateChangeDetailQueryResult = {
	invoiceRateChangeID: number;
	invoiceID: number;
	invoiceFixedRate: number;
	invoiceAskAmount: number;
	invoiceAskCurrencyCode: string;
	rate: number;
	dateCalculated: string;
	externalID: string;
};

export type GetInvoiceRateChangeDetailQuery = {
	externalID: string;
};

export type ProcessInvoiceRateChangeCommandResult = {
	status: ProcessInvoiceRateChangeCommandResultStatus;
};

export enum ProcessInvoiceRateChangeCommandResultStatus {
	Success = "Success",
	Fail = "Fail",
	NotFound = "NotFound"
};

export type ProcessInvoiceRateChangeRequest = {
	isAccepted: boolean;
	externalID: string;
};

export type InvoiceSettingsDto = {
	ownershipType: XeOwnershipType;
	cryptoAddress?: string | null;
};

export type SaveInvoiceSettingsCommandResult = {
	status: SaveInvoiceSettingsCommandResultStatus;
};

export enum SaveInvoiceSettingsCommandResultStatus {
	Success = "Success"
};

export type GetUserFeeRateQueryResult = {
	feeRate: number;
	remainingAmount: number;
	remainingAmountCurrencyCode: string;
	nextFeeRate: number;
};

export enum InvoiceFormat {
	Pdf = "Pdf",
	Isdoc = "Isdoc"
};

export enum SettlementInvoiceType {
	Merchant = "Merchant",
	Hunter = "Hunter"
};

export type EntityListOfLeadDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: LeadDto[];
};

export type LeadDto = {
	email?: string | null;
	status: LeadStatus;
	code: string;
	invitedAsRole?: string | null;
	dateCreated: string;
	dateUpdated?: string | null;
};

export type AffiliateDataDto = {
	url: string;
	code: string;
	defaultAffiliateLicensePublicID?: string | null;
};

export type LeadInvitationCommandResult = {
	status: LeadInvitationCommandResultStatus;
};

export enum LeadInvitationCommandResultStatus {
	Success = "Success",
	UserExists = "UserExists",
	LeadExists = "LeadExists",
	Error = "Error"
};

export type InviteLeadRequest = {
	email: string;
	userRole: string;
};

export type SetThanksToYouParticipationResult = {
	thanksToYouParticipation: ProgramParticipationState;
};

export type SetThanksToYouParticipationCommand = {
	state: ProgramParticipationState;
};

export type RequestThanksToYouWithdrawalResult = {
	email: string;
	expiresAt: string;
};

export type ConfirmThanksToYouWithdrawalResult = {
	status: ThanksToYouWithdrawalStatus;
};

export enum ThanksToYouWithdrawalStatus {
	Success = "Success",
	AlreadyWithdrawn = "AlreadyWithdrawn",
	Expired = "Expired",
	NotFound = "NotFound"
};

export type SetDefaultAffiliateLicenseRequest = {
	licensePublicID?: string | null;
};

export type AffiliateCodeVerificationDto = {
	code: string;
	publisherDisplayName: string;
};

export type AffiliateEarningsSummaryDto = {
	totalRegisteredUsers: number;
	tier1Count: number;
	tier2Count: number;
	tier3Count: number;
	currentPayoutAmount: number;
	currentPayoutCurrency: string;
	totalEarned: number;
	totalEarnedCurrency: string;
};

export type EntityListOfCampaignDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: CampaignDto[];
};

export type CampaignDto = {
	name: string;
	code: string;
	description: string;
	currency?: CurrencyCode | null;
	startDate?: string | null;
	endDate?: string | null;
	url: string;
	receiverUserID: number;
	header?: string | null;
	linkName?: string | null;
	linkUrl?: string | null;
	successfulPaymentText?: string | null;
	color?: string | null;
	paymentInstructionsText?: string | null;
	onlyWithMooneText?: string | null;
	logoFileName?: string | null;
	landingImageFileName?: string | null;
	thankYouImageFileName?: string | null;
	iconFileName?: string | null;
};

export type EntityListOfCampaignUserDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: CampaignUserDto[];
};

export type CampaignUserDto = {
	dateCreated: string;
	dateUpdated?: string | null;
	status: LeadStatus;
};

export type ErrorWebLogCommand = {
	dateCreated: string;
	webLogRequests: WebLogRequest[];
};

export type WebLogRequest = {
	dateCreated: string;
	error: string;
	additionalInfo?: string | null;
	reduxState?: string | null;
};

export type MerchantDetailDto = {
	publicID: string;
	status: MerchantStatus;
	note?: string | null;
	fees: MerchantFeeDto[];
	facilities: MerchantFacilityDto[];
	party: PartyDto;
	merchantUserLogin?: string | null;
	licenseShares: MerchantLicenseShareDto[];
	merchantUserID?: number | null;
	merchantIdentityUserPublicID?: string | null;
	merchantProfilePicture?: string | null;
};

export type MerchantFeeDto = {
	publicID: string;
	productCode?: ProductCode | null;
	hunterLicenseDirectFee?: number | null;
	shareAmount?: number | null;
	merchantPricingID?: number | null;
};

export type MerchantFacilityDto = {
	publicID: string;
	name: string;
	responsiblePerson: string;
	providedServices?: string | null;
	phone: PhoneNumber;
	email?: string | null;
	openSince?: string | null;
	address?: AddressDto | null;
	yearlyTurnover?: number | null;
	estimatedTurnover?: number | null;
	realCardTurnover?: number | null;
	averageTransactionValue?: number | null;
	turnoverCurrencyCode: CurrencyCode;
	isPublic: boolean;
	description?: string | null;
	categoryCodes: string[];
	hours: MerchantFacilityHoursDto[];
	specialHours: MerchantFacilitySpecialHoursDto[];
	hasPhotoOutside: boolean;
	hasPhotoInside: boolean;
	logoFileName?: string | null;
	terminalCount?: number | null;
	softPosCount?: number | null;
};

export type MerchantFacilityHoursDto = {
	weekday: number;
	openTime?: string | null;
	closeTime?: string | null;
	isClosedAllDay: boolean;
	isOpenAllDay: boolean;
};

export type MerchantFacilitySpecialHoursDto = {
	date: string;
	openTime?: string | null;
	closeTime?: string | null;
	isClosedAllDay: boolean;
	isOpenAllDay: boolean;
};

export type MerchantLicenseShareDto = {
	licensePublicID: string;
	licenseNumber: string;
	holderName: string;
	sharePercentage: number;
	isPrimary: boolean;
};

export type CreateMerchantRequest = {
	publicPartyID: string;
	licensePublicID: string;
	partyLicenseFees?: { [key: string | number]: number } | null;
};

export enum MerchantViewMode {
	Default = "Default",
	HunterView = "HunterView"
};

export enum SortDirection {
	Ascending = "Ascending",
	Descending = "Descending"
};

export type MerchantStatsDto = {
	openRegistrations: number;
	invitationsSent: number;
	inOnboarding: number;
	completed: number;
};

export type MerchantBaseDto = {
	publicID: string;
	status: MerchantStatus;
};

export type HunterAvailableTerminalsDto = {
	availableCount: number;
	hasAvailableTerminals: boolean;
};

export type UpdateMerchantFeeDto = {
	publicID: string;
	productCode?: ProductCode | null;
	merchantPricingID: number;
};

export type CreateMerchantFeeDto = {
	productCode?: ProductCode | null;
	hunterLicenseDirectFee: number;
	merchantPricingID: number;
};

export type CreateMerchantFacilityDto = {
	name: string;
	responsiblePerson: string;
	providedServices?: string | null;
	phone: PhoneNumber;
	email?: string | null;
	openSince?: string | null;
	address?: AddressDto | null;
	yearlyTurnover?: number | null;
	estimatedTurnover?: number | null;
	realCardTurnover?: number | null;
	averageTransactionValue?: number | null;
	isPublic?: boolean | null;
	description?: string | null;
	categoryCodes?: string[] | null;
	hours?: MerchantFacilityHoursDto[] | null;
	specialHours?: MerchantFacilitySpecialHoursDto[] | null;
	terminalCount?: number | null;
	softPosCount?: number | null;
};

export type FacilityPhotosDto = {
	photoOutside?: string | null;
	photoOutsideExtension?: string | null;
	photoInside?: string | null;
	photoInsideExtension?: string | null;
};

export enum FacilityPhotoType {
	Outside = "Outside",
	Inside = "Inside"
};

export type SendMerchantAccessRequest = {
	login: string;
};

export type MerchantTerminalContractDto = {
	publicID: string;
	type: MerchantTerminalContractType;
	merchantPublicID: string;
	ucbTerminalContractDetail?: UCBTerminalContractDetailDto | null;
	comgateTerminalContractDetail?: ComgateTerminalContractDetailDto | null;
};

export type UCBTerminalContractDetailDto = {
	gprsCount?: number | null;
	softPosCount?: number | null;
};

export type ComgateTerminalContractDetailDto = {
	terminalCount: number;
	currencies: string;
	tariff?: string | null;
	payoutIBAN?: string | null;
	payoutBIC?: string | null;
	payoutCurrency?: string | null;
	payoutAccountNumber?: string | null;
	comgateMID?: string | null;
	comgateStatus?: ComgateOnboardingStatus | null;
	contractAccepted: boolean;
	handoverConfirmed: boolean;
	softPosCount: number;
};

export enum ComgateOnboardingStatus {
	REQUESTED = "REQUESTED",
	REJECTED = "REJECTED",
	PROCESSING = "PROCESSING",
	WAITING_FOR_DOCUMENTS = "WAITING_FOR_DOCUMENTS",
	WAITING_FOR_AUTHORIZATION_PAYMENT = "WAITING_FOR_AUTHORIZATION_PAYMENT",
	ERRORS_IN_DOCUMENTS = "ERRORS_IN_DOCUMENTS",
	ERROR_ACTION_PENDING = "ERROR_ACTION_PENDING",
	ASSOCIATION_REGISTERING = "ASSOCIATION_REGISTERING",
	READY = "READY"
};

export type CreateMerchantTerminalContractDto = {
	type: MerchantTerminalContractType;
	ucbTerminalContractDetail?: UCBTerminalContractDetailDto | null;
	comgateTerminalContractDetail?: ComgateTerminalContractDetailDto | null;
};

export type EntityListOfMerchantTerminalContractBase = {
	offset: number;
	limit: number;
	totalCount: number;
	items: MerchantTerminalContractBase[];
};

export type MerchantTerminalContractBase = {
	publicID: string;
	merchantPublicID: string;
	type: MerchantTerminalContractType;
};

export type UpdateMerchantTerminalContractCommandResult = {
	type: MerchantTerminalContractType;
	ucbTerminalContractDetail?: UCBTerminalContractDetailDto | null;
	comgateTerminalContractDetail?: ComgateTerminalContractDetailDto | null;
};

export type UpdateMerchantTerminalContractCommandRequest = {
	type: MerchantTerminalContractType;
	ucbTerminalContractDetail?: UCBTerminalContractDetailDto | null;
	comgateTerminalContractDetail?: ComgateTerminalContractDetailDto | null;
};

export type SubmitComgateOnboardingResult = {
	mid: string;
	status: string;
	verificationPaymentData?: string | null;
};

export type OrbitLStatusDto = {
	phase: OrbitLPhase;
	checklist: OrbitLChecklistDto;
	isSelfEmployed: boolean;
	comgateMID?: string | null;
	comgateStatus?: ComgateOnboardingStatus | null;
	contractDownloadedAt?: string | null;
	paymentServicesDownloadedAt?: string | null;
	contractAcceptedAt?: string | null;
	handoverConfirmedAt?: string | null;
	lastStatusCheckAt?: string | null;
	verificationPaymentData?: string | null;
	merchantTerminalData?: string | null;
	rejectionGroups?: RejectionGroupDto[] | null;
	financingModel: TerminalFinancingModel;
	isTerminalCountLocked: boolean;
	openTerminalCountRequest?: TerminalCountChangeRequestDto | null;
	isLoanContractRequired: boolean;
	physicalTerminalPricing?: DevicePricingDto | null;
	softPosPricing?: DevicePricingDto | null;
};

export enum OrbitLPhase {
	RequiresCompletion = "RequiresCompletion",
	ReadyToDownloadContract = "ReadyToDownloadContract",
	ContractDownloaded = "ContractDownloaded",
	SubmittedToComgate = "SubmittedToComgate",
	ProcessingByComgate = "ProcessingByComgate",
	TerminalDispatched = "TerminalDispatched",
	Completed = "Completed"
};

export type OrbitLChecklistDto = {
	isComplete: boolean;
	basicInfo: ChecklistItemDto;
	facilityInfo: ChecklistItemDto;
	appProductActive: ChecklistItemDto;
	bankAccountInfo: ChecklistItemDto;
	executiveInfo: ChecklistItemDto;
	executiveDocuments: ChecklistItemDto;
	terminalAssignment: ChecklistItemDto;
	primaryBankAccountEnvironment?: BankEnvironment | null;
};

export type ChecklistItemDto = {
	isValid: boolean;
	validationMessage?: string | null;
	issues?: OrbitLChecklistIssue[] | null;
	personIssues?: ChecklistPersonIssuesDto[] | null;
};

export enum OrbitLChecklistIssue {
	MissingExecutive = "MissingExecutive",
	PrimaryBankAccount = "PrimaryBankAccount",
	BankVerificationAudit = "BankVerificationAudit",
	BirthDate = "BirthDate",
	Email = "Email",
	Phone = "Phone",
	PermanentAddress = "PermanentAddress",
	PermanentAddressStreet = "PermanentAddressStreet",
	PermanentAddressMunicipality = "PermanentAddressMunicipality",
	PermanentAddressPostalCode = "PermanentAddressPostalCode",
	Documents = "Documents",
	FirstDocumentNumber = "FirstDocumentNumber",
	FirstDocumentValidity = "FirstDocumentValidity",
	FirstDocumentPhotos = "FirstDocumentPhotos",
	SecondDocumentNumber = "SecondDocumentNumber",
	SecondDocumentValidity = "SecondDocumentValidity",
	SecondDocumentPhotos = "SecondDocumentPhotos"
};

export type ChecklistPersonIssuesDto = {
	partyPublicID: string;
	displayName: string;
	missingFields: OrbitLChecklistIssue[];
};

export type RejectionGroupDto = {
	partyPublicID?: string | null;
	displayName?: string | null;
	documents: RejectionDocumentDto[];
};

export type RejectionDocumentDto = {
	documentType?: string | null;
	documentNumber?: string | null;
	messages: string[];
};

export type TerminalCountChangeRequestDto = {
	requestGroupID: string;
	requestedAt: string;
	note?: string | null;
	requestedBy?: string | null;
	oldTotal: number;
	newTotal: number;
	facilities: TerminalCountChangeRecordDto[];
	oldSoftPosTotal?: number | null;
	newSoftPosTotal?: number | null;
};

export type TerminalCountChangeRecordDto = {
	recordID: number;
	requestGroupID?: string | null;
	merchantFacilityPublicID?: string | null;
	facilityName?: string | null;
	oldCount: number;
	newCount: number;
	note?: string | null;
	resolutionNote?: string | null;
	source: TerminalCountChangeSource;
	status: TerminalCountChangeStatus;
	changedAt: string;
	changedBy?: string | null;
	resolvedAt?: string | null;
	oldSoftPosCount?: number | null;
	requestedSoftPosCount?: number | null;
};

export enum TerminalCountChangeSource {
	MerchantSelfService = "MerchantSelfService",
	Admin = "Admin",
	InitialOrder = "InitialOrder"
};

export enum TerminalCountChangeStatus {
	Applied = "Applied",
	Pending = "Pending",
	Resolved = "Resolved",
	Dismissed = "Dismissed"
};

export type DevicePricingDto = {
	merchantPricingID: number;
	productName: string;
	totalFee: number;
	hunterLicenseDirectFee: number;
};

export enum OrbitLContractType {
	Loan = "Loan",
	PaymentServices = "PaymentServices"
};

export type SubmitOrbitLOrderResult = {
	mid: string;
	status: string;
	verificationPaymentData?: string | null;
	kycPackageId: string;
};

export type ConfirmOrbitLHandoverResult = {
	confirmedAt: string;
};

export type HunterTerminalsForReservationResult = {
	totalRequiredCount: number;
	alreadyAssignedCount: number;
	terminals: HunterTerminalDto[];
	assignedTerminals: HunterTerminalDto[];
};

export type HunterTerminalDto = {
	publicID: string;
	serialNumber: string;
	hardwareModel?: string | null;
};

export type ReserveTerminalsResult = {
	reservedCount: number;
	reservedTerminalPublicIDs: string[];
};

export type ReserveTerminalsRequest = {
	facilityPublicID?: string | null;
	terminalPublicIDs?: string[] | null;
	terminalCount?: number | null;
	softPosCount?: number | null;
};

export type RequestTerminalCountChangeDto = {
	facilities: TerminalCountChangeRequestFacilityDto[];
	note?: string | null;
};

export type TerminalCountChangeRequestFacilityDto = {
	merchantFacilityPublicID: string;
	requestedCount: number;
	requestedSoftPosCount?: number | null;
};

export type ResolveTerminalCountChangeRequestDto = {
	isDismissed: boolean;
	note?: string | null;
};

export type EntityListOfOrbitLOnboardingListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: OrbitLOnboardingListItemDto[];
};

export type OrbitLOnboardingListItemDto = {
	merchantPublicID: string;
	companyName?: string | null;
	companyNumber?: string | null;
	hunterName?: string | null;
	orbitLActivatedAt: string;
	orbitLPhase: OrbitLPhase;
	comgateStatus?: ComgateOnboardingStatus | null;
	comgateMID?: string | null;
	lastStatusCheckAt?: string | null;
	submittedToComgateAt?: string | null;
	financingModel?: TerminalFinancingModel | null;
	lastStatusChangeAt: string;
	contractedTerminalCount: number;
	requestedTerminalCount?: number | null;
};

export type OrbitLOnboardingActionRequiredCountResult = {
	actionRequiredCount: number;
};

export type OrbitLOnboardingDetailDto = {
	status: OrbitLStatusDto;
	facilityTerminals: FacilityTerminalDto[];
	contractedTerminalCount: number;
	contractedSoftPosCount: number;
	terminalCountHistory: TerminalCountChangeRecordDto[];
	tids: ComgateTerminalTidDto[];
};

export type FacilityTerminalDto = {
	facilityName?: string | null;
	facilityAddress?: string | null;
	terminals: TerminalItemDto[];
};

export type TerminalItemDto = {
	publicID: string;
	serialNumber?: string | null;
	hardwareModel?: string | null;
	tid?: string | null;
	status: TerminalInventoryStatus;
	financing: TerminalFinancing;
	isSwappable: boolean;
};

export enum TerminalInventoryStatus {
	InStock = "InStock",
	AssignedToHunter = "AssignedToHunter",
	AssignedToMerchant = "AssignedToMerchant",
	Shipped = "Shipped",
	WithMerchant = "WithMerchant",
	Deployed = "Deployed",
	Returned = "Returned"
};

export type ComgateTerminalTidDto = {
	tid: string;
	storeName?: string | null;
	facilityName?: string | null;
	terminalType?: TerminalType | null;
	isTypeManual: boolean;
	isRegistered: boolean;
	activationCode?: string | null;
};

export type ComgateCommentDto = {
	commentText: string;
	author: string;
	commentDate: string;
};

export type SendComgateCommentRequest = {
	commentText: string;
};

export type SetComgateTerminalTidTypesRequest = {
	tids: ComgateTerminalTidTypeEntry[];
};

export type ComgateTerminalTidTypeEntry = {
	tid: string;
	terminalType: TerminalType;
};

export type TmsRegistrationOutcome = {
	registeredCount: number;
	reportedTidCount: number;
	expectedCount: number;
	unknownTidCount: number;
	registeredTids: string[];
	failedTids: { [key: string | number]: string };
	isComplete: boolean;
};

export type TerminalActivationCodeDto = {
	tid?: string | null;
	terminalType?: TerminalType | null;
	activationCode?: string | null;
};

export type SwapOrbitLTerminalResult = {
	newTerminalPublicID: string;
	newSerialNumber: string;
	newHardwareModel?: string | null;
	activationCode?: string | null;
};

export type SwapOrbitLTerminalRequest = {
	oldTerminalPublicID: string;
	newSerialNumber: string;
};

export type AvailableTerminalDto = {
	publicID: string;
	serialNumber: string;
	hardwareModel?: string | null;
};

export type OrbitLTerminalSearchResultDto = {
	tid?: string | null;
	serialNumber?: string | null;
	hardwareModel?: string | null;
	merchantPublicID: string;
	companyName?: string | null;
	companyNumber?: string | null;
};

export type MerchantPricingDto = {
	merchantPricingID: number;
	code?: ProductCode | null;
	productName: string;
	hunterLicenseDirectFee: number;
	totalFee: number;
	merchantPricingVariant?: MerchantPricingVariant | null;
	assignedCount: number;
};

export type MerchantAppProductDto = {
	merchantPublicID: string;
	productDto: ProductDto;
};

export type AddMerchantAppProductRequest = {
	tariff?: OrbitLTariff | null;
	financingModel?: TerminalFinancingModel | null;
};

export enum OrbitLTariff {
	POS_1_CZ = "POS_1_CZ",
	POS_2_CZ = "POS_2_CZ",
	POS_3_CZ = "POS_3_CZ",
	POS_4_CZ = "POS_4_CZ"
};

export type EmployeeDto = {
	publicID: string;
	partyPublicID: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: PhoneNumber;
	status: EmployeeStatus;
};

export type CreateEmployeeRequest = {
	publicPartyID: string;
};

export type EntityListOfEmployeeDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: EmployeeDto[];
};

export type EntityListOfFacilityWithMerchantDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: FacilityWithMerchantDto[];
};

export type FacilityWithMerchantDto = {
	publicID: string;
	name: string;
	providedServices?: string | null;
	responsiblePerson: string;
	phone: PhoneNumber;
	email?: string | null;
	openSince?: string | null;
	address?: AddressDto | null;
	yearlyTurnover?: number | null;
	estimatedTurnover?: number | null;
	realCardTurnover?: number | null;
	averageTransactionValue?: number | null;
	turnoverCurrencyCode: CurrencyCode;
	merchantName: string;
	isPublic: boolean;
	description?: string | null;
	categories: CategoryDto[];
};

export type CategoryDto = {
	merchantFacilityCategoryID: number;
	code: string;
	name: string;
};

export type FacilityDetailDto = {
	publicID: string;
	name: string;
	providedServices?: string | null;
	responsiblePerson: string;
	phone: PhoneNumber;
	email?: string | null;
	openSince?: string | null;
	address?: AddressDto | null;
	yearlyTurnover?: number | null;
	estimatedTurnover?: number | null;
	realCardTurnover?: number | null;
	averageTransactionValue?: number | null;
	turnoverCurrencyCode: CurrencyCode;
	merchantName: string;
	isPublic: boolean;
	description?: string | null;
	categories: CategoryDto[];
	hours: FacilityHoursDto[];
	specialHours: FacilitySpecialHoursDto[];
};

export type FacilityHoursDto = {
	weekday: number;
	openTime?: string | null;
	closeTime?: string | null;
	isOpenAllDay: boolean;
	isClosedAllDay: boolean;
};

export type FacilitySpecialHoursDto = {
	date: string;
	openTime?: string | null;
	closeTime?: string | null;
	isClosedAllDay: boolean;
	isOpenAllDay: boolean;
};

export type EntityListOfMunicipalityDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: MunicipalityDto[];
};

export type MunicipalityDto = {
	name: string;
	facilityCount: number;
};

export type UpdateEmployeeRequest = {
	firstName: string;
	lastName: string;
	email: string;
	phone: PhoneNumber;
};

export type SendEmployeeAccessRequest = {
	login: string;
};

export type NFCCardData = {
	publicID: string;
	type: NFCCardType;
	redirectUrl?: string | null;
};

export enum NFCCardType {
	StandardPayPoint = "StandardPayPoint",
	FixedCollectorPayPoint = "FixedCollectorPayPoint",
	VariableCollectorPayPoint = "VariableCollectorPayPoint",
	GiftCard = "GiftCard",
	RedirectPayPoint = "RedirectPayPoint"
};

export type UserNotificationSettingsDto = {
	isFilledOrderNotificationActive: boolean;
	isCreatedOrderNotificationActive: boolean;
	isWithdrawalNotificationActive: boolean;
};

export type SaveUserNotificationSettingsCommandResult = {
	status: SaveUserNotificationSettingsCommandResultStatus;
};

export enum SaveUserNotificationSettingsCommandResultStatus {
	Success = "Success"
};

export type PagedNotificationResult = {
	items: UserNotificationDto[];
	totalCount: number;
	page: number;
	pageSize: number;
};

export type UserNotificationDto = {
	publicID: string;
	notificationPublicID: string;
	title: string;
	content: string;
	variant: NotificationVariant;
	seenAt?: string | null;
	dateCreated: string;
	scheduledDate: string;
	link?: string | null;
};

export enum NotificationVariant {
	Announcement = "Announcement",
	Completed = "Completed",
	Error = "Error",
	Critical = "Critical",
	Stardust = "Stardust",
	Raffle = "Raffle"
};

export type UnreadCountDto = {
	count: number;
};

export type NotificationDto = {
	publicID: string;
	title: string;
	content: string;
	variant: NotificationVariant;
	scheduledDate: string;
	expirationDate?: string | null;
	dispatchedAt?: string | null;
	dateCreated: string;
	status: NotificationStatus;
};

export enum NotificationStatus {
	Planned = "Planned",
	Dispatched = "Dispatched",
	Deleted = "Deleted"
};

export type CreateNotificationRequest = {
	title: string;
	content: string;
	variant: NotificationVariant;
	scheduledDate: string;
	expirationDate?: string | null;
};

export type UpdateNotificationRequest = {
	title: string;
	content: string;
	variant: NotificationVariant;
	scheduledDate: string;
	expirationDate?: string | null;
};

export type GetRateQueryResult = {
	fiatCurrencyCode: string;
	cryptoCurrencyCode: string;
	askRate: number;
	bidRate: number;
	dateExecuted: string;
};

export type GetRateQuery = {
	fiatCurrencyCode: string;
	cryptoCurrencyCode: string;
	useCache: boolean;
};

export type GetRateHistoryQueryResult = {
	items: EntityListOfCurrencyRateDto;
};

export type EntityListOfCurrencyRateDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: CurrencyRateDto[];
};

export type CurrencyRateDto = {
	dateCreated: string;
	askCurrencyCode: string;
	bidCurrencyCode: string;
	ask: number;
	bid: number;
};

export type SetHandleCommandResult = {
	handle: string;
};

export type SetHandleRequest = {
	handle: string;
	acceptSocialTerms: boolean;
};

export type SetProfileVisibilityResult = {
	isProfilePublic: boolean;
};

export type SetProfileVisibilityRequest = {
	isPublic: boolean;
};

export type SetBioResult = {
	bio?: string | null;
};

export type SetBioRequest = {
	bio?: string | null;
};

export type HandleAvailabilityDto = {
	isAvailable: boolean;
	normalizedHandle: string;
};

export type SocialUserSearchDto = {
	identityUserPublicID: string;
	handle?: string | null;
	displayName?: string | null;
	companyName?: string | null;
	accessRoleCode?: string | null;
	isFullMoone: boolean;
	profilePicture?: string | null;
};

export type PublicProfileDto = {
	identityUserPublicID: string;
	handle?: string | null;
	isPublic: boolean;
	profilePicture?: string | null;
	displayName?: string | null;
	bio?: string | null;
	isIdentityVerified: boolean;
	accessRoleCode?: string | null;
	isFullMoone: boolean;
	mutualFollowCount?: number | null;
	followerCount?: number | null;
	followedCount?: number | null;
};

export type EntityListOfSocialUserSummary = {
	offset: number;
	limit: number;
	totalCount: number;
	items: SocialUserSummary[];
};

export type SocialUserSummary = {
	identityUserPublicID: string;
	handle?: string | null;
	displayName?: string | null;
	companyName?: string | null;
	accessRoleCode?: string | null;
	isFullMoone: boolean;
	profilePicture?: string | null;
};

export type DisclosedNameDto = {
	identityUserPublicID: string;
	handle?: string | null;
	displayName: string;
};

export type FollowRequestDto = {
	requestedAt: string;
	isFollowedByCaller: boolean;
	user: SocialUserSummary;
};

export enum FollowRequestDirection {
	Incoming = "Incoming",
	Outgoing = "Outgoing"
};

export type FollowRequestCountDto = {
	pendingIncomingCount: number;
};

export type FollowRequestSummaryDto = {
	pendingIncomingCount: number;
	mutualOnApprovalCount: number;
};

export type ApproveFollowRequestResult = {
	isMutual: boolean;
};

export type FollowUserResult = {
	isRequested: boolean;
	isMutual: boolean;
};

export type FollowUserRequest = {
	targetIdentityUserPublicID: string;
};

export type EntityListOfFollowerDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: FollowerDto[];
};

export type FollowerDto = {
	isFollowedByCaller: boolean;
	hasOutgoingRequest: boolean;
	requiresFollowApproval: boolean;
	user: SocialUserSummary;
};

export type BlockUserRequest = {
	targetIdentityUserPublicID: string;
};

export type SocialRelationshipDto = {
	isFollowed: boolean;
	isFollowedBy: boolean;
	isMutual: boolean;
	hasOutgoingRequest: boolean;
	hasIncomingRequest: boolean;
	canFollow: boolean;
	requiresFollowApproval: boolean;
	isSelf: boolean;
	isBlocked: boolean;
};

export type GetStoriesTokenQueryResult = {
	token: string;
	userId: string;
	userName: string;
	apiKey: string;
};

export type GetStoryPostUsageQueryResult = {
	limit: number;
	used: number;
};

export type EntityListOfStoryListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: StoryListItemDto[];
};

export type StoryListItemDto = {
	publicID: string;
	authorPublicID: string;
	authorName: string;
	authorAccessRoleCode: string;
	text?: string | null;
	imageUrl?: string | null;
	videoUrl?: string | null;
	state: StoryState;
	dateCreated: string;
	lastPublishedAt?: string | null;
	expiresAt?: string | null;
	publicationCount: number;
};

export enum StoryState {
	Draft = "Draft",
	Live = "Live",
	Expired = "Expired",
	Unpublished = "Unpublished"
};

export type StoryDetailDto = {
	summary: StoryListItemDto;
	buttonLabel?: string | null;
	buttonUrl?: string | null;
	sheetTitle?: string | null;
	sheetDescription?: string | null;
	sheetPrice?: string | null;
	sheetPriceNote?: string | null;
	sheetImageUrl?: string | null;
};

export type CreateStoryCommandResult = {
	publicID: string;
};

export type CreateStoryRequest = {
	story: StorySaveRequest;
	publish: boolean;
};

export type StorySaveRequest = {
	imageUrl?: string | null;
	videoUrl?: string | null;
	text?: string | null;
	buttonLabel?: string | null;
	buttonUrl?: string | null;
	sheetTitle?: string | null;
	sheetDescription?: string | null;
	sheetPrice?: string | null;
	sheetPriceNote?: string | null;
	sheetImageUrl?: string | null;
};

export type UploadStoryMediaCommandResult = {
	url: string;
};

export type CreateSupportRequestResult = {
	ticketNumber?: number | null;
};

export type CreateContentReportResult = {
	referenceNumber?: number | null;
};

export type CreateContentReportRequest = {
	contentType: ContentReportType;
	category: ContentReportCategory;
	explanation: string;
	isBonaFideConfirmed: boolean;
	name?: string | null;
	email?: string | null;
	profileIdentityUserPublicID?: string | null;
	profileHandle?: string | null;
	channelId?: string | null;
	messageId?: string | null;
	contentUrl?: string | null;
	appVersion?: string | null;
	buildNumber?: string | null;
	language?: string | null;
};

export enum ContentReportType {
	Profile = "Profile",
	ChatMessage = "ChatMessage"
};

export enum ContentReportCategory {
	ChildSexualAbuse = "ChildSexualAbuse",
	ThreatsOrViolence = "ThreatsOrViolence",
	HateSpeech = "HateSpeech",
	FraudOrScam = "FraudOrScam",
	Impersonation = "Impersonation",
	PersonalDataOrPrivacy = "PersonalDataOrPrivacy",
	IntellectualProperty = "IntellectualProperty",
	OtherIllegal = "OtherIllegal",
	HarassmentOrBullying = "HarassmentOrBullying",
	SpamOrUnwantedContact = "SpamOrUnwantedContact",
	OtherTermsViolation = "OtherTermsViolation"
};

export type GetSystemSettingQuery = {
	systemSettingType: SystemSettingType;
};

export type SaveSystemSettingCommandResult = {
	status: SaveSystemSettingCommandResultStatus;
};

export enum SaveSystemSettingCommandResultStatus {
	Success = "Success"
};

export type SaveSystemSettingCommand = {
	type: SystemSettingType;
	value: string;
};

export type TerminalInventoryItemDto = {
	publicID: string;
	serialNumber: string;
	status: string;
	financing: string;
	hardwareModel?: string | null;
	hunterPartyID?: number | null;
	merchantID?: number | null;
	merchantFacilityID?: number | null;
	terminalRegistrationID?: number | null;
	purchasePrice?: number | null;
	merchantName?: string | null;
	orbitLPhase?: string | null;
	comgateMID?: string | null;
	comgateStatus?: string | null;
	comgateRejectedMessages?: string | null;
	purchasePriceCurrencyCode?: CurrencyCode | null;
};

export type AddTerminalInventoryItemCommand = {
	serialNumber: string;
	hardwareModel: string;
	purchasePrice?: number | null;
	purchasePriceCurrencyCode?: CurrencyCode | null;
	hunterPartyPublicID?: string | null;
	status: TerminalInventoryStatus;
};

export type AddTerminalInventoryItemsBulkResult = {
	addedCount: number;
	duplicateSerialNumbers: string[];
	failedEntries: BulkTerminalEntryError[];
};

export type BulkTerminalEntryError = {
	serialNumber: string;
	error: string;
};

export type AddTerminalInventoryItemsBulkCommand = {
	items: BulkTerminalEntry[];
};

export type BulkTerminalEntry = {
	serialNumber: string;
	hardwareModel?: string | null;
	purchasePrice?: number | null;
	purchasePriceCurrencyCode?: CurrencyCode | null;
	hunterPartyPublicID?: string | null;
};

export type EntityListOfTerminalInventoryListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: TerminalInventoryListItemDto[];
};

export type TerminalInventoryListItemDto = {
	publicID: string;
	serialNumber: string;
	hardwareModel?: string | null;
	status: TerminalInventoryStatus;
	financing: TerminalFinancing;
	tid?: string | null;
	comgateMid?: string | null;
	hunterPartyPublicID?: string | null;
	hunterName?: string | null;
	merchantPublicID?: string | null;
	merchantName?: string | null;
	facilityName?: string | null;
	purchasePrice?: number | null;
	purchasePriceCurrencyCode?: CurrencyCode | null;
	lastChangedAt: string;
};

export type TerminalAuditRecordDto = {
	recordID: number;
	field: string;
	oldValue?: string | null;
	newValue?: string | null;
	changedAt: string;
	changedBy?: string | null;
};

export type UpdateTerminalInventoryItemRequest = {
	hardwareModel: string;
	purchasePrice?: number | null;
	purchasePriceCurrencyCode?: CurrencyCode | null;
	hunterPartyPublicID?: string | null;
	status: TerminalInventoryStatus;
};

export type AssignTerminalToMerchantRequest = {
	merchantID: number;
	merchantFacilityID?: number | null;
};

export type TerminalPinResult = {
	pin?: string | null;
};

export type TerminalPinRegeneratedResult = {
	pin: string;
};

export type EntityListOfUserBankAccountListDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UserBankAccountListDto[];
};

export type UserBankAccountListDto = {
	userBankAccountID: number;
	userID: number;
	iban?: string | null;
	status: UserBankAccountStatus;
	externalID: string;
	formattedAccountNumber?: string | null;
};

export type EntityListOfUserDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UserDto[];
};

export type UserDto = {
	userID: number;
	login: string;
	party: PartyDto;
	isAdmin: boolean;
	roleCode?: string | null;
	status: UserStatus;
	dateCreated: string;
	verificationAdditionalInfoStatus: AdditionalInfoStatus;
	verificationIdentityVerificationStatus: IdentityVerificationStatus;
	verificationRiskProfile: RiskProfileStatus;
	verificationBankVerificationStatus: BankVerificationStatus;
	version?: Version | null;
	identityRoles: UserRoleGrantDto[];
};

export type UserRoleGrantDto = {
	accessRoleCode: string;
	status: IdentityUserStatus;
	partyCompanyName?: string | null;
};

export type EntityListOfHunterListDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: HunterListDto[];
};

export type HunterListDto = {
	userID: number;
	login: string;
	party: HunterListPartyDto;
	status: UserStatus;
	dateCreated: string;
	completedPrerequisitesCount: number;
	totalPrerequisitesCount: number;
	affiliatedToName?: string | null;
	affiliatedToEmail?: string | null;
};

export type HunterListPartyDto = {
	publicID: string;
	type: PartyType;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	email?: string | null;
	phone: PhoneNumber;
};

export type EntityListOfUserAwaitingVerificationDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UserAwaitingVerificationDto[];
};

export type UserAwaitingVerificationDto = {
	userID: number;
	login: string;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	companyNumber?: string | null;
	additionalInfoStatus?: AdditionalInfoStatus | null;
	riskProfile?: RiskProfileStatus | null;
	bankVerificationStatus?: BankVerificationStatus | null;
	identityVerificationStatus?: IdentityVerificationStatus | null;
	roleCode?: string | null;
	identityRoles: UserRoleGrantDto[];
};

export enum VerificationFilterType {
	UserVerification = "UserVerification",
	BankAccountVerification = "BankAccountVerification",
	IdentityVerification = "IdentityVerification"
};

export type UserAdminDetailDto = {
	userID: number;
	partyPublicID: string;
	login: string;
	status: UserStatus;
	verificationAdditionalInfoStatus: AdditionalInfoStatus;
	verificationRiskProfile: RiskProfileStatus;
	verificationIdentityVerificationStatus: IdentityVerificationStatus;
	verificationBankVerificationStatus: BankVerificationStatus;
	verificationVerificationJson?: string | null;
	verificationExternalID?: string | null;
	verificationBirthnumberSha256?: string | null;
	verificationDailyBuyLimit: number;
	verificationMonthlyBuyLimit: number;
	hasIdentificationsUploaded: boolean;
	accessRoleCode?: string | null;
	verifiedIBAN?: string | null;
	bankVerificationSource?: BankVerificationSource | null;
	bankVerificationDate?: string | null;
	identityRoles: UserIdentityRoleDto[];
	stardustParticipation?: ProgramParticipationDto | null;
	thanksToYouParticipation?: ProgramParticipationDto | null;
};

export type UserIdentityRoleDto = {
	accessRoleCode: string;
	status: IdentityUserStatus;
	partyPublicID?: string | null;
};

export type ProgramParticipationDto = {
	program: ProgramCode;
	state: ProgramParticipationState;
	changedAt?: string | null;
	source?: ProgramParticipationSource | null;
};

export enum ProgramCode {
	Stardust = "Stardust",
	ThanksToYou = "ThanksToYou"
};

export enum ProgramParticipationSource {
	Registration = "Registration",
	ProgramSection = "ProgramSection",
	ConsentDialog = "ConsentDialog"
};

export type HunterDetailDto = {
	userID: number;
	login: string;
	status: UserStatus;
	dateCreated: string;
	affiliatedToName?: string | null;
	affiliatedToEmail?: string | null;
	merchantStats?: HunterMerchantStatsDto | null;
	party?: HunterDetailPartyDto | null;
};

export type HunterMerchantStatsDto = {
	openRegistrations: number;
	invitationsSent: number;
	inOnboarding: number;
	activeMerchants: number;
};

export type HunterDetailPartyDto = {
	type: PartyType;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	companyNumber?: string | null;
	taxNumber?: string | null;
	birthDate?: string | null;
	email?: string | null;
	phone: PhoneNumber;
	licenses: HunterDetailLicenseDto[];
};

export type HunterDetailLicenseDto = {
	publicID: string;
	code: string;
	licenseNo?: string | null;
};

export type SaveUserAdminDetailCommandResult = {
	status: SaveUserAdminDetailCommandResultStatus;
};

export enum SaveUserAdminDetailCommandResultStatus {
	Success = "Success"
};

export type SetRiskProfileCommand = {
	targetUserID: number;
	riskProfile: RiskProfileStatus;
};

export type SetIdentityVerificationStatusCommand = {
	targetUserID: number;
	identityVerificationStatus: IdentityVerificationStatus;
};

export type DeactivateUserCommandResult = {
	status: DeactivateUserCommandResultStatus;
};

export enum DeactivateUserCommandResultStatus {
	Success = "Success"
};

export type UserSettingsDto = {
	isQuickPaymentEnabled: boolean;
	isBalanceVisible: boolean;
};

export type ChangePasswordRequest = {
	oldPassword: string;
	newPassword: string;
	newPasswordConfirm: string;
};

export type UpdateQuickPaymentEnabledRequest = {
	isEnabled: boolean;
};

export type UpdateBalanceVisibilityRequest = {
	isVisible: boolean;
};

export type HunterSearchDto = {
	partyPublicID: string;
	firstName?: string | null;
	lastName?: string | null;
	companyName?: string | null;
	licenseNo?: string | null;
	licensePublicID?: string | null;
	licensePaymentStatus?: LicensePaymentStatus | null;
	region?: Region | null;
};

export type UserVerificationDetailDto = {
	additionalInfoStatus: AdditionalInfoStatus;
	riskProfile: RiskProfileStatus;
	isPoliticallyExposedPerson: boolean;
	identityVerificationStatus: IdentityVerificationStatus;
	bankVerificationStatus: BankVerificationStatus;
	verificationLevel: number;
};

export type ProcessBankIDVerificationCommandResult = {
	status: ProcessBankIDVerificationCommandResultStatus;
	signInResult?: SignInResult | null;
};

export enum ProcessBankIDVerificationCommandResultStatus {
	BankIDUserInfoError = "BankIDUserInfoError",
	Success = "Success",
	Fail = "Fail",
	VerificationAlreadyExists = "VerificationAlreadyExists"
};

export type BankIDVerificationRequest = {
	token: string;
};

export type SetAdditionalInfoCommandResult = {
	verificationDetail: UserVerificationDetailDto;
};

export type SetAdditionalInfoRequest = {
	hasMoneyFromCriminalActivityOrIsFinancingTerrorism: boolean;
	hasConnectionToSanctionedCountry: boolean;
	isPoliticallyExposedPerson: boolean;
	sourcesOfIncome: SourceOfIncome[];
};

export type UploadIdentificationCommandResult = {
	status: UploadIdentificationCommandResultStatus;
};

export enum UploadIdentificationCommandResultStatus {
	Success = "Success",
	MissingFiles = "MissingFiles"
};

export type SetBankIdentificationInProgressCommandResult = {
	status: SetBankIdentificationInProgressCommandResultStatus;
	verificationDetail: UserVerificationDetailDto;
};

export enum SetBankIdentificationInProgressCommandResultStatus {
	Success = "Success"
};

export type UserVerificationDto = {
	publicID: string;
	userID: number;
	businessActivity?: BusinessActivity | null;
	otherBusinessActivityDetails?: string | null;
	sourcesOfIncome: SourceOfIncome[];
	otherSourceOfIncomeDetails?: string | null;
	uboUnknown: boolean;
	expectedMonthlyRevenue?: ExpectedMonthlyRevenue | null;
	averageTransactionValue?: AverageTransactionValue | null;
	taxResidency?: CountryCode | null;
	isPoliticallyExposedPerson: boolean;
	additionalInfoStatus: AdditionalInfoStatus;
	identityVerificationStatus: IdentityVerificationStatus;
	riskProfile: RiskProfileStatus;
	bankVerificationStatus: BankVerificationStatus;
	verifiedIBAN?: string | null;
	verificationLevel: number;
	hasNonEUNationality?: boolean | null;
	hasNonEUResidence?: boolean | null;
	legacySourceOfIncome?: string | null;
	documentExpirationDate?: string | null;
	secondDocumentExpirationDate?: string | null;
};

export type UserVerificationUpdateDto = {
	requestedUserID?: number | null;
	businessActivity?: BusinessActivity | null;
	otherBusinessActivityDetails?: string | null;
	sourcesOfIncome?: SourceOfIncome[] | null;
	otherSourceOfIncomeDetails?: string | null;
	expectedMonthlyRevenue?: ExpectedMonthlyRevenue | null;
	averageTransactionValue?: AverageTransactionValue | null;
	taxResidency?: CountryCode | null;
	isPoliticallyExposedPerson: boolean;
	hasNonEUNationality?: boolean | null;
	hasNonEUResidence?: boolean | null;
	uboUnknown?: boolean | null;
};

export type CardTransactionsAvailabilityResponse = {
	isAvailable: boolean;
};

export type EntityListOfCardTransactionItem = {
	offset: number;
	limit: number;
	totalCount: number;
	items: CardTransactionItem[];
};

export type CardTransactionItem = {
	publicID: string;
	occurredAt: string;
	payPointPublicID?: string | null;
	terminalDisplayName?: string | null;
	employeePublicID?: string | null;
	employeeDisplayName?: string | null;
	amount: number;
	currency: CurrencyCode;
	status: CardTransactionStatus;
	direction: CardTransactionDirection;
	isRefundOrCancellation: boolean;
	cardBrand?: string | null;
	truncatedPAN?: string | null;
};

export enum CardTransactionStatus {
	Unknown = "Unknown",
	Approved = "Approved",
	Rejected = "Rejected",
	Canceled = "Canceled",
	Pending = "Pending"
};

export enum CardTransactionDirection {
	Sale = "Sale",
	Refund = "Refund",
	Cancellation = "Cancellation",
	Adjustment = "Adjustment"
};

export type CardTransactionsSumResponse = {
	currencies: CardTransactionsCurrencySum[];
};

export type CardTransactionsCurrencySum = {
	currency: CurrencyCode;
	salesAmount: number;
	salesCount: number;
	refundAmount: number;
	refundCount: number;
	netAmount: number;
};

export enum TransactionExportFormat {
	Pdf = "Pdf",
	Email = "Email",
	Xlsx = "Xlsx",
	Csv = "Csv"
};

export type ExportCardTransactionsCommandResult = {
	bytes: string;
	emailSent: boolean;
};

export type ExportCardTransactionsRequest = {
	format: TransactionExportFormat;
	email?: string | null;
	dateFrom?: string | null;
	dateTo?: string | null;
	payPointPublicID?: string | null;
	employeePublicID?: string | null;
	status?: CardTransactionStatus | null;
	isRefundOrCancellation?: boolean | null;
};

export type InternalPayPointDto = {
	publicID: string;
	name?: string | null;
	description?: string | null;
	partyPublicID: string;
	nfcCardNo?: string | null;
	type: PayPointType;
	externalID?: string | null;
	productID?: number | null;
	productCode?: ProductCode | null;
	facilityPublicID?: string | null;
	bankAccountPublicID?: string | null;
	employeePublicIDs: string[];
	settings: PayPointSettingsDto;
	hasActiveDevice: boolean;
	requiresPin: boolean;
};

export type PayPointSettingsDto = {
	mode: PayPointMode;
	predefinedAmount?: number | null;
	predefinedAmountCurrencyCode?: CurrencyCode | null;
	tipsEnabled: boolean;
	redirectUrl?: string | null;
};

export type CreateInternalPayPointRequest = {
	name?: string | null;
	description?: string | null;
	externalID?: string | null;
	nfcCardNo?: string | null;
	type: PayPointType;
	productID?: number | null;
	facilityPublicID?: string | null;
	bankAccountPublicID?: string | null;
	employeePublicIDs: string[];
	settings?: PayPointSettingsDto | null;
};

export type UpdateInternalPayPointRequest = {
	publicID: string;
	name?: string | null;
	description?: string | null;
	nfcCardNo?: string | null;
	type: PayPointType;
	facilityPublicID?: string | null;
	bankAccountPublicID?: string | null;
	employeePublicIDs: string[];
	settings?: PayPointSettingsDto | null;
};

export type PayPointBaseDto = {
	publicID: string;
	name?: string | null;
	description?: string | null;
	partyPublicID: string;
	nfcCardNo?: string | null;
	type: PayPointType;
	externalID?: string | null;
	productID?: number | null;
	productCode?: ProductCode | null;
	hasConnectedAccount?: boolean | null;
	mode: PayPointMode;
	hasActiveDevice: boolean;
	requiresPin: boolean;
};

export type AssignPayPointRequest = {
	nfcCardNo: string;
};

export type EntityListOfPayPointBaseDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: PayPointBaseDto[];
};

export type TransactionDetailDto = {
	publicID: string;
	creditorID: number;
	debtorID?: number | null;
	amount: number;
	tipAmount: number;
	currencyCode: string;
	creditorIBAN: string;
	debtorIBAN: string;
	transactionStatus: TransactionStatus;
	paymentReference?: string | null;
	noteForDebtor?: string | null;
	payPointPublicID?: string | null;
	signingUrl?: string | null;
	creditorName?: string | null;
	payPointMode?: PayPointMode | null;
	payPointTipsEnabled: boolean;
	payPointPredefinedAmount?: number | null;
	payPointPredefinedAmountCurrencyCode?: CurrencyCode | null;
	merchantIdentityUserPublicID?: string | null;
	merchantProfilePicture?: string | null;
	expirationDate?: string | null;
	failureReason: PaymentErrorCode;
	isRefund: boolean;
	relatedTransactionStatus?: TransactionStatus | null;
};

export type PayPointOwnerDto = {
	name?: string | null;
	logoUrl?: string | null;
	merchantIdentityUserPublicID?: string | null;
	merchantProfilePicture?: string | null;
	affiliateCode?: string | null;
};

export type PayPointScanViewDto = {
	publicID: string;
	name?: string | null;
	mode: PayPointMode;
	predefinedAmount?: number | null;
	predefinedAmountCurrencyCode?: CurrencyCode | null;
	tipsEnabled: boolean;
};

export type StartPayPointTransactionResponse = {
	transactionPublicID: string;
	redirectUrl: string;
};

export type StartPayPointTransactionRequest = {
	amount?: number | null;
	tipAmount: number;
};

export type PayPointCredentialDto = {
	publicID?: string | null;
	name?: string | null;
	lastUsedAt?: string | null;
};

export type GatewayCredentialSecretResult = {
	clientID: string;
	clientSecret: string;
};

export type GetSettlementPoolBoostsQueryResult = {
	boosts: SettlementPoolBoostDto[];
};

export type SettlementPoolBoostDto = {
	settlementPoolBoostID: number;
	settlementPeriodID: number;
	region: Region;
	loyaltyPointType: LoyaltyPointType;
	boostAmount: AmountDto;
	hunterPoolRatioPercent?: number | null;
	valorPoolRatioPercent?: number | null;
};

export type AmountDto = {
	value: number;
	currencyCode: CurrencyCode;
};

export type GetCurrentMonthlyPoolTotalQueryResult = {
	poolTotal: Amount;
	hunterPoolRatioPercent?: number | null;
	valorPoolRatioPercent?: number | null;
};

export type UpdateSettlementPoolBoostCommandResult = {
	settlementPoolBoostID: number;
};

export type UpdateSettlementPoolBoostRequest = {
	boostAmount: number;
	hunterPoolRatioPercent?: number | null;
	valorPoolRatioPercent?: number | null;
};

export type GetSettlementsQueryResult = {
	settlements: SettlementDto[];
	summary: SettlementSummary;
};

export type SettlementDto = {
	settlementID: number;
	amount: number;
	region: Region;
	currencyCode: CurrencyCode;
	settlementDate?: string | null;
	dueDate?: string | null;
	settlementPeriodID?: number | null;
	isPaid: boolean;
	settlementStatus: SettlementStatus;
	type: PartyRecordSettlementType;
	invoiceNumber?: number | null;
	transaction?: SettlementTransactionDto | null;
};

export type SettlementTransactionDto = {
	publicID: string;
	amount: number;
	currencyCode: string;
	receiverIBAN?: string | null;
	receiverBankAccount?: string | null;
	paymentReference?: string | null;
	noteForDebtor?: string | null;
};

export type SettlementSummary = {
	total: number;
	paid: number;
	unpaid: number;
	overdue: number;
};

export enum SettlementFilter {
	All = "All",
	Paid = "Paid",
	Unpaid = "Unpaid",
	Overdue = "Overdue"
};

export enum SettlementSortBy {
	DateDesc = "DateDesc",
	DateAsc = "DateAsc",
	AmountDesc = "AmountDesc",
	AmountAsc = "AmountAsc"
};

export type UpdateSettlementStatusRequest = {
	isPaid: boolean;
};

export type TotalMonthlyFeesResponse = {
	totalFees: AmountDto[];
};

export type TransactionTotalFeeResponse = {
	transactionAmount: number;
	transactionAmountCurrencyCode: CurrencyCode;
	totalFee: number;
	totalFeeCurrencyCode: CurrencyCode;
};

export type HunterCardCommissionResponse = {
	isAvailable: boolean;
	currentPeriodAmounts: AmountDto[];
};

export type InitiateTransactionResponse = {
	transaction: TransactionDto;
};

export type TransactionDto = {
	transactionID: number;
	publicID: string;
	amount: AmountDto;
	tipAmount: number;
	receiverIBAN?: string | null;
	receiverBankAccountID?: number | null;
	payPointPublicID?: string | null;
};

export type InitiateTransactionRequest = {
	amount: Amount;
	receiverBankAccountID?: number | null;
	receiverIBAN?: string | null;
	payPointPublicID?: string | null;
	paymentReference?: string | null;
	noteForCreditor?: string | null;
	tipAmount?: number | null;
};

export type TransactionStatusResponse = {
	transactionStatus: TransactionStatus;
	returnUrl?: string | null;
	failureReason: PaymentErrorCode;
};

export type PayTransactionResponse = {
	signingUrl?: string | null;
	isServerAuthorized: boolean;
};

export type PayTransactionRequest = {
	publicID: string;
	senderBankAccountID: number;
	shouldReturnToNativeApp: boolean;
};

export type SendDirectPaymentResponse = {
	transactionPublicID: string;
	signingUrl?: string | null;
	amount: AmountDto;
	isServerAuthorized: boolean;
	requiresPispAuthentication: boolean;
};

export type SendDirectPaymentRequest = {
	recipientIdentityUserPublicID: string;
	amount: AmountDto;
	senderBankAccountID: number;
	channelId: string;
	shouldReturnToNativeApp: boolean;
};

export type PayTransactionQuickRequest = {
	publicID: string;
	shouldReturnToNativeApp: boolean;
};

export type EntityListOfTransactionItem = {
	offset: number;
	limit: number;
	totalCount: number;
	items: TransactionItem[];
};

export type TransactionItem = {
	publicID: string;
	creditorID: number;
	debtorID?: number | null;
	dateCreated: string;
	amount: Amount;
	tipAmount: number;
	status: TransactionStatus;
	isRefund: boolean;
	facilityPublicID?: string | null;
	merchantIdentityUserPublicID?: string | null;
	merchantProfilePicture?: string | null;
	relatedTransactionStatus?: TransactionStatus | null;
};

export enum TransactionDirection {
	Incoming = "Incoming",
	Outgoing = "Outgoing",
	IncomingRefund = "IncomingRefund",
	OutgoingRefund = "OutgoingRefund",
	Unknown = "Unknown"
};

export type ExportTransactionsRequest = {
	format: TransactionExportFormat;
	email?: string | null;
	searchPublicID?: string | null;
	status?: TransactionStatus | null;
	dateFrom?: string | null;
	dateTo?: string | null;
	payPointPublicID?: string | null;
	employeePublicID?: string | null;
	targetUserID?: number | null;
	direction?: TransactionDirection | null;
	isRefundOrCancellation?: boolean | null;
};

export type TransactionSumResponse = {
	totalSums: AmountDto[];
};

export type SendInvoiceRequest = {
	email: string;
	transactionPublicID: string;
};

export type RecordBankReturnRequest = {
	queryString: string;
};

export type CancelTransactionCommandResult = {
	inverseTransactionID?: string | null;
};

export type UpdateTransactionTipRequest = {
	tipAmount: number;
};

export type InitiateCampaignTransactionResponse = {
	campaignCode: string;
	campaignName: string;
	transaction: TransactionDto;
};

export type InitiateCampaignTransactionRequest = {
	amount: number;
	campaignCode: string;
};

export type SsoClientDto = {
	clientId: string;
	displayName: string;
	isConfidential: boolean;
	redirectUris: string[];
	postLogoutRedirectUris: string[];
	allowedRoles: string[];
	allowedScopes: string[];
};

export type SsoClientRegisteredDto = {
	client: SsoClientDto;
	clientSecret?: string | null;
};

export type SsoClientRequest = {
	clientId: string;
	displayName: string;
	isConfidential: boolean;
	redirectUris: string[];
	postLogoutRedirectUris: string[];
	allowedRoles: string[];
	allowedScopes: string[];
};

export type SsoClientSecretDto = {
	clientId: string;
	clientSecret: string;
};

export type SsoAuthorizationRequestDto = {
	publicID: string;
	clientId: string;
	clientDisplayName: string;
	scopes: string[];
	expiresAt: string;
	hasExistingConsent: boolean;
	requiresReauthentication: boolean;
};

export type SsoAuthorizationDecisionResult = {
	resumeUrl: string;
};

export type ConnectedAppDto = {
	clientId: string;
	displayName: string;
	scopes: string[];
	connectedAt?: string | null;
};

export type RaffleRoundDto = {
	publicID: string;
	region: Region;
	isDefault: boolean;
	name: string;
	drawDate?: string | null;
	status: RaffleRoundStatus;
	announcedAt?: string | null;
	closedAt?: string | null;
	drawnAt?: string | null;
	cancelledAt?: string | null;
	ticketCount?: number | null;
	participantCount?: number | null;
	exportChecksum?: string | null;
	allocationChecksum?: string | null;
	waitingTicketCount?: number | null;
	rewards: RaffleRewardDto[];
	canAnnounce: boolean;
};

export enum RaffleRoundStatus {
	Draft = "Draft",
	Announced = "Announced",
	Closed = "Closed",
	Drawn = "Drawn",
	Cancelled = "Cancelled"
};

export type RaffleRewardDto = {
	order: number;
	title: string;
	description?: string | null;
	quantity?: number | null;
};

export type CreateRaffleRoundRequest = {
	region: Region;
	name: string;
	drawDate?: string | null;
};

export type UpdateRaffleRoundRequest = {
	name: string;
	drawDate?: string | null;
	rewards: RaffleRewardInput[];
};

export type RaffleRewardInput = {
	order: number;
	title: string;
	description?: string | null;
	quantity?: number | null;
};

export type RaffleTicketHolderDto = {
	ticketNumber: number;
	partyPublicID: string;
	holderName: string;
	email: string;
	ticketCount: number;
	firstTicketNumber: number;
	lastTicketNumber: number;
};

export type RaffleCurrentDto = {
	isRunning: boolean;
	region?: Region | null;
	totalMyTicketCount: number;
	competitions: RaffleCompetitionDto[];
};

export type RaffleCompetitionDto = {
	roundPublicID: string;
	isDefault: boolean;
	isAnnounced: boolean;
	name?: string | null;
	drawDate?: string | null;
	myTicketCount: number;
	rewards: RaffleRewardDto[];
};

export type RaffleHistoryItemDto = {
	roundPublicID: string;
	roundName: string;
	region: Region;
	drawDate?: string | null;
	closedAt?: string | null;
	isDrawn: boolean;
	myTicketCount: number;
};

export type RaffleTicketMoveResultDto = {
	movedCount: number;
};

export type MoveRaffleTicketsRequest = {
	fromRoundPublicID: string;
	toRoundPublicID: string;
	count: number;
};

export enum CampaignImageType {
	Logo = "Logo",
	Landing = "Landing",
	ThankYou = "ThankYou",
	Icon = "Icon"
};

export type CreatePartyCommandResult = {
	publicID: string;
};

export type VatRegistrationDto = {
	vatNumber: string;
	vatStatus: VatStatus;
};

export type UploadDocumentsCommandResult = {
	partyPublicID: string;
	status: UploadIdentificationCommandResultStatus2;
	documentChecks: DocumentCheckResultDto[];
	verificationAttemptsLeft: number;
};

export enum UploadIdentificationCommandResultStatus2 {
	Success = "Success",
	MissingFiles = "MissingFiles",
	VerificationAttemptsExhausted = "VerificationAttemptsExhausted"
};

export type DocumentCheckResultDto = {
	document: IdentityDocumentSlot;
	verdict: IdentityDocumentVerdict;
	requiresManualReview: boolean;
	reasons: DeclinedReason[];
};

export enum IdentityDocumentSlot {
	Primary = "Primary",
	Secondary = "Secondary"
};

export enum DeclinedReason {
	DocumentExpired = "DocumentExpired",
	NotOriginal = "NotOriginal",
	Unreadable = "Unreadable",
	Unsupported = "Unsupported",
	Generic = "Generic"
};

export type CreateRelatedPartyCommandResult = {
	relatedPartyPublicID: string;
};

export type SetActingPersonRelationCommandResult = {
	relatedPartyPublicID: string;
	actingPersonPartyPublicID: string;
};

export type SetActingPersonRequest = {
	relationType: RelationType;
};

export type GetPartyIdentificationImagesQueryResult = {
	images: PartyIdentificationImageDto[];
};

export type PartyIdentificationImageDto = {
	imageType: PartyIdentificationImageType;
	base64Data: string;
	mimeType: string;
};

export enum PartyIdentificationImageType {
	FirstIDCardFrontSide = "FirstIDCardFrontSide",
	FirstIDCardBackSide = "FirstIDCardBackSide",
	SecondIDCardFrontSide = "SecondIDCardFrontSide",
	SecondIDCardBackSide = "SecondIDCardBackSide"
};

export type IdentityDocumentVerificationDto = {
	identityDocumentVerificationID: number;
	document: IdentityDocumentSlot;
	provider: IdentityDocumentVerificationProvider;
	verdict: IdentityDocumentVerdict;
	externalRequestID: string;
	documentType: string;
	warnings: IdentityDocumentWarning[];
	errorMessage: string;
	verifiedAt: string;
};

export enum IdentityDocumentVerificationProvider {
	Didit = "Didit"
};

export type IdentityDocumentWarning = {
	code: string;
	logType: string;
	shortDescription: string;
	longDescription: string;
};

export type GetExpiringRelatedPartyDocumentsQueryResult = {
	items: ExpiringRelatedPartyDocumentDto[];
};

export type ExpiringRelatedPartyDocumentDto = {
	partyPublicID: string;
	name: string;
	relationType: RelationType;
	identificationValidTo?: string | null;
	secondIdentificationValidTo?: string | null;
};

export type ProcessLoyaltyEventCommandResult = {
	partyLoyaltyPointsDto: PartyLoyaltyPointsDto;
};

export type PartyLoyaltyPointsDto = {
	loyaltyPointType: LoyaltyPointType;
	totalPoints: number;
};

export type ProcessLoyaltyEventRequest = {
	eventCode: LoyaltyEventCode;
};

export enum LoyaltyEventCode {
	HunterDailyAppOpen = "HunterDailyAppOpen",
	HunterDailyAppOpenStreak3 = "HunterDailyAppOpenStreak3",
	HunterDailyAppOpenStreak5 = "HunterDailyAppOpenStreak5",
	HunterDailyAppOpenStreak10 = "HunterDailyAppOpenStreak10",
	HunterDailyAppOpenStreak30 = "HunterDailyAppOpenStreak30",
	HunterDailyAppOpenStreak180 = "HunterDailyAppOpenStreak180",
	HunterDailyAppOpenStreak365 = "HunterDailyAppOpenStreak365",
	Anniversary = "Anniversary",
	HunterReferUser = "HunterReferUser",
	HunterRefer10 = "HunterRefer10",
	HunterRefer50 = "HunterRefer50",
	HunterRefer100 = "HunterRefer100",
	HunterMerchantOnboarded = "HunterMerchantOnboarded",
	HunterMerchant1 = "HunterMerchant1",
	HunterMerchant10 = "HunterMerchant10",
	HunterMerchant50 = "HunterMerchant50",
	HunterRecruitHunter = "HunterRecruitHunter",
	HunterRecruit3 = "HunterRecruit3",
	HunterRecruit10 = "HunterRecruit10",
	HunterMerchantNetwork = "HunterMerchantNetwork",
	HunterWeeklyMerchant = "HunterWeeklyMerchant",
	HunterMonthlyMerchant = "HunterMonthlyMerchant",
	HunterTerminalPlaced = "HunterTerminalPlaced",
	HunterTerminalPlaced3 = "HunterTerminalPlaced3",
	HunterTerminalPlaced10 = "HunterTerminalPlaced10",
	HunterTerminalOfTheWeek = "HunterTerminalOfTheWeek",
	HunterTerminalOfTheMonth = "HunterTerminalOfTheMonth",
	HunterClosedHunter = "HunterClosedHunter",
	CustomerReferCustomer = "CustomerReferCustomer",
	CustomerReferCustomer10 = "CustomerReferCustomer10",
	CustomerReferCustomer50 = "CustomerReferCustomer50",
	CustomerReferCustomer100 = "CustomerReferCustomer100",
	CustomerDailyAppOpen = "CustomerDailyAppOpen",
	CustomerDailyAppOpenStreak3 = "CustomerDailyAppOpenStreak3",
	CustomerDailyAppOpenStreak5 = "CustomerDailyAppOpenStreak5",
	CustomerDailyAppOpenStreak10 = "CustomerDailyAppOpenStreak10",
	CustomerDailyAppOpenStreak30 = "CustomerDailyAppOpenStreak30",
	CustomerDailyAppOpenStreak180 = "CustomerDailyAppOpenStreak180",
	CustomerDailyAppOpenStreak365 = "CustomerDailyAppOpenStreak365",
	Payment = "Payment",
	PaymentStreak3 = "PaymentStreak3",
	PaymentStreak5 = "PaymentStreak5",
	PaymentStreak10 = "PaymentStreak10",
	PaymentStreak30 = "PaymentStreak30",
	PaymentStreak180 = "PaymentStreak180",
	CustomerCompleteRegistration = "CustomerCompleteRegistration",
	TenPayments = "TenPayments",
	FiftyPayments = "FiftyPayments",
	HundredPayments = "HundredPayments",
	ThousandPayments = "ThousandPayments",
	Explorer = "Explorer",
	Discoverer = "Discoverer",
	Traveler = "Traveler",
	FriendPayment = "FriendPayment",
	LargePayment = "LargePayment",
	BankConnection = "BankConnection",
	FirstSpending = "FirstSpending",
	EngineIgnition = "EngineIgnition",
	WeeklyMissionStart = "WeeklyMissionStart",
	RepeatedUsage = "RepeatedUsage",
	MonthlyMissionStart = "MonthlyMissionStart"
};

export type SetStardustParticipationResult = {
	stardustParticipation: ProgramParticipationState;
};

export type SetStardustParticipationRequest = {
	state: ProgramParticipationState;
	source: ProgramParticipationSource;
};

export type GetLoyaltyEventListQueryResult = {
	events: LoyaltyEventDto[];
};

export type LoyaltyEventDto = {
	code: LoyaltyEventCode;
	loyaltyPointType: LoyaltyPointType;
	points: number;
	frequency: LoyaltyEventCategory;
	progress?: number | null;
	isCompleted: boolean;
	resetsAt?: string | null;
};

export enum LoyaltyEventCategory {
	Weekly = "Weekly",
	Monthly = "Monthly",
	Daily = "Daily",
	LongTerm = "LongTerm",
	Unlimited = "Unlimited"
};

export type GetLoyaltyOverviewQueryResult = {
	userPoints: LoyaltyPointsDto;
	toPayout: AmountDto;
	poolTotal: AmountDto;
	userShare: AmountDto;
	totalPoints: LoyaltyPointsDto;
	totalEarned: AmountDto;
};

export type LoyaltyPointsDto = {
	points: number;
	loyaltyPointType: LoyaltyPointType;
};

export type GetStardustLeaderboardQueryResult = {
	items: StardustLeaderboardEntryDto[];
	totalCount: number;
};

export type StardustLeaderboardEntryDto = {
	rank: number;
	name?: string | null;
	totalPoints: number;
	isCurrentUser: boolean;
	partyPublicId?: string | null;
	identityUserPublicId?: string | null;
	profilePicture?: string | null;
};

export type GetLoyaltyPeriodsQueryResult = {
	items: LoyaltyPeriodDto[];
};

export type LoyaltyPeriodDto = {
	settlementPeriodId: number;
	year: number;
	month: number;
	isCurrent: boolean;
};

export type GetStardustRecordQueryResult = {
	items: LoyaltyEventRecordDto[];
	totalCount: number;
};

export type LoyaltyEventRecordDto = {
	dateCreated: string;
	eventCode: LoyaltyEventCode;
	loyaltyPointType: LoyaltyPointType;
	loyaltyEventRecordType: LoyaltyEventRecordType;
	points: number;
};

export enum LoyaltyEventRecordType {
	Collect = "Collect",
	Redeem = "Redeem"
};

export type EntityListOfPartyLicenseDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: PartyLicenseDto[];
};

export type EntityListOfLicenseTypeListItem = {
	offset: number;
	limit: number;
	totalCount: number;
	items: LicenseTypeListItem[];
};

export type LicenseTypeListItem = {
	code: LicenseCode;
	currencyCode: CurrencyCode;
	price: number;
	totalAmount: number;
	availableAmount: number;
};

export type UpdateLicensePaymentStatusCommandResult = {
	partyLicenseDto: PartyLicenseBaseDto;
};

export type PartyLicenseBaseDto = {
	publicID: string;
	paymentStatus: LicensePaymentStatus;
	licenseNo?: string | null;
	paymentDate?: string | null;
};

export type UpdateLicensePaymentStatusRequest = {
	paymentStatus?: LicensePaymentStatus | null;
	paymentDate?: string | null;
};

export type UpdateLicenseCommandResult = {
	partyLicenseDto: PartyLicenseBaseDto;
};

export type UpdateLicenseRequest = {
	licenseNo?: string | null;
	paymentStatus: LicensePaymentStatus;
	paymentDate?: string | null;
};

export type CreateLicenseCommandResult = {
	license: LicenseDto;
};

export type LicenseDto = {
	publicID: string;
	transaction: TransactionDto2;
};

export type TransactionDto2 = {
	publicID: string;
	amount: number;
	currencyCode: CurrencyCode;
	receiverIBAN: string;
	receiverBankAccount: string;
	paymentReference: string;
	noteForDebtor: string;
};

export type CreateLicenseRequest = {
	region: Region;
	code: LicenseCode;
	walletAddress: string;
	ownershipType: OwnershipType;
	subscriptionPeriodicity?: SubscriptionPeriodicity | null;
	shouldReplaceUnpaidLicenses: boolean;
	couponCode?: string | null;
};

export type TransferLicenseCommandResult = {
	licensePublicID: string;
	newOwnerPartyPublicID: string;
};

export type TransferLicenseRequest = {
	targetPartyPublicID: string;
};

export type RecreateInvoicesCommandResult = {
	invoiceForRecreationCount: number;
	countProcessed: number;
};

export type RecreateLicensesInvoicesRequest = {
	dateFrom?: string | null;
	dateTo?: string | null;
	invoiceNumbers?: number[] | null;
	sendToCustomers: boolean;
};

export type CreateCouponCommandResult = {
	couponID: number;
	code: string;
};

export type CreateCouponRequest = {
	code?: string | null;
	discount: number;
	discountType: CouponDiscountType;
	expirationDate: string;
	type: CouponType;
	region: Region;
	initialStock: number;
};

export type EntityListOfCouponDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: CouponDto[];
};

export type CouponDto = {
	couponID: number;
	code: string;
	discount: number;
	discountType: CouponDiscountType;
	expirationDate: string;
	type: CouponType;
	region: Region;
	initialStock: number;
	currentStock: number;
};

export enum CouponStatusFilter {
	Active = "Active",
	Expired = "Expired",
	OutOfStock = "OutOfStock"
};

export type ValidateCouponResult = {
	discount: number;
	discountType: CouponDiscountType;
	originalPriceWithTax: number;
	discountAmount: number;
	finalPriceWithTax: number;
	currencyCode: CurrencyCode;
};

export type ValidateCouponRequest = {
	code: string;
	licenseCode: LicenseCode;
	region: Region;
};

export type UpdateCouponRequest = {
	expirationDate: string;
	initialStock: number;
};

export type EntityListOfBankAccountListItem = {
	offset: number;
	limit: number;
	totalCount: number;
	items: BankAccountListItem[];
};

export type BankAccountListItem = {
	bankAccountID: number;
	iban: string;
	currency: string;
	balance?: number | null;
	rank: number;
	productName: string;
	publicID: string;
	environment: BankEnvironment;
	bank: Bank;
	status: BankAccountStatus;
	ownersNames: string[];
	dateCreated: string;
	isPrimary: boolean;
	isReceiveOnly: boolean;
	isTokenInvalid: boolean;
	paymentLimits: PaymentLimits;
	contextRoleCode?: string | null;
	contextPartyName?: string | null;
};

export enum Bank {
	CSOB = "CSOB",
	CSAS = "CSAS",
	KB = "KB",
	AirBank = "AirBank",
	UCB = "UCB",
	MONETA = "MONETA",
	FIO = "FIO",
	MBank = "MBank",
	RB = "RB",
	Citfin = "Citfin",
	TRINITY = "TRINITY",
	PenezniDum = "PenezniDum",
	Artesa = "Artesa",
	CREDITAS = "CREDITAS",
	NEY = "NEY",
	MaxBanka = "MaxBanka",
	NRB = "NRB",
	JandT = "JandT",
	PPF = "PPF",
	Oberbank = "Oberbank",
	PartnersBank = "PartnersBank",
	CNB = "CNB",
	Revolut = "Revolut",
	CZKT = "CZKT"
};

export type PaymentLimits = {
	hasLimit: boolean;
	preApprovalRemainingAmount: AmountDto;
	preApprovalTotalLimit: AmountDto;
	preApprovalOneTimeLimit: AmountDto;
};

export type SyncBankTransactionsCommandResult = {
	accounts: BankAccountSyncResult[];
};

export type BankAccountSyncResult = {
	bankAccountID: number;
	iban: string;
	fetchedCount: number;
	insertedCount: number;
	failedRangeCount: number;
	truncatedRangeCount: number;
	error: string;
};

export type RBStandingOrdersResult = {
	success: boolean;
	error?: string | null;
	requestUrl: string;
	statusCode: number;
	rawResponse: string;
};

export type RankBankAccountsResponse = {
	success: boolean;
};

export type RankBankAccountsRequest = {
	bankAccountIDs: number[];
};

export type DeleteBankAccountResponse = {
	success: boolean;
};

export type SetPrimaryBankAccountCommandResult = {
	publicID: string;
};

export type UpdateBankAccountStatusResponse = {
	publicID: string;
};

export type UpdateBankAccountStatusRequest = {
	status: BankAccountStatus;
};

export type AuthenticationUrl = {
	url: string;
	externalID?: string | null;
	consentId?: string | null;
	scopeTimeLimit?: string | null;
};

export type ExpiringRefreshTokenBanksResult = {
	expiringBanks: BankEnvironment[];
	invalidBanks: BankEnvironment[];
	expiringPispBanks: BankEnvironment[];
	invalidPispBanks: BankEnvironment[];
	expirations: BankAuthExpiration[];
};

export type BankAuthExpiration = {
	environment: BankEnvironment;
	aisExpirationDate?: string | null;
	pispExpirationDate?: string | null;
};

export type EntityListOfBankEnvironmentDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: BankEnvironmentDto[];
};

export type BankEnvironmentDto = {
	bankEnvironment: BankEnvironment;
	name: string;
	bank: Bank;
	isEnabled: boolean;
	rank: number;
	isVisible: boolean;
	paymentAuthorizationNeeded: boolean;
};

export type EntityListOfBatchPaymentListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: BatchPaymentListItemDto[];
};

export type BatchPaymentListItemDto = {
	publicId: string;
	status: BatchPaymentStatus;
	bankAccountIBAN: string;
	bankEnvironment: BankEnvironment;
	totalAmount: number;
	currencyCode: string;
	paymentCount: number;
	signingUrl?: string | null;
	authorizedAt?: string | null;
	completedAt?: string | null;
	dateCreated: string;
};

export type BatchPaymentDetailDto = {
	publicId: string;
	status: BatchPaymentStatus;
	bankAccountIBAN: string;
	bankEnvironment: BankEnvironment;
	signingUrl?: string | null;
	totalAmount: number;
	currencyCode: string;
	paymentCount: number;
	payments: BatchPaymentItemDto[];
	authorizedAt?: string | null;
	completedAt?: string | null;
	dateCreated: string;
};

export type BatchPaymentItemDto = {
	amount: number;
	currencyCode: string;
	creditorIBAN: string;
	creditorName?: string | null;
	paymentReference?: string | null;
	note?: string | null;
	instructionStatus: PaymentInstructionStatus;
	transactionStatus?: TransactionStatus | null;
};

export type CreateBatchPaymentResponse = {
	batchPublicID: string;
};

export type CreateBatchPaymentCommand = {
	transactionIDs: number[];
	debtorBankAccountID: number;
	userID: number;
};

export type EntityListOfAdminCampaignDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: AdminCampaignDto[];
};

export type AdminCampaignDto = {
	currency?: CurrencyCode | null;
	campaignID: number;
	code: string;
	name: string;
	description: string;
	header?: string | null;
	linkName?: string | null;
	linkUrl?: string | null;
	successfulPaymentText?: string | null;
	color?: string | null;
	paymentInstructionsText?: string | null;
	onlyWithMooneText?: string | null;
	startDate?: string | null;
	endDate?: string | null;
	receiverUserID?: number | null;
	receiverIdentityUserID?: number | null;
	receiverMerchantUser?: MerchantUserDto | null;
	isAffiliateEnabled: boolean;
	status: CampaignLifecycleStatus;
	dateCreated: string;
	dateUpdated?: string | null;
	logoFileName?: string | null;
	landingImageFileName?: string | null;
	thankYouImageFileName?: string | null;
	iconFileName?: string | null;
};

export type MerchantUserDto = {
	userID: number;
	identityUserID?: number | null;
	companyNumber?: string | null;
	companyName?: string | null;
};

export enum CampaignLifecycleStatus {
	Draft = "Draft",
	Published = "Published",
	Archived = "Archived"
};

export enum CampaignDisplayStatus {
	Active = "Active",
	NotStarted = "NotStarted",
	Finished = "Finished",
	Unlimited = "Unlimited"
};

export type CreateCampaignCommandResult = {
	campaignID: number;
	code: string;
};

export type CreateCampaignRequest = {
	name: string;
	code: string;
	description: string;
	header?: string | null;
	linkName?: string | null;
	linkUrl?: string | null;
	successfulPaymentText?: string | null;
	color?: string | null;
	paymentInstructionsText?: string | null;
	onlyWithMooneText?: string | null;
	receiverUserID?: number | null;
	receiverIdentityUserID?: number | null;
	isAffiliateEnabled: boolean;
	startDate?: string | null;
	endDate?: string | null;
};

export type UpdateCampaignCommandResult = {
	campaignID: number;
	code: string;
};

export type UpdateCampaignRequest = {
	name: string;
	code: string;
	description: string;
	header?: string | null;
	linkName?: string | null;
	linkUrl?: string | null;
	successfulPaymentText?: string | null;
	color?: string | null;
	paymentInstructionsText?: string | null;
	onlyWithMooneText?: string | null;
	receiverUserID?: number | null;
	receiverIdentityUserID?: number | null;
	isAffiliateEnabled: boolean;
	startDate?: string | null;
	endDate?: string | null;
	status: CampaignLifecycleStatus;
};

export type EnqueueCardTransactionBackfillCommandResult = {
	jobID: string;
};

export type EnqueueCardTransactionBackfillCommand = {
	provider: CardTransactionProvider;
	fromUtc: string;
	toUtc: string;
};

export enum CardTransactionProvider {
	Switchio = "Switchio",
	Comgate = "Comgate",
	Elcom = "Elcom"
};

export type RecomputeCardCommissionRollupsCommandResult = {
	updated: number;
	created: number;
	zeroedOut: number;
	closedMismatches: number;
};

export type EntityListOfMerchantUserDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: MerchantUserDto[];
};

export type SimulatePaymentSuccessResult = {
	publicID: string;
	previousStatus: TransactionStatus;
	status: TransactionStatus;
	amount: AmountDto;
	environment: BankEnvironment;
};

export type EntityListOfUnassignedMerchantListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UnassignedMerchantListItemDto[];
};

export type UnassignedMerchantListItemDto = {
	publicID: string;
	party: UnassignedMerchantPartyDto;
	merchantStatus: MerchantStatus;
	dateCreated: string;
};

export type UnassignedMerchantPartyDto = {
	companyName?: string | null;
	companyNumber?: string | null;
};

export type AssignHunterToUnassignedMerchantResult = {
	merchantPublicID: string;
};

export type AssignHunterToUnassignedMerchantRequest = {
	primaryLicensePublicID: string;
	partyLicenseFees: { [key: string | number]: number };
};

export type AddressSuggestionDto = {
	street: string;
	streetNumber: string;
	orientationNumber?: string | null;
	postalCode: string;
	municipality: string;
	addressCode: string;
};

export type GetAccessRoleListWithPermissionsFetchResponse = 
| FetchResponse<AccessRoleWithPermissionsDto[], 200> 
| FetchResponse<ProblemDetails, 403> 
| ErrorResponse;

export const getAccessRoleListWithPermissionsPath = () => `/api/access-role/list-with-permissions`;

export const getAccessRoleListWithPermissions = (options?: FetchArgsOptions):
  Promise<GetAccessRoleListWithPermissionsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAccessRoleListWithPermissionsPath()}`, options, {}) as Promise<GetAccessRoleListWithPermissionsFetchResponse>;
}

export type PostAuthSignInFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postAuthSignInPath = () => `/api/auth/sign-in`;

export const postAuthSignIn = (requestContract: SignInCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignInFetchResponse> => {
    const requestData = getApiRequestData<SignInCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignInPath()}`, requestData, options) as Promise<PostAuthSignInFetchResponse>;
}

export type PostAuthSignUpFetchResponse = 
| FetchResponse<SignUpCommandResult, 200> 
| ErrorResponse;

export const postAuthSignUpPath = () => `/api/auth/sign-up`;

export const postAuthSignUp = (requestContract: SignUpCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignUpFetchResponse> => {
    const requestData = getApiRequestData<SignUpCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignUpPath()}`, requestData, options) as Promise<PostAuthSignUpFetchResponse>;
}

export type PostAuthSignUpPasswordlessFetchResponse = 
| FetchResponse<PasswordlessSignUpCommandResult, 200> 
| ErrorResponse;

export const postAuthSignUpPasswordlessPath = () => `/api/auth/sign-up/passwordless`;

export const postAuthSignUpPasswordless = (requestContract: PasswordlessSignUpCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignUpPasswordlessFetchResponse> => {
    const requestData = getApiRequestData<PasswordlessSignUpCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignUpPasswordlessPath()}`, requestData, options) as Promise<PostAuthSignUpPasswordlessFetchResponse>;
}

export type PostAuthVerifyEmailFetchResponse = 
| FetchResponse<EmailVerificationCommandResult, 200> 
| ErrorResponse;

export const postAuthVerifyEmailPath = () => `/api/auth/verify-email`;

export const postAuthVerifyEmail = (requestContract: EmailVerificationCommand, options?: FetchArgsOptions):
  Promise<PostAuthVerifyEmailFetchResponse> => {
    const requestData = getApiRequestData<EmailVerificationCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthVerifyEmailPath()}`, requestData, options) as Promise<PostAuthVerifyEmailFetchResponse>;
}

export type PostAuthResendVerificationEmailFetchResponse = 
| FetchResponse<ResendVerificationEmailCommandResult, 200> 
| ErrorResponse;

export const postAuthResendVerificationEmailPath = () => `/api/auth/resend-verification-email`;

export const postAuthResendVerificationEmail = (requestContract: ResendVerificationEmailCommand, options?: FetchArgsOptions):
  Promise<PostAuthResendVerificationEmailFetchResponse> => {
    const requestData = getApiRequestData<ResendVerificationEmailCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthResendVerificationEmailPath()}`, requestData, options) as Promise<PostAuthResendVerificationEmailFetchResponse>;
}

export type PostAuthSsoFetchResponse = 
| FetchResponse<SignInResult, 200> 
| ErrorResponse;

export const postAuthSsoPath = () => `/api/auth/sso`;

export const postAuthSso = (requestContract: SsoSignInRequest, options?: FetchArgsOptions):
  Promise<PostAuthSsoFetchResponse> => {
    const requestData = getApiRequestData<SsoSignInRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSsoPath()}`, requestData, options) as Promise<PostAuthSsoFetchResponse>;
}

export type GetAuthSsoGoogleCallbackFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getAuthSsoGoogleCallbackPath = () => `/api/auth/sso/google-callback`;

export const getAuthSsoGoogleCallback = (code?: string, scope?: string | undefined | null, authuser?: string | undefined | null, hd?: string | undefined | null, prompt?: string | undefined | null, state?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetAuthSsoGoogleCallbackFetchResponse> => {
    const queryParams = {
      "code": code,
      "scope": scope,
      "authuser": authuser,
      "hd": hd,
      "prompt": prompt,
      "state": state
    }
    return apiGet(`${getApiUrl()}${getAuthSsoGoogleCallbackPath()}`, options, queryParams) as Promise<GetAuthSsoGoogleCallbackFetchResponse>;
}

export type PostAuthSsoAppleCallbackFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postAuthSsoAppleCallbackPath = () => `/api/auth/sso/apple-callback`;

export const postAuthSsoAppleCallback = (options?: FetchArgsOptions):
  Promise<PostAuthSsoAppleCallbackFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postAuthSsoAppleCallbackPath()}`, requestData, options) as Promise<PostAuthSsoAppleCallbackFetchResponse>;
}

export type GetAuthUserInfoFetchResponse = 
| FetchResponse<UserInfoQueryResult, 200> 
| FetchResponse<ProblemDetails, 401> 
| ErrorResponse;

export const getAuthUserInfoPath = () => `/api/auth/user-info`;

export const getAuthUserInfo = (options?: FetchArgsOptions):
  Promise<GetAuthUserInfoFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthUserInfoPath()}`, options, {}) as Promise<GetAuthUserInfoFetchResponse>;
}

export type PostAuthMigrateLinkToCustomerFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAuthMigrateLinkToCustomerPath = () => `/api/auth/migrate/link-to-customer`;

export const postAuthMigrateLinkToCustomer = (requestContract: LinkToCustomerCommand, options?: FetchArgsOptions):
  Promise<PostAuthMigrateLinkToCustomerFetchResponse> => {
    const requestData = getApiRequestData<LinkToCustomerCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthMigrateLinkToCustomerPath()}`, requestData, options) as Promise<PostAuthMigrateLinkToCustomerFetchResponse>;
}

export type PostAuthMigrateLinkToCustomerSsoFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAuthMigrateLinkToCustomerSsoPath = () => `/api/auth/migrate/link-to-customer/sso`;

export const postAuthMigrateLinkToCustomerSso = (requestContract: LinkToCustomerSsoCommand, options?: FetchArgsOptions):
  Promise<PostAuthMigrateLinkToCustomerSsoFetchResponse> => {
    const requestData = getApiRequestData<LinkToCustomerSsoCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthMigrateLinkToCustomerSsoPath()}`, requestData, options) as Promise<PostAuthMigrateLinkToCustomerSsoFetchResponse>;
}

export type PostAuthMigrateCreateIdentityFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAuthMigrateCreateIdentityPath = () => `/api/auth/migrate/create-identity`;

export const postAuthMigrateCreateIdentity = (requestContract: CreateIdentityFromUserCommand, options?: FetchArgsOptions):
  Promise<PostAuthMigrateCreateIdentityFetchResponse> => {
    const requestData = getApiRequestData<CreateIdentityFromUserCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthMigrateCreateIdentityPath()}`, requestData, options) as Promise<PostAuthMigrateCreateIdentityFetchResponse>;
}

export type GetAuthMigrateMerchantCandidatesFetchResponse = 
| FetchResponse<MerchantPersonCandidatesDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getAuthMigrateMerchantCandidatesPath = () => `/api/auth/migrate/merchant-candidates`;

export const getAuthMigrateMerchantCandidates = (options?: FetchArgsOptions):
  Promise<GetAuthMigrateMerchantCandidatesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthMigrateMerchantCandidatesPath()}`, options, {}) as Promise<GetAuthMigrateMerchantCandidatesFetchResponse>;
}

export type PostAuthMigrateCreateIdentityFromMerchantFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAuthMigrateCreateIdentityFromMerchantPath = () => `/api/auth/migrate/create-identity-from-merchant`;

export const postAuthMigrateCreateIdentityFromMerchant = (requestContract: CreateIdentityFromMerchantCommand, options?: FetchArgsOptions):
  Promise<PostAuthMigrateCreateIdentityFromMerchantFetchResponse> => {
    const requestData = getApiRequestData<CreateIdentityFromMerchantCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthMigrateCreateIdentityFromMerchantPath()}`, requestData, options) as Promise<PostAuthMigrateCreateIdentityFromMerchantFetchResponse>;
}

export type GetAuthContextsFetchResponse = 
| FetchResponse<GetContextsResponse, 200> 
| ErrorResponse;

export const getAuthContextsPath = () => `/api/auth/contexts`;

export const getAuthContexts = (options?: FetchArgsOptions):
  Promise<GetAuthContextsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthContextsPath()}`, options, {}) as Promise<GetAuthContextsFetchResponse>;
}

export type GetAuthContextsMerchantsFetchResponse = 
| FetchResponse<GetMerchantContextsResponse, 200> 
| ErrorResponse;

export const getAuthContextsMerchantsPath = () => `/api/auth/contexts/merchants`;

export const getAuthContextsMerchants = (options?: FetchArgsOptions):
  Promise<GetAuthContextsMerchantsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthContextsMerchantsPath()}`, options, {}) as Promise<GetAuthContextsMerchantsFetchResponse>;
}

export type PostAuthContextSwitchFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const postAuthContextSwitchPath = () => `/api/auth/context/switch`;

export const postAuthContextSwitch = (requestContract: SwitchContextRequest, options?: FetchArgsOptions):
  Promise<PostAuthContextSwitchFetchResponse> => {
    const requestData = getApiRequestData<SwitchContextRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthContextSwitchPath()}`, requestData, options) as Promise<PostAuthContextSwitchFetchResponse>;
}

export type PutAuthContextRegionFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const putAuthContextRegionPath = () => `/api/auth/context/region`;

export const putAuthContextRegion = (requestContract: SetRegionCommand, options?: FetchArgsOptions):
  Promise<PutAuthContextRegionFetchResponse> => {
    const requestData = getApiRequestData<SetRegionCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAuthContextRegionPath()}`, requestData, options) as Promise<PutAuthContextRegionFetchResponse>;
}

export type PostAuthSendPhoneVerificationFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postAuthSendPhoneVerificationPath = () => `/api/auth/send-phone-verification`;

export const postAuthSendPhoneVerification = (requestContract: SendPhoneVerificationRequest, options?: FetchArgsOptions):
  Promise<PostAuthSendPhoneVerificationFetchResponse> => {
    const requestData = getApiRequestData<SendPhoneVerificationRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSendPhoneVerificationPath()}`, requestData, options) as Promise<PostAuthSendPhoneVerificationFetchResponse>;
}

export type PostAuthVerifyPhoneCodeFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postAuthVerifyPhoneCodePath = () => `/api/auth/verify-phone-code`;

export const postAuthVerifyPhoneCode = (requestContract: VerifyPhoneCodeRequest, options?: FetchArgsOptions):
  Promise<PostAuthVerifyPhoneCodeFetchResponse> => {
    const requestData = getApiRequestData<VerifyPhoneCodeRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthVerifyPhoneCodePath()}`, requestData, options) as Promise<PostAuthVerifyPhoneCodeFetchResponse>;
}

export type GetAuthPhoneVerificationStatusFetchResponse = 
| FetchResponse<PhoneVerificationStatusDto, 200> 
| ErrorResponse;

export const getAuthPhoneVerificationStatusPath = () => `/api/auth/phone-verification-status`;

export const getAuthPhoneVerificationStatus = (options?: FetchArgsOptions):
  Promise<GetAuthPhoneVerificationStatusFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthPhoneVerificationStatusPath()}`, options, {}) as Promise<GetAuthPhoneVerificationStatusFetchResponse>;
}

export type PostAuthResetPasswordFetchResponse = 
| FetchResponse<ResetPasswordCommandResult, 200> 
| ErrorResponse;

export const postAuthResetPasswordPath = () => `/api/auth/reset-password`;

export const postAuthResetPassword = (requestContract: ResetPasswordCommand, options?: FetchArgsOptions):
  Promise<PostAuthResetPasswordFetchResponse> => {
    const requestData = getApiRequestData<ResetPasswordCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthResetPasswordPath()}`, requestData, options) as Promise<PostAuthResetPasswordFetchResponse>;
}

export type PostAuthSetPasswordFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const postAuthSetPasswordPath = () => `/api/auth/set-password`;

export const postAuthSetPassword = (requestContract: SetPasswordCommand, options?: FetchArgsOptions):
  Promise<PostAuthSetPasswordFetchResponse> => {
    const requestData = getApiRequestData<SetPasswordCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSetPasswordPath()}`, requestData, options) as Promise<PostAuthSetPasswordFetchResponse>;
}

export type PutAuthRoleFetchResponse = 
| FetchResponse<SetRoleCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putAuthRolePath = () => `/api/auth/role`;

export const putAuthRole = (requestContract: SetRoleRequest, options?: FetchArgsOptions):
  Promise<PutAuthRoleFetchResponse> => {
    const requestData = getApiRequestData<SetRoleRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAuthRolePath()}`, requestData, options) as Promise<PutAuthRoleFetchResponse>;
}

export type GetAuthIdentityLookupFetchResponse = 
| FetchResponse<IdentityLookupDto, 200> 
| FetchResponse<ProblemDetails, 401> 
| FetchResponse<ProblemDetails, 429> 
| ErrorResponse;

export const getAuthIdentityLookupPath = () => `/api/auth/identity-lookup`;

export const getAuthIdentityLookup = (login?: string, companyPartyPublicID?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetAuthIdentityLookupFetchResponse> => {
    const queryParams = {
      "login": login,
      "companyPartyPublicID": companyPartyPublicID
    }
    return apiGet(`${getApiUrl()}${getAuthIdentityLookupPath()}`, options, queryParams) as Promise<GetAuthIdentityLookupFetchResponse>;
}

export type GetAuthCurrentTimeFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getAuthCurrentTimePath = () => `/api/auth/current-time`;

export const getAuthCurrentTime = (options?: FetchArgsOptions):
  Promise<GetAuthCurrentTimeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthCurrentTimePath()}`, options, {}) as Promise<GetAuthCurrentTimeFetchResponse>;
}

export type GetCacheRefreshFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getCacheRefreshPath = () => `/api/Cache/refresh`;

export const getCacheRefresh = (options?: FetchArgsOptions):
  Promise<GetCacheRefreshFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCacheRefreshPath()}`, options, {}) as Promise<GetCacheRefreshFetchResponse>;
}

export type GetCertificatesEnvironmentQsealPemFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getCertificatesEnvironmentQsealPemPath = (environment: BankEnvironment) => `/api/Certificates/${environment}/qseal.pem`;

export const getCertificatesEnvironmentQsealPem = (environment: BankEnvironment, options?: FetchArgsOptions):
  Promise<GetCertificatesEnvironmentQsealPemFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCertificatesEnvironmentQsealPemPath(environment)}`, options, {}) as Promise<GetCertificatesEnvironmentQsealPemFetchResponse>;
}

export type GetChatTokenFetchResponse = 
| FetchResponse<GetChatTokenQueryResult, 200> 
| ErrorResponse;

export const getChatTokenPath = () => `/api/Chat/token`;

export const getChatToken = (options?: FetchArgsOptions):
  Promise<GetChatTokenFetchResponse> => {
    return apiGet(`${getApiUrl()}${getChatTokenPath()}`, options, {}) as Promise<GetChatTokenFetchResponse>;
}

export type PostChatChannelFetchResponse = 
| FetchResponse<CreateChatChannelCommandResult, 200> 
| ErrorResponse;

export const postChatChannelPath = () => `/api/Chat/channel`;

export const postChatChannel = (requestContract: CreateChatChannelRequest, options?: FetchArgsOptions):
  Promise<PostChatChannelFetchResponse> => {
    const requestData = getApiRequestData<CreateChatChannelRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatChannelPath()}`, requestData, options) as Promise<PostChatChannelFetchResponse>;
}

export type PostChatChannelChannelIdAcceptFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postChatChannelChannelIdAcceptPath = (channelId: string) => `/api/Chat/channel/${channelId}/accept`;

export const postChatChannelChannelIdAccept = (channelId: string, options?: FetchArgsOptions):
  Promise<PostChatChannelChannelIdAcceptFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postChatChannelChannelIdAcceptPath(channelId)}`, requestData, options) as Promise<PostChatChannelChannelIdAcceptFetchResponse>;
}

export type PostChatChannelChannelIdRejectFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postChatChannelChannelIdRejectPath = (channelId: string) => `/api/Chat/channel/${channelId}/reject`;

export const postChatChannelChannelIdReject = (channelId: string, options?: FetchArgsOptions):
  Promise<PostChatChannelChannelIdRejectFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postChatChannelChannelIdRejectPath(channelId)}`, requestData, options) as Promise<PostChatChannelChannelIdRejectFetchResponse>;
}

export type PutChatChannelChannelIdNameFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const putChatChannelChannelIdNamePath = (channelId: string) => `/api/Chat/channel/${channelId}/name`;

export const putChatChannelChannelIdName = (requestContract: RenameChannelRequest, channelId: string, options?: FetchArgsOptions):
  Promise<PutChatChannelChannelIdNameFetchResponse> => {
    const requestData = getApiRequestData<RenameChannelRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putChatChannelChannelIdNamePath(channelId)}`, requestData, options) as Promise<PutChatChannelChannelIdNameFetchResponse>;
}

export type PostChatChannelChannelIdMembersFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postChatChannelChannelIdMembersPath = (channelId: string) => `/api/Chat/channel/${channelId}/members`;

export const postChatChannelChannelIdMembers = (requestContract: AddChatChannelMemberRequest, channelId: string, options?: FetchArgsOptions):
  Promise<PostChatChannelChannelIdMembersFetchResponse> => {
    const requestData = getApiRequestData<AddChatChannelMemberRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatChannelChannelIdMembersPath(channelId)}`, requestData, options) as Promise<PostChatChannelChannelIdMembersFetchResponse>;
}

export type DeleteChatChannelChannelIdMembersMemberIdentityUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteChatChannelChannelIdMembersMemberIdentityUserPublicIDPath = (channelId: string, memberIdentityUserPublicID: string) => `/api/Chat/channel/${channelId}/members/${memberIdentityUserPublicID}`;

export const deleteChatChannelChannelIdMembersMemberIdentityUserPublicID = (channelId: string, memberIdentityUserPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteChatChannelChannelIdMembersMemberIdentityUserPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteChatChannelChannelIdMembersMemberIdentityUserPublicIDPath(channelId, memberIdentityUserPublicID)}`, options, {}) as Promise<DeleteChatChannelChannelIdMembersMemberIdentityUserPublicIDFetchResponse>;
}

export type DeleteChatDevicesDeviceIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteChatDevicesDeviceIdPath = (deviceId: string) => `/api/Chat/devices/${deviceId}`;

export const deleteChatDevicesDeviceId = (deviceId: string, options?: FetchArgsOptions):
  Promise<DeleteChatDevicesDeviceIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteChatDevicesDeviceIdPath(deviceId)}`, options, {}) as Promise<DeleteChatDevicesDeviceIdFetchResponse>;
}

export type GetCodeListFetchResponse = 
| FetchResponse<GetCodeListCollectionQueryResult, 200> 
| ErrorResponse;

export const getCodeListPath = () => `/api/CodeList`;

export const getCodeList = (options?: FetchArgsOptions):
  Promise<GetCodeListFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCodeListPath()}`, options, {}) as Promise<GetCodeListFetchResponse>;
}

export type GetHashSha256FetchResponse = 
| FetchResponse<string, 200> 
| ErrorResponse;

export const getHashSha256Path = () => `/api/Hash/sha-256`;

export const getHashSha256 = (value?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetHashSha256FetchResponse> => {
    const queryParams = {
      "value": value
    }
    return apiGet(`${getApiUrl()}${getHashSha256Path()}`, options, queryParams) as Promise<GetHashSha256FetchResponse>;
}

export type GetHunterPrerequisitesFetchResponse = 
| FetchResponse<GetHunterPrerequisitesQueryResult, 200> 
| ErrorResponse;

export const getHunterPrerequisitesPath = () => `/api/hunter/prerequisites`;

export const getHunterPrerequisites = (options?: FetchArgsOptions):
  Promise<GetHunterPrerequisitesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHunterPrerequisitesPath()}`, options, {}) as Promise<GetHunterPrerequisitesFetchResponse>;
}

export type GetHunterUserIDPrerequisitesFetchResponse = 
| FetchResponse<GetHunterPrerequisitesQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getHunterUserIDPrerequisitesPath = (userID: number) => `/api/hunter/${userID}/prerequisites`;

export const getHunterUserIDPrerequisites = (userID: number, options?: FetchArgsOptions):
  Promise<GetHunterUserIDPrerequisitesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHunterUserIDPrerequisitesPath(userID)}`, options, {}) as Promise<GetHunterUserIDPrerequisitesFetchResponse>;
}

export type PutHunterUserIDPrerequisitesFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putHunterUserIDPrerequisitesPath = (userID: number) => `/api/hunter/${userID}/prerequisites`;

export const putHunterUserIDPrerequisites = (requestContract: UpdateHunterPrerequisiteItemRequest[], userID: number, options?: FetchArgsOptions):
  Promise<PutHunterUserIDPrerequisitesFetchResponse> => {
    const requestData = getApiRequestData<UpdateHunterPrerequisiteItemRequest[]>(requestContract, false);

    return apiPut(`${getApiUrl()}${putHunterUserIDPrerequisitesPath(userID)}`, requestData, options) as Promise<PutHunterUserIDPrerequisitesFetchResponse>;
}

export type GetHunterUserIDMerchantsFetchResponse = 
| FetchResponse<EntityListOfMerchantListItemDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getHunterUserIDMerchantsPath = (userID: number) => `/api/hunter/${userID}/merchants`;

export const getHunterUserIDMerchants = (userID: number, options?: FetchArgsOptions):
  Promise<GetHunterUserIDMerchantsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHunterUserIDMerchantsPath(userID)}`, options, {}) as Promise<GetHunterUserIDMerchantsFetchResponse>;
}

export type GetHunterUserIDLicenseSharesFetchResponse = 
| FetchResponse<EntityListOfLicenseShareDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getHunterUserIDLicenseSharesPath = (userID: number) => `/api/hunter/${userID}/license-shares`;

export const getHunterUserIDLicenseShares = (userID: number, options?: FetchArgsOptions):
  Promise<GetHunterUserIDLicenseSharesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHunterUserIDLicenseSharesPath(userID)}`, options, {}) as Promise<GetHunterUserIDLicenseSharesFetchResponse>;
}

export type GetIdentitiesRolesIntentsFetchResponse = 
| FetchResponse<PendingRoleIntentsResult, 200> 
| ErrorResponse;

export const getIdentitiesRolesIntentsPath = () => `/api/identities/roles/intents`;

export const getIdentitiesRolesIntents = (options?: FetchArgsOptions):
  Promise<GetIdentitiesRolesIntentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getIdentitiesRolesIntentsPath()}`, options, {}) as Promise<GetIdentitiesRolesIntentsFetchResponse>;
}

export type PostIdentitiesRolesHunterFetchResponse = 
| FetchResponse<AddRoleResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postIdentitiesRolesHunterPath = () => `/api/identities/roles/hunter`;

export const postIdentitiesRolesHunter = (requestContract: AddRoleRequest, options?: FetchArgsOptions):
  Promise<PostIdentitiesRolesHunterFetchResponse> => {
    const requestData = getApiRequestData<AddRoleRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postIdentitiesRolesHunterPath()}`, requestData, options) as Promise<PostIdentitiesRolesHunterFetchResponse>;
}

export type PostIdentitiesRolesMerchantFetchResponse = 
| FetchResponse<AddRoleResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postIdentitiesRolesMerchantPath = () => `/api/identities/roles/merchant`;

export const postIdentitiesRolesMerchant = (requestContract: AddRoleRequest, options?: FetchArgsOptions):
  Promise<PostIdentitiesRolesMerchantFetchResponse> => {
    const requestData = getApiRequestData<AddRoleRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postIdentitiesRolesMerchantPath()}`, requestData, options) as Promise<PostIdentitiesRolesMerchantFetchResponse>;
}

export type PostIdentitiesRolesIdentityUserPublicIDAffiliateCodeFetchResponse = 
| FetchResponse<AffiliateReferrerDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postIdentitiesRolesIdentityUserPublicIDAffiliateCodePath = (identityUserPublicID: string) => `/api/identities/roles/${identityUserPublicID}/affiliate-code`;

export const postIdentitiesRolesIdentityUserPublicIDAffiliateCode = (requestContract: ApplyAffiliateCodeRequest, identityUserPublicID: string, options?: FetchArgsOptions):
  Promise<PostIdentitiesRolesIdentityUserPublicIDAffiliateCodeFetchResponse> => {
    const requestData = getApiRequestData<ApplyAffiliateCodeRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postIdentitiesRolesIdentityUserPublicIDAffiliateCodePath(identityUserPublicID)}`, requestData, options) as Promise<PostIdentitiesRolesIdentityUserPublicIDAffiliateCodeFetchResponse>;
}

export type PostIdentitiesRolesIdentityUserPublicIDCompleteFetchResponse = 
| FetchResponse<CompleteRoleOnboardingResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postIdentitiesRolesIdentityUserPublicIDCompletePath = (identityUserPublicID: string) => `/api/identities/roles/${identityUserPublicID}/complete`;

export const postIdentitiesRolesIdentityUserPublicIDComplete = (identityUserPublicID: string, options?: FetchArgsOptions):
  Promise<PostIdentitiesRolesIdentityUserPublicIDCompleteFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postIdentitiesRolesIdentityUserPublicIDCompletePath(identityUserPublicID)}`, requestData, options) as Promise<PostIdentitiesRolesIdentityUserPublicIDCompleteFetchResponse>;
}

export type GetInvitationsFetchResponse = 
| FetchResponse<MyInvitationsResult, 200> 
| ErrorResponse;

export const getInvitationsPath = () => `/api/invitations`;

export const getInvitations = (options?: FetchArgsOptions):
  Promise<GetInvitationsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getInvitationsPath()}`, options, {}) as Promise<GetInvitationsFetchResponse>;
}

export type PostInvitationsPublicIDAcceptFetchResponse = 
| FetchResponse<AcceptInvitationResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postInvitationsPublicIDAcceptPath = (publicID: string) => `/api/invitations/${publicID}/accept`;

export const postInvitationsPublicIDAccept = (publicID: string, options?: FetchArgsOptions):
  Promise<PostInvitationsPublicIDAcceptFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvitationsPublicIDAcceptPath(publicID)}`, requestData, options) as Promise<PostInvitationsPublicIDAcceptFetchResponse>;
}

export type PostInvitationsPublicIDDeclineFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postInvitationsPublicIDDeclinePath = (publicID: string) => `/api/invitations/${publicID}/decline`;

export const postInvitationsPublicIDDecline = (publicID: string, options?: FetchArgsOptions):
  Promise<PostInvitationsPublicIDDeclineFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvitationsPublicIDDeclinePath(publicID)}`, requestData, options) as Promise<PostInvitationsPublicIDDeclineFetchResponse>;
}

export type GetInvoicesFetchResponse = 
| FetchResponse<EntityListOfInvoiceListItemDto, 200> 
| ErrorResponse;

export const getInvoicesPath = () => `/api/invoices`;

export const getInvoices = (options?: FetchArgsOptions):
  Promise<GetInvoicesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getInvoicesPath()}`, options, {}) as Promise<GetInvoicesFetchResponse>;
}

export type PostInvoicesCreateInvoiceFetchResponse = 
| FetchResponse<CreateInvoiceCommandResult, 200> 
| ErrorResponse;

export const postInvoicesCreateInvoicePath = () => `/api/invoices/create-invoice`;

export const postInvoicesCreateInvoice = (requestContract: CreateInvoiceRequest, options?: FetchArgsOptions):
  Promise<PostInvoicesCreateInvoiceFetchResponse> => {
    const requestData = getApiRequestData<CreateInvoiceRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postInvoicesCreateInvoicePath()}`, requestData, options) as Promise<PostInvoicesCreateInvoiceFetchResponse>;
}

export type PostInvoicesGetInvoiceRateChangeFetchResponse = 
| FetchResponse<GetInvoiceRateChangeDetailQueryResult, 200> 
| ErrorResponse;

export const postInvoicesGetInvoiceRateChangePath = () => `/api/invoices/get-invoice-rate-change`;

export const postInvoicesGetInvoiceRateChange = (requestContract: GetInvoiceRateChangeDetailQuery, options?: FetchArgsOptions):
  Promise<PostInvoicesGetInvoiceRateChangeFetchResponse> => {
    const requestData = getApiRequestData<GetInvoiceRateChangeDetailQuery>(requestContract, false);

    return apiPost(`${getApiUrl()}${postInvoicesGetInvoiceRateChangePath()}`, requestData, options) as Promise<PostInvoicesGetInvoiceRateChangeFetchResponse>;
}

export type PostInvoicesProcessInvoiceRateChangeFetchResponse = 
| FetchResponse<ProcessInvoiceRateChangeCommandResult, 200> 
| ErrorResponse;

export const postInvoicesProcessInvoiceRateChangePath = () => `/api/invoices/process-invoice-rate-change`;

export const postInvoicesProcessInvoiceRateChange = (requestContract: ProcessInvoiceRateChangeRequest, options?: FetchArgsOptions):
  Promise<PostInvoicesProcessInvoiceRateChangeFetchResponse> => {
    const requestData = getApiRequestData<ProcessInvoiceRateChangeRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postInvoicesProcessInvoiceRateChangePath()}`, requestData, options) as Promise<PostInvoicesProcessInvoiceRateChangeFetchResponse>;
}

export type PostInvoicesDownloadEmployeeGuideFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postInvoicesDownloadEmployeeGuidePath = () => `/api/invoices/download-employee-guide`;

export const postInvoicesDownloadEmployeeGuide = (options?: FetchArgsOptions):
  Promise<PostInvoicesDownloadEmployeeGuideFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvoicesDownloadEmployeeGuidePath()}`, requestData, options) as Promise<PostInvoicesDownloadEmployeeGuideFetchResponse>;
}

export type PostInvoicesGetInvoiceSettingsFetchResponse = 
| FetchResponse<InvoiceSettingsDto, 200> 
| ErrorResponse;

export const postInvoicesGetInvoiceSettingsPath = () => `/api/invoices/get-invoice-settings`;

export const postInvoicesGetInvoiceSettings = (options?: FetchArgsOptions):
  Promise<PostInvoicesGetInvoiceSettingsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvoicesGetInvoiceSettingsPath()}`, requestData, options) as Promise<PostInvoicesGetInvoiceSettingsFetchResponse>;
}

export type PostInvoicesSaveInvoiceSettingsFetchResponse = 
| FetchResponse<SaveInvoiceSettingsCommandResult, 200> 
| ErrorResponse;

export const postInvoicesSaveInvoiceSettingsPath = () => `/api/invoices/save-invoice-settings`;

export const postInvoicesSaveInvoiceSettings = (requestContract: InvoiceSettingsDto, options?: FetchArgsOptions):
  Promise<PostInvoicesSaveInvoiceSettingsFetchResponse> => {
    const requestData = getApiRequestData<InvoiceSettingsDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postInvoicesSaveInvoiceSettingsPath()}`, requestData, options) as Promise<PostInvoicesSaveInvoiceSettingsFetchResponse>;
}

export type PostInvoicesGetUserFeeRateFetchResponse = 
| FetchResponse<GetUserFeeRateQueryResult, 200> 
| ErrorResponse;

export const postInvoicesGetUserFeeRatePath = () => `/api/invoices/get-user-fee-rate`;

export const postInvoicesGetUserFeeRate = (options?: FetchArgsOptions):
  Promise<PostInvoicesGetUserFeeRateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvoicesGetUserFeeRatePath()}`, requestData, options) as Promise<PostInvoicesGetUserFeeRateFetchResponse>;
}

export type GetInvoicesSettlementInvoicesInvoiceNumberFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const getInvoicesSettlementInvoicesInvoiceNumberPath = (invoiceNumber: number) => `/api/invoices/settlement-invoices/${invoiceNumber}`;

export const getInvoicesSettlementInvoicesInvoiceNumber = (invoiceNumber: number, format?: InvoiceFormat, options?: FetchArgsOptions):
  Promise<GetInvoicesSettlementInvoicesInvoiceNumberFetchResponse> => {
    const queryParams = {
      "format": format
    }
    return apiGet(`${getApiUrl()}${getInvoicesSettlementInvoicesInvoiceNumberPath(invoiceNumber)}`, options, queryParams) as Promise<GetInvoicesSettlementInvoicesInvoiceNumberFetchResponse>;
}

export type GetInvoicesLicenseInvoicesInvoiceNumberFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const getInvoicesLicenseInvoicesInvoiceNumberPath = (invoiceNumber: number) => `/api/invoices/license-invoices/${invoiceNumber}`;

export const getInvoicesLicenseInvoicesInvoiceNumber = (invoiceNumber: number, format?: InvoiceFormat, options?: FetchArgsOptions):
  Promise<GetInvoicesLicenseInvoicesInvoiceNumberFetchResponse> => {
    const queryParams = {
      "format": format
    }
    return apiGet(`${getApiUrl()}${getInvoicesLicenseInvoicesInvoiceNumberPath(invoiceNumber)}`, options, queryParams) as Promise<GetInvoicesLicenseInvoicesInvoiceNumberFetchResponse>;
}

export type GetInvoicesSettlementInvoicesBySettlementSettlementIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ProblemDetails, 403> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const getInvoicesSettlementInvoicesBySettlementSettlementIDPath = (settlementID: number) => `/api/invoices/settlement-invoices/by-settlement/${settlementID}`;

export const getInvoicesSettlementInvoicesBySettlementSettlementID = (settlementID: number, options?: FetchArgsOptions):
  Promise<GetInvoicesSettlementInvoicesBySettlementSettlementIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getInvoicesSettlementInvoicesBySettlementSettlementIDPath(settlementID)}`, options, {}) as Promise<GetInvoicesSettlementInvoicesBySettlementSettlementIDFetchResponse>;
}

export type PostInvoicesSettlementInvoicesInvoiceNumberRegenerateFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const postInvoicesSettlementInvoicesInvoiceNumberRegeneratePath = (invoiceNumber: number) => `/api/invoices/settlement-invoices/${invoiceNumber}/regenerate`;

export const postInvoicesSettlementInvoicesInvoiceNumberRegenerate = (invoiceNumber: number, options?: FetchArgsOptions):
  Promise<PostInvoicesSettlementInvoicesInvoiceNumberRegenerateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvoicesSettlementInvoicesInvoiceNumberRegeneratePath(invoiceNumber)}`, requestData, options) as Promise<PostInvoicesSettlementInvoicesInvoiceNumberRegenerateFetchResponse>;
}

export type GetInvoicesDownloadZipFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const getInvoicesDownloadZipPath = () => `/api/invoices/download-zip`;

export const getInvoicesDownloadZip = (settlementPeriodId?: number, type?: SettlementInvoiceType, options?: FetchArgsOptions):
  Promise<GetInvoicesDownloadZipFetchResponse> => {
    const queryParams = {
      "settlementPeriodId": settlementPeriodId,
      "type": type
    }
    return apiGet(`${getApiUrl()}${getInvoicesDownloadZipPath()}`, options, queryParams) as Promise<GetInvoicesDownloadZipFetchResponse>;
}

export type PostInvoicesLicenseLicensePublicIDSendFetchResponse = 
| FetchResponse<boolean, 200> 
| FetchResponse<ProblemDetails, 400> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const postInvoicesLicenseLicensePublicIDSendPath = (licensePublicID: string) => `/api/invoices/license/${licensePublicID}/send`;

export const postInvoicesLicenseLicensePublicIDSend = (licensePublicID: string, options?: FetchArgsOptions):
  Promise<PostInvoicesLicenseLicensePublicIDSendFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvoicesLicenseLicensePublicIDSendPath(licensePublicID)}`, requestData, options) as Promise<PostInvoicesLicenseLicensePublicIDSendFetchResponse>;
}

export type PostInvoicesLicenseLicensePublicIDRegenerateFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ProblemDetails, 404> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const postInvoicesLicenseLicensePublicIDRegeneratePath = (licensePublicID: string) => `/api/invoices/license/${licensePublicID}/regenerate`;

export const postInvoicesLicenseLicensePublicIDRegenerate = (licensePublicID: string, options?: FetchArgsOptions):
  Promise<PostInvoicesLicenseLicensePublicIDRegenerateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInvoicesLicenseLicensePublicIDRegeneratePath(licensePublicID)}`, requestData, options) as Promise<PostInvoicesLicenseLicensePublicIDRegenerateFetchResponse>;
}

export type GetWellKnownJwksJsonFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getWellKnownJwksJsonPath = () => `/.well-known/jwks.json`;

export const getWellKnownJwksJson = (env?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetWellKnownJwksJsonFetchResponse> => {
    const queryParams = {
      "env": env
    }
    return apiGet(`${getApiUrl()}${getWellKnownJwksJsonPath()}`, options, queryParams) as Promise<GetWellKnownJwksJsonFetchResponse>;
}

export type GetLeadsFetchResponse = 
| FetchResponse<EntityListOfLeadDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const getLeadsPath = () => `/api/leads`;

export const getLeads = (offset?: number, limit?: number, leadStatus?: LeadStatus, invitedAsRole?: string | undefined | null, registeredAsRole?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetLeadsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "leadStatus": leadStatus,
      "invitedAsRole": invitedAsRole,
      "registeredAsRole": registeredAsRole
    }
    return apiGet(`${getApiUrl()}${getLeadsPath()}`, options, queryParams) as Promise<GetLeadsFetchResponse>;
}

export type GetLeadsAffiliateLinkFetchResponse = 
| FetchResponse<AffiliateDataDto, 200> 
| ErrorResponse;

export const getLeadsAffiliateLinkPath = () => `/api/leads/affiliate-link`;

export const getLeadsAffiliateLink = (userRole?: string, options?: FetchArgsOptions):
  Promise<GetLeadsAffiliateLinkFetchResponse> => {
    const queryParams = {
      "userRole": userRole
    }
    return apiGet(`${getApiUrl()}${getLeadsAffiliateLinkPath()}`, options, queryParams) as Promise<GetLeadsAffiliateLinkFetchResponse>;
}

export type PostLeadsInviteFetchResponse = 
| FetchResponse<LeadInvitationCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postLeadsInvitePath = () => `/api/leads/invite`;

export const postLeadsInvite = (requestContract: InviteLeadRequest, options?: FetchArgsOptions):
  Promise<PostLeadsInviteFetchResponse> => {
    const requestData = getApiRequestData<InviteLeadRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLeadsInvitePath()}`, requestData, options) as Promise<PostLeadsInviteFetchResponse>;
}

export type PutLeadsThanksToYouParticipationFetchResponse = 
| FetchResponse<SetThanksToYouParticipationResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putLeadsThanksToYouParticipationPath = () => `/api/leads/thanks-to-you-participation`;

export const putLeadsThanksToYouParticipation = (requestContract: SetThanksToYouParticipationCommand, options?: FetchArgsOptions):
  Promise<PutLeadsThanksToYouParticipationFetchResponse> => {
    const requestData = getApiRequestData<SetThanksToYouParticipationCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putLeadsThanksToYouParticipationPath()}`, requestData, options) as Promise<PutLeadsThanksToYouParticipationFetchResponse>;
}

export type PostLeadsThanksToYouWithdrawalRequestsFetchResponse = 
| FetchResponse<RequestThanksToYouWithdrawalResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postLeadsThanksToYouWithdrawalRequestsPath = () => `/api/leads/thanks-to-you-withdrawal-requests`;

export const postLeadsThanksToYouWithdrawalRequests = (options?: FetchArgsOptions):
  Promise<PostLeadsThanksToYouWithdrawalRequestsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postLeadsThanksToYouWithdrawalRequestsPath()}`, requestData, options) as Promise<PostLeadsThanksToYouWithdrawalRequestsFetchResponse>;
}

export type PostLeadsThanksToYouWithdrawalRequestsTokenConfirmationFetchResponse = 
| FetchResponse<ConfirmThanksToYouWithdrawalResult, 200> 
| ErrorResponse;

export const postLeadsThanksToYouWithdrawalRequestsTokenConfirmationPath = (token: string) => `/api/leads/thanks-to-you-withdrawal-requests/${token}/confirmation`;

export const postLeadsThanksToYouWithdrawalRequestsTokenConfirmation = (token: string, options?: FetchArgsOptions):
  Promise<PostLeadsThanksToYouWithdrawalRequestsTokenConfirmationFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postLeadsThanksToYouWithdrawalRequestsTokenConfirmationPath(token)}`, requestData, options) as Promise<PostLeadsThanksToYouWithdrawalRequestsTokenConfirmationFetchResponse>;
}

export type PutLeadsAffiliateMerchantLicenseFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putLeadsAffiliateMerchantLicensePath = () => `/api/leads/affiliate-merchant-license`;

export const putLeadsAffiliateMerchantLicense = (requestContract: SetDefaultAffiliateLicenseRequest, options?: FetchArgsOptions):
  Promise<PutLeadsAffiliateMerchantLicenseFetchResponse> => {
    const requestData = getApiRequestData<SetDefaultAffiliateLicenseRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putLeadsAffiliateMerchantLicensePath()}`, requestData, options) as Promise<PutLeadsAffiliateMerchantLicenseFetchResponse>;
}

export type GetLeadsAffiliateCodesCodeFetchResponse = 
| FetchResponse<AffiliateCodeVerificationDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLeadsAffiliateCodesCodePath = (code: string) => `/api/leads/affiliate-codes/${code}`;

export const getLeadsAffiliateCodesCode = (code: string, role?: string, options?: FetchArgsOptions):
  Promise<GetLeadsAffiliateCodesCodeFetchResponse> => {
    const queryParams = {
      "role": role
    }
    return apiGet(`${getApiUrl()}${getLeadsAffiliateCodesCodePath(code)}`, options, queryParams) as Promise<GetLeadsAffiliateCodesCodeFetchResponse>;
}

export type GetLeadsReferrerFetchResponse = 
| FetchResponse<AffiliateReferrerDto, 200> 
| ErrorResponse;

export const getLeadsReferrerPath = () => `/api/leads/referrer`;

export const getLeadsReferrer = (role?: string, options?: FetchArgsOptions):
  Promise<GetLeadsReferrerFetchResponse> => {
    const queryParams = {
      "role": role
    }
    return apiGet(`${getApiUrl()}${getLeadsReferrerPath()}`, options, queryParams) as Promise<GetLeadsReferrerFetchResponse>;
}

export type PostLeadsReferrerFetchResponse = 
| FetchResponse<AffiliateReferrerDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postLeadsReferrerPath = () => `/api/leads/referrer`;

export const postLeadsReferrer = (requestContract: ApplyAffiliateCodeRequest, options?: FetchArgsOptions):
  Promise<PostLeadsReferrerFetchResponse> => {
    const requestData = getApiRequestData<ApplyAffiliateCodeRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLeadsReferrerPath()}`, requestData, options) as Promise<PostLeadsReferrerFetchResponse>;
}

export type GetLeadsAffiliateEarningsFetchResponse = 
| FetchResponse<AffiliateEarningsSummaryDto, 200> 
| ErrorResponse;

export const getLeadsAffiliateEarningsPath = () => `/api/leads/affiliate-earnings`;

export const getLeadsAffiliateEarnings = (options?: FetchArgsOptions):
  Promise<GetLeadsAffiliateEarningsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLeadsAffiliateEarningsPath()}`, options, {}) as Promise<GetLeadsAffiliateEarningsFetchResponse>;
}

export type GetLeadsCampaignsFetchResponse = 
| FetchResponse<EntityListOfCampaignDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLeadsCampaignsPath = () => `/api/leads/campaigns`;

export const getLeadsCampaigns = (pageSize?: number, pageNumber?: number, options?: FetchArgsOptions):
  Promise<GetLeadsCampaignsFetchResponse> => {
    const queryParams = {
      "pageSize": pageSize,
      "pageNumber": pageNumber
    }
    return apiGet(`${getApiUrl()}${getLeadsCampaignsPath()}`, options, queryParams) as Promise<GetLeadsCampaignsFetchResponse>;
}

export type GetLeadsCampaignsCodeUsersFetchResponse = 
| FetchResponse<EntityListOfCampaignUserDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLeadsCampaignsCodeUsersPath = (code: string) => `/api/leads/campaigns/${code}/users`;

export const getLeadsCampaignsCodeUsers = (code: string, options?: FetchArgsOptions):
  Promise<GetLeadsCampaignsCodeUsersFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLeadsCampaignsCodeUsersPath(code)}`, options, {}) as Promise<GetLeadsCampaignsCodeUsersFetchResponse>;
}

export type PostLeadsCampaignsCodeUsersFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postLeadsCampaignsCodeUsersPath = (code: string) => `/api/leads/campaigns/${code}/users`;

export const postLeadsCampaignsCodeUsers = (code: string, options?: FetchArgsOptions):
  Promise<PostLeadsCampaignsCodeUsersFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postLeadsCampaignsCodeUsersPath(code)}`, requestData, options) as Promise<PostLeadsCampaignsCodeUsersFetchResponse>;
}

export type PostLogErrorFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postLogErrorPath = () => `/api/Log/Error`;

export const postLogError = (requestContract: ErrorWebLogCommand, options?: FetchArgsOptions):
  Promise<PostLogErrorFetchResponse> => {
    const requestData = getApiRequestData<ErrorWebLogCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLogErrorPath()}`, requestData, options) as Promise<PostLogErrorFetchResponse>;
}

export type GetLogTestExceptionLoggingFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getLogTestExceptionLoggingPath = () => `/api/Log/test-exception-logging`;

export const getLogTestExceptionLogging = (options?: FetchArgsOptions):
  Promise<GetLogTestExceptionLoggingFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLogTestExceptionLoggingPath()}`, options, {}) as Promise<GetLogTestExceptionLoggingFetchResponse>;
}

export type GetLogTestExceptionLoggerLoggingFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getLogTestExceptionLoggerLoggingPath = () => `/api/Log/test-exception-logger-logging`;

export const getLogTestExceptionLoggerLogging = (options?: FetchArgsOptions):
  Promise<GetLogTestExceptionLoggerLoggingFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLogTestExceptionLoggerLoggingPath()}`, options, {}) as Promise<GetLogTestExceptionLoggerLoggingFetchResponse>;
}

export type GetMerchantsFetchResponse = 
| FetchResponse<EntityListOfMerchantListItemDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPath = () => `/api/merchants`;

export const getMerchants = (OwnOnly?: boolean, Statuses?: string[] | undefined | null, RegistrationSource?: string | undefined | null, LicensePublicID?: string | undefined | null, ViewMode?: MerchantViewMode, CompanyName?: string | undefined | null, CompanyNumber?: string | undefined | null, LicenseOwnerName?: string | undefined | null, LicenseNumber?: string | undefined | null, LicenseCodes?: string[] | undefined | null, DateCreatedFrom?: string | undefined | null, DateCreatedTo?: string | undefined | null, Phone?: string | undefined | null, Email?: string | undefined | null, TransactionsCountFrom?: number | undefined | null, SettlementStatus?: SettlementStatus | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetMerchantsFetchResponse> => {
    const queryParams = {
      "OwnOnly": OwnOnly,
      "Statuses": Statuses,
      "RegistrationSource": RegistrationSource,
      "LicensePublicID": LicensePublicID,
      "ViewMode": ViewMode,
      "CompanyName": CompanyName,
      "CompanyNumber": CompanyNumber,
      "LicenseOwnerName": LicenseOwnerName,
      "LicenseNumber": LicenseNumber,
      "LicenseCodes": LicenseCodes,
      "DateCreatedFrom": DateCreatedFrom,
      "DateCreatedTo": DateCreatedTo,
      "Phone": Phone,
      "Email": Email,
      "TransactionsCountFrom": TransactionsCountFrom,
      "SettlementStatus": SettlementStatus,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getMerchantsPath()}`, options, queryParams) as Promise<GetMerchantsFetchResponse>;
}

export type PostMerchantsFetchResponse = 
| FetchResponse<MerchantDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPath = () => `/api/merchants`;

export const postMerchants = (requestContract: CreateMerchantRequest, options?: FetchArgsOptions):
  Promise<PostMerchantsFetchResponse> => {
    const requestData = getApiRequestData<CreateMerchantRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPath()}`, requestData, options) as Promise<PostMerchantsFetchResponse>;
}

export type GetMerchantsStatsFetchResponse = 
| FetchResponse<MerchantStatsDto, 200> 
| ErrorResponse;

export const getMerchantsStatsPath = () => `/api/merchants/stats`;

export const getMerchantsStats = (ownOnly?: boolean, options?: FetchArgsOptions):
  Promise<GetMerchantsStatsFetchResponse> => {
    const queryParams = {
      "ownOnly": ownOnly
    }
    return apiGet(`${getApiUrl()}${getMerchantsStatsPath()}`, options, queryParams) as Promise<GetMerchantsStatsFetchResponse>;
}

export type GetMerchantsPublicIDDetailFetchResponse = 
| FetchResponse<MerchantDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDDetailPath = (publicID: string) => `/api/merchants/${publicID}/detail`;

export const getMerchantsPublicIDDetail = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDDetailFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDDetailPath(publicID)}`, options, {}) as Promise<GetMerchantsPublicIDDetailFetchResponse>;
}

export type GetMerchantsDetailFetchResponse = 
| FetchResponse<MerchantDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsDetailPath = () => `/api/merchants/detail`;

export const getMerchantsDetail = (publicID?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetMerchantsDetailFetchResponse> => {
    const queryParams = {
      "publicID": publicID
    }
    return apiGet(`${getApiUrl()}${getMerchantsDetailPath()}`, options, queryParams) as Promise<GetMerchantsDetailFetchResponse>;
}

export type PutMerchantsPublicIDStatusFetchResponse = 
| FetchResponse<MerchantBaseDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDStatusPath = (publicID: string) => `/api/merchants/${publicID}/status`;

export const putMerchantsPublicIDStatus = (body: string, publicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDStatusFetchResponse> => {
    const requestData = getApiRequestData<string>(body, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDStatusPath(publicID)}`, requestData, options) as Promise<PutMerchantsPublicIDStatusFetchResponse>;
}

export type GetMerchantsHunterAvailableTerminalsFetchResponse = 
| FetchResponse<HunterAvailableTerminalsDto, 200> 
| ErrorResponse;

export const getMerchantsHunterAvailableTerminalsPath = () => `/api/merchants/hunter-available-terminals`;

export const getMerchantsHunterAvailableTerminals = (options?: FetchArgsOptions):
  Promise<GetMerchantsHunterAvailableTerminalsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsHunterAvailableTerminalsPath()}`, options, {}) as Promise<GetMerchantsHunterAvailableTerminalsFetchResponse>;
}

export type PostMerchantsPublicIDFeesFetchResponse = 
| FetchResponse<MerchantFeeDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDFeesPath = (publicID: string) => `/api/merchants/${publicID}/fees`;

export const postMerchantsPublicIDFees = (requestContract: CreateMerchantFeeDto, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDFeesFetchResponse> => {
    const requestData = getApiRequestData<CreateMerchantFeeDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDFeesPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDFeesFetchResponse>;
}

export type PutMerchantsPublicIDFeesFetchResponse = 
| FetchResponse<MerchantFeeDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDFeesPath = (publicID: string) => `/api/merchants/${publicID}/fees`;

export const putMerchantsPublicIDFees = (requestContract: UpdateMerchantFeeDto, publicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDFeesFetchResponse> => {
    const requestData = getApiRequestData<UpdateMerchantFeeDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDFeesPath(publicID)}`, requestData, options) as Promise<PutMerchantsPublicIDFeesFetchResponse>;
}

export type PutMerchantsPublicIDNoteFetchResponse = 
| FetchResponse<MerchantDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDNotePath = (publicID: string) => `/api/merchants/${publicID}/note`;

export const putMerchantsPublicIDNote = (body: string, publicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDNoteFetchResponse> => {
    const requestData = getApiRequestData<string>(body, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDNotePath(publicID)}`, requestData, options) as Promise<PutMerchantsPublicIDNoteFetchResponse>;
}

export type DeleteMerchantsPublicIDAvatarFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDAvatarPath = (publicID: string) => `/api/merchants/${publicID}/avatar`;

export const deleteMerchantsPublicIDAvatar = (publicID: string, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDAvatarFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDAvatarPath(publicID)}`, options, {}) as Promise<DeleteMerchantsPublicIDAvatarFetchResponse>;
}

export type PutMerchantsPublicIDAvatarFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDAvatarPath = (publicID: string) => `/api/merchants/${publicID}/avatar`;

export const putMerchantsPublicIDAvatar = (publicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDAvatarFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDAvatarPath(publicID)}`, requestData, options) as Promise<PutMerchantsPublicIDAvatarFetchResponse>;
}

export type DeleteMerchantsPublicIDFacilitiesFacilityPublicIDLogoFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDFacilitiesFacilityPublicIDLogoPath = (publicID: string, facilityPublicID: string) => `/api/merchants/${publicID}/facilities/${facilityPublicID}/logo`;

export const deleteMerchantsPublicIDFacilitiesFacilityPublicIDLogo = (publicID: string, facilityPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDFacilitiesFacilityPublicIDLogoFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDFacilitiesFacilityPublicIDLogoPath(publicID, facilityPublicID)}`, options, {}) as Promise<DeleteMerchantsPublicIDFacilitiesFacilityPublicIDLogoFetchResponse>;
}

export type PutMerchantsPublicIDFacilitiesFacilityPublicIDLogoFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDFacilitiesFacilityPublicIDLogoPath = (publicID: string, facilityPublicID: string) => `/api/merchants/${publicID}/facilities/${facilityPublicID}/logo`;

export const putMerchantsPublicIDFacilitiesFacilityPublicIDLogo = (publicID: string, facilityPublicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDFacilitiesFacilityPublicIDLogoFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDFacilitiesFacilityPublicIDLogoPath(publicID, facilityPublicID)}`, requestData, options) as Promise<PutMerchantsPublicIDFacilitiesFacilityPublicIDLogoFetchResponse>;
}

export type GetMerchantsFacilitiesFacilityPublicIDLogoFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsFacilitiesFacilityPublicIDLogoPath = (facilityPublicID: string) => `/api/merchants/facilities/${facilityPublicID}/logo`;

export const getMerchantsFacilitiesFacilityPublicIDLogo = (facilityPublicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsFacilitiesFacilityPublicIDLogoFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsFacilitiesFacilityPublicIDLogoPath(facilityPublicID)}`, options, {}) as Promise<GetMerchantsFacilitiesFacilityPublicIDLogoFetchResponse>;
}

export type PostMerchantsPublicIDFacilitiesFetchResponse = 
| FetchResponse<MerchantFacilityDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDFacilitiesPath = (publicID: string) => `/api/merchants/${publicID}/facilities`;

export const postMerchantsPublicIDFacilities = (requestContract: CreateMerchantFacilityDto, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDFacilitiesFetchResponse> => {
    const requestData = getApiRequestData<CreateMerchantFacilityDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDFacilitiesPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDFacilitiesFetchResponse>;
}

export type PutMerchantsPublicIDFacilitiesFetchResponse = 
| FetchResponse<MerchantFacilityDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDFacilitiesPath = (publicID: string) => `/api/merchants/${publicID}/facilities`;

export const putMerchantsPublicIDFacilities = (requestContract: MerchantFacilityDto, publicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDFacilitiesFetchResponse> => {
    const requestData = getApiRequestData<MerchantFacilityDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDFacilitiesPath(publicID)}`, requestData, options) as Promise<PutMerchantsPublicIDFacilitiesFetchResponse>;
}

export type GetMerchantsPublicIDFacilitiesFacilityPublicIDPhotosFetchResponse = 
| FetchResponse<FacilityPhotosDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPath = (publicID: string, facilityPublicID: string) => `/api/merchants/${publicID}/facilities/${facilityPublicID}/photos`;

export const getMerchantsPublicIDFacilitiesFacilityPublicIDPhotos = (publicID: string, facilityPublicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDFacilitiesFacilityPublicIDPhotosFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPath(publicID, facilityPublicID)}`, options, {}) as Promise<GetMerchantsPublicIDFacilitiesFacilityPublicIDPhotosFetchResponse>;
}

export type PostMerchantsPublicIDFacilitiesFacilityPublicIDPhotosFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPath = (publicID: string, facilityPublicID: string) => `/api/merchants/${publicID}/facilities/${facilityPublicID}/photos`;

export const postMerchantsPublicIDFacilitiesFacilityPublicIDPhotos = (publicID: string, facilityPublicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDFacilitiesFacilityPublicIDPhotosFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPath(publicID, facilityPublicID)}`, requestData, options) as Promise<PostMerchantsPublicIDFacilitiesFacilityPublicIDPhotosFetchResponse>;
}

export type DeleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoTypeFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoTypePath = (publicID: string, facilityPublicID: string, photoType: FacilityPhotoType) => `/api/merchants/${publicID}/facilities/${facilityPublicID}/photos/${photoType}`;

export const deleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoType = (publicID: string, facilityPublicID: string, photoType: FacilityPhotoType, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoTypeFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoTypePath(publicID, facilityPublicID, photoType)}`, options, {}) as Promise<DeleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoTypeFetchResponse>;
}

export type DeleteMerchantsPublicIDFacilitiesFacilityPublicIDFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDFacilitiesFacilityPublicIDPath = (publicID: string, facilityPublicID: string) => `/api/merchants/${publicID}/facilities/${facilityPublicID}`;

export const deleteMerchantsPublicIDFacilitiesFacilityPublicID = (publicID: string, facilityPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDFacilitiesFacilityPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDFacilitiesFacilityPublicIDPath(publicID, facilityPublicID)}`, options, {}) as Promise<DeleteMerchantsPublicIDFacilitiesFacilityPublicIDFetchResponse>;
}

export type PostMerchantsPublicIDSendAccessFetchResponse = 
| FetchResponse<MerchantBaseDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDSendAccessPath = (publicID: string) => `/api/merchants/${publicID}/send-access`;

export const postMerchantsPublicIDSendAccess = (requestContract: SendMerchantAccessRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDSendAccessFetchResponse> => {
    const requestData = getApiRequestData<SendMerchantAccessRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDSendAccessPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDSendAccessFetchResponse>;
}

export type PostMerchantsPublicIDCancelAccessFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDCancelAccessPath = (publicID: string) => `/api/merchants/${publicID}/cancel-access`;

export const postMerchantsPublicIDCancelAccess = (publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDCancelAccessFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDCancelAccessPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDCancelAccessFetchResponse>;
}

export type GetMerchantsPublicIDTerminalContractsFetchResponse = 
| FetchResponse<EntityListOfMerchantTerminalContractBase, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDTerminalContractsPath = (publicID: string) => `/api/merchants/${publicID}/terminal-contracts`;

export const getMerchantsPublicIDTerminalContracts = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDTerminalContractsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDTerminalContractsPath(publicID)}`, options, {}) as Promise<GetMerchantsPublicIDTerminalContractsFetchResponse>;
}

export type PostMerchantsPublicIDTerminalContractsFetchResponse = 
| FetchResponse<MerchantTerminalContractDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDTerminalContractsPath = (publicID: string) => `/api/merchants/${publicID}/terminal-contracts`;

export const postMerchantsPublicIDTerminalContracts = (requestContract: CreateMerchantTerminalContractDto, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDTerminalContractsFetchResponse> => {
    const requestData = getApiRequestData<CreateMerchantTerminalContractDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDTerminalContractsPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDTerminalContractsFetchResponse>;
}

export type GetMerchantsTerminalContractsFetchResponse = 
| FetchResponse<EntityListOfMerchantTerminalContractBase, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsTerminalContractsPath = () => `/api/merchants/terminal-contracts`;

export const getMerchantsTerminalContracts = (options?: FetchArgsOptions):
  Promise<GetMerchantsTerminalContractsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsTerminalContractsPath()}`, options, {}) as Promise<GetMerchantsTerminalContractsFetchResponse>;
}

export type GetMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse = 
| FetchResponse<MerchantTerminalContractDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDTerminalContractsTerminalContractPublicIDPath = (publicID: string, terminalContractPublicID: string) => `/api/merchants/${publicID}/terminal-contracts/${terminalContractPublicID}`;

export const getMerchantsPublicIDTerminalContractsTerminalContractPublicID = (publicID: string, terminalContractPublicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDTerminalContractsTerminalContractPublicIDPath(publicID, terminalContractPublicID)}`, options, {}) as Promise<GetMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse>;
}

export type DeleteMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDTerminalContractsTerminalContractPublicIDPath = (publicID: string, terminalContractPublicID: string) => `/api/merchants/${publicID}/terminal-contracts/${terminalContractPublicID}`;

export const deleteMerchantsPublicIDTerminalContractsTerminalContractPublicID = (publicID: string, terminalContractPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDTerminalContractsTerminalContractPublicIDPath(publicID, terminalContractPublicID)}`, options, {}) as Promise<DeleteMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse>;
}

export type PutMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse = 
| FetchResponse<UpdateMerchantTerminalContractCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsPublicIDTerminalContractsTerminalContractPublicIDPath = (publicID: string, terminalContractPublicID: string) => `/api/merchants/${publicID}/terminal-contracts/${terminalContractPublicID}`;

export const putMerchantsPublicIDTerminalContractsTerminalContractPublicID = (requestContract: UpdateMerchantTerminalContractCommandRequest, publicID: string, terminalContractPublicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse> => {
    const requestData = getApiRequestData<UpdateMerchantTerminalContractCommandRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDTerminalContractsTerminalContractPublicIDPath(publicID, terminalContractPublicID)}`, requestData, options) as Promise<PutMerchantsPublicIDTerminalContractsTerminalContractPublicIDFetchResponse>;
}

export type GetMerchantsPublicIDTerminalContractsTerminalContractPublicIDContractFileFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsPublicIDTerminalContractsTerminalContractPublicIDContractFilePath = (publicID: string, terminalContractPublicID: string) => `/api/merchants/${publicID}/terminal-contracts/${terminalContractPublicID}/contract-file`;

export const getMerchantsPublicIDTerminalContractsTerminalContractPublicIDContractFile = (publicID: string, terminalContractPublicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDTerminalContractsTerminalContractPublicIDContractFileFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDTerminalContractsTerminalContractPublicIDContractFilePath(publicID, terminalContractPublicID)}`, options, {}) as Promise<GetMerchantsPublicIDTerminalContractsTerminalContractPublicIDContractFileFetchResponse>;
}

export type PostMerchantsPublicIDTerminalContractsTerminalContractPublicIDSubmitComgateFetchResponse = 
| FetchResponse<SubmitComgateOnboardingResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDTerminalContractsTerminalContractPublicIDSubmitComgatePath = (publicID: string, terminalContractPublicID: string) => `/api/merchants/${publicID}/terminal-contracts/${terminalContractPublicID}/submit-comgate`;

export const postMerchantsPublicIDTerminalContractsTerminalContractPublicIDSubmitComgate = (publicID: string, terminalContractPublicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDTerminalContractsTerminalContractPublicIDSubmitComgateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDTerminalContractsTerminalContractPublicIDSubmitComgatePath(publicID, terminalContractPublicID)}`, requestData, options) as Promise<PostMerchantsPublicIDTerminalContractsTerminalContractPublicIDSubmitComgateFetchResponse>;
}

export type GetMerchantsPublicIDOrbitLStatusFetchResponse = 
| FetchResponse<OrbitLStatusDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDOrbitLStatusPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/status`;

export const getMerchantsPublicIDOrbitLStatus = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDOrbitLStatusFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDOrbitLStatusPath(publicID)}`, options, {}) as Promise<GetMerchantsPublicIDOrbitLStatusFetchResponse>;
}

export type GetMerchantsPublicIDOrbitLContractFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDOrbitLContractPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/contract`;

export const getMerchantsPublicIDOrbitLContract = (publicID: string, contractType?: OrbitLContractType, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDOrbitLContractFetchResponse> => {
    const queryParams = {
      "contractType": contractType
    }
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDOrbitLContractPath(publicID)}`, options, queryParams) as Promise<GetMerchantsPublicIDOrbitLContractFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLSubmitFetchResponse = 
| FetchResponse<SubmitOrbitLOrderResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLSubmitPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/submit`;

export const postMerchantsPublicIDOrbitLSubmit = (publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLSubmitFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLSubmitPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLSubmitFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLConfirmHandoverFetchResponse = 
| FetchResponse<ConfirmOrbitLHandoverResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLConfirmHandoverPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/confirm-handover`;

export const postMerchantsPublicIDOrbitLConfirmHandover = (publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLConfirmHandoverFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLConfirmHandoverPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLConfirmHandoverFetchResponse>;
}

export type GetMerchantsPublicIDOrbitLHunterTerminalsFetchResponse = 
| FetchResponse<HunterTerminalsForReservationResult, 200> 
| ErrorResponse;

export const getMerchantsPublicIDOrbitLHunterTerminalsPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/hunter-terminals`;

export const getMerchantsPublicIDOrbitLHunterTerminals = (publicID: string, facilityPublicID?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDOrbitLHunterTerminalsFetchResponse> => {
    const queryParams = {
      "facilityPublicID": facilityPublicID
    }
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDOrbitLHunterTerminalsPath(publicID)}`, options, queryParams) as Promise<GetMerchantsPublicIDOrbitLHunterTerminalsFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLReserveTerminalsFetchResponse = 
| FetchResponse<ReserveTerminalsResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLReserveTerminalsPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/reserve-terminals`;

export const postMerchantsPublicIDOrbitLReserveTerminals = (requestContract: ReserveTerminalsRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLReserveTerminalsFetchResponse> => {
    const requestData = getApiRequestData<ReserveTerminalsRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLReserveTerminalsPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLReserveTerminalsFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLTerminalCountChangeRequestFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLTerminalCountChangeRequestPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/terminal-count-change-request`;

export const postMerchantsPublicIDOrbitLTerminalCountChangeRequest = (requestContract: RequestTerminalCountChangeDto, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLTerminalCountChangeRequestFetchResponse> => {
    const requestData = getApiRequestData<RequestTerminalCountChangeDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLTerminalCountChangeRequestPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLTerminalCountChangeRequestFetchResponse>;
}

export type PutMerchantsOrbitLTerminalCountChangeRequestRequestGroupIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putMerchantsOrbitLTerminalCountChangeRequestRequestGroupIDPath = (requestGroupID: string) => `/api/merchants/orbit-l/terminal-count-change-request/${requestGroupID}`;

export const putMerchantsOrbitLTerminalCountChangeRequestRequestGroupID = (requestContract: ResolveTerminalCountChangeRequestDto, requestGroupID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsOrbitLTerminalCountChangeRequestRequestGroupIDFetchResponse> => {
    const requestData = getApiRequestData<ResolveTerminalCountChangeRequestDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putMerchantsOrbitLTerminalCountChangeRequestRequestGroupIDPath(requestGroupID)}`, requestData, options) as Promise<PutMerchantsOrbitLTerminalCountChangeRequestRequestGroupIDFetchResponse>;
}

export type GetMerchantsOrbitLOnboardingListFetchResponse = 
| FetchResponse<EntityListOfOrbitLOnboardingListItemDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsOrbitLOnboardingListPath = () => `/api/merchants/orbit-l/onboarding-list`;

export const getMerchantsOrbitLOnboardingList = (CompanyName?: string | undefined | null, CompanyNumber?: string | undefined | null, HunterName?: string | undefined | null, ComgateMID?: string | undefined | null, ComgateStatuses?: string[] | undefined | null, FinancingModels?: string[] | undefined | null, OrbitLPhases?: string[] | undefined | null, HasOpenTerminalCountRequest?: boolean | undefined | null, ActivatedFrom?: string | undefined | null, ActivatedTo?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetMerchantsOrbitLOnboardingListFetchResponse> => {
    const queryParams = {
      "CompanyName": CompanyName,
      "CompanyNumber": CompanyNumber,
      "HunterName": HunterName,
      "ComgateMID": ComgateMID,
      "ComgateStatuses": ComgateStatuses,
      "FinancingModels": FinancingModels,
      "OrbitLPhases": OrbitLPhases,
      "HasOpenTerminalCountRequest": HasOpenTerminalCountRequest,
      "ActivatedFrom": ActivatedFrom,
      "ActivatedTo": ActivatedTo,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getMerchantsOrbitLOnboardingListPath()}`, options, queryParams) as Promise<GetMerchantsOrbitLOnboardingListFetchResponse>;
}

export type GetMerchantsOrbitLOnboardingActionRequiredCountFetchResponse = 
| FetchResponse<OrbitLOnboardingActionRequiredCountResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsOrbitLOnboardingActionRequiredCountPath = () => `/api/merchants/orbit-l/onboarding-action-required-count`;

export const getMerchantsOrbitLOnboardingActionRequiredCount = (options?: FetchArgsOptions):
  Promise<GetMerchantsOrbitLOnboardingActionRequiredCountFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsOrbitLOnboardingActionRequiredCountPath()}`, options, {}) as Promise<GetMerchantsOrbitLOnboardingActionRequiredCountFetchResponse>;
}

export type GetMerchantsPublicIDOrbitLOnboardingDetailFetchResponse = 
| FetchResponse<OrbitLOnboardingDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDOrbitLOnboardingDetailPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/onboarding-detail`;

export const getMerchantsPublicIDOrbitLOnboardingDetail = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDOrbitLOnboardingDetailFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDOrbitLOnboardingDetailPath(publicID)}`, options, {}) as Promise<GetMerchantsPublicIDOrbitLOnboardingDetailFetchResponse>;
}

export type GetMerchantsPublicIDOrbitLComgateCommentsFetchResponse = 
| FetchResponse<ComgateCommentDto[], 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDOrbitLComgateCommentsPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/comgate-comments`;

export const getMerchantsPublicIDOrbitLComgateComments = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDOrbitLComgateCommentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDOrbitLComgateCommentsPath(publicID)}`, options, {}) as Promise<GetMerchantsPublicIDOrbitLComgateCommentsFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLComgateCommentFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLComgateCommentPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/comgate-comment`;

export const postMerchantsPublicIDOrbitLComgateComment = (requestContract: SendComgateCommentRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLComgateCommentFetchResponse> => {
    const requestData = getApiRequestData<SendComgateCommentRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLComgateCommentPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLComgateCommentFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLResubmitToComgateFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLResubmitToComgatePath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/resubmit-to-comgate`;

export const postMerchantsPublicIDOrbitLResubmitToComgate = (publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLResubmitToComgateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLResubmitToComgatePath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLResubmitToComgateFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLTidTypesFetchResponse = 
| FetchResponse<ComgateTerminalTidDto[], 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLTidTypesPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/tid-types`;

export const postMerchantsPublicIDOrbitLTidTypes = (requestContract: SetComgateTerminalTidTypesRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLTidTypesFetchResponse> => {
    const requestData = getApiRequestData<SetComgateTerminalTidTypesRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLTidTypesPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLTidTypesFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLRegisterTmsFetchResponse = 
| FetchResponse<TmsRegistrationOutcome, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLRegisterTmsPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/register-tms`;

export const postMerchantsPublicIDOrbitLRegisterTms = (publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLRegisterTmsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLRegisterTmsPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLRegisterTmsFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLTidsTidReactivateCodeFetchResponse = 
| FetchResponse<TerminalActivationCodeDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLTidsTidReactivateCodePath = (publicID: string, tid: string) => `/api/merchants/${publicID}/orbit-l/tids/${tid}/reactivate-code`;

export const postMerchantsPublicIDOrbitLTidsTidReactivateCode = (publicID: string, tid: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLTidsTidReactivateCodeFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLTidsTidReactivateCodePath(publicID, tid)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLTidsTidReactivateCodeFetchResponse>;
}

export type PostMerchantsPublicIDOrbitLSwapTerminalFetchResponse = 
| FetchResponse<SwapOrbitLTerminalResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDOrbitLSwapTerminalPath = (publicID: string) => `/api/merchants/${publicID}/orbit-l/swap-terminal`;

export const postMerchantsPublicIDOrbitLSwapTerminal = (requestContract: SwapOrbitLTerminalRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDOrbitLSwapTerminalFetchResponse> => {
    const requestData = getApiRequestData<SwapOrbitLTerminalRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDOrbitLSwapTerminalPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDOrbitLSwapTerminalFetchResponse>;
}

export type GetMerchantsOrbitLAvailableTerminalsFetchResponse = 
| FetchResponse<AvailableTerminalDto[], 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsOrbitLAvailableTerminalsPath = () => `/api/merchants/orbit-l/available-terminals`;

export const getMerchantsOrbitLAvailableTerminals = (serialNumberPrefix?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetMerchantsOrbitLAvailableTerminalsFetchResponse> => {
    const queryParams = {
      "serialNumberPrefix": serialNumberPrefix
    }
    return apiGet(`${getApiUrl()}${getMerchantsOrbitLAvailableTerminalsPath()}`, options, queryParams) as Promise<GetMerchantsOrbitLAvailableTerminalsFetchResponse>;
}

export type GetMerchantsOrbitLTerminalsFetchResponse = 
| FetchResponse<OrbitLTerminalSearchResultDto[], 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsOrbitLTerminalsPath = () => `/api/merchants/orbit-l/terminals`;

export const getMerchantsOrbitLTerminals = (search?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetMerchantsOrbitLTerminalsFetchResponse> => {
    const queryParams = {
      "search": search
    }
    return apiGet(`${getApiUrl()}${getMerchantsOrbitLTerminalsPath()}`, options, queryParams) as Promise<GetMerchantsOrbitLTerminalsFetchResponse>;
}

export type GetMerchantsMerchantPricingsFetchResponse = 
| FetchResponse<MerchantPricingDto[], 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsMerchantPricingsPath = () => `/api/merchants/merchant-pricings`;

export const getMerchantsMerchantPricings = (options?: FetchArgsOptions):
  Promise<GetMerchantsMerchantPricingsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsMerchantPricingsPath()}`, options, {}) as Promise<GetMerchantsMerchantPricingsFetchResponse>;
}

export type GetMerchantsAppProductsFetchResponse = 
| FetchResponse<MerchantAppProductDto[], 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsAppProductsPath = () => `/api/merchants/app-products`;

export const getMerchantsAppProducts = (options?: FetchArgsOptions):
  Promise<GetMerchantsAppProductsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsAppProductsPath()}`, options, {}) as Promise<GetMerchantsAppProductsFetchResponse>;
}

export type GetMerchantsPublicIDAppProductsFetchResponse = 
| FetchResponse<MerchantAppProductDto[], 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getMerchantsPublicIDAppProductsPath = (publicID: string) => `/api/merchants/${publicID}/app-products`;

export const getMerchantsPublicIDAppProducts = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDAppProductsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDAppProductsPath(publicID)}`, options, {}) as Promise<GetMerchantsPublicIDAppProductsFetchResponse>;
}

export type DeleteMerchantsPublicIDAppProductsCodeFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDAppProductsCodePath = (publicID: string, code: ProductCode) => `/api/merchants/${publicID}/app-products/${code}`;

export const deleteMerchantsPublicIDAppProductsCode = (publicID: string, code: ProductCode, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDAppProductsCodeFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDAppProductsCodePath(publicID, code)}`, options, {}) as Promise<DeleteMerchantsPublicIDAppProductsCodeFetchResponse>;
}

export type PostMerchantsPublicIDAppProductsCodeFetchResponse = 
| FetchResponse<MerchantAppProductDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDAppProductsCodePath = (publicID: string, code: ProductCode) => `/api/merchants/${publicID}/app-products/${code}`;

export const postMerchantsPublicIDAppProductsCode = (requestContract: AddMerchantAppProductRequest, publicID: string, code: ProductCode, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDAppProductsCodeFetchResponse> => {
    const requestData = getApiRequestData<AddMerchantAppProductRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDAppProductsCodePath(publicID, code)}`, requestData, options) as Promise<PostMerchantsPublicIDAppProductsCodeFetchResponse>;
}

export type GetMerchantsPublicIDEmployeesFetchResponse = 
| FetchResponse<EntityListOfEmployeeDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDEmployeesPath = (publicID: string) => `/api/merchants/${publicID}/employees`;

export const getMerchantsPublicIDEmployees = (publicID: string, Statuses?: string[] | undefined | null, FirstName?: string | undefined | null, LastName?: string | undefined | null, Email?: string | undefined | null, Phone?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDEmployeesFetchResponse> => {
    const queryParams = {
      "Statuses": Statuses,
      "FirstName": FirstName,
      "LastName": LastName,
      "Email": Email,
      "Phone": Phone,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDEmployeesPath(publicID)}`, options, queryParams) as Promise<GetMerchantsPublicIDEmployeesFetchResponse>;
}

export type PostMerchantsPublicIDEmployeesFetchResponse = 
| FetchResponse<EmployeeDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDEmployeesPath = (publicID: string) => `/api/merchants/${publicID}/employees`;

export const postMerchantsPublicIDEmployees = (requestContract: CreateEmployeeRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDEmployeesFetchResponse> => {
    const requestData = getApiRequestData<CreateEmployeeRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDEmployeesPath(publicID)}`, requestData, options) as Promise<PostMerchantsPublicIDEmployeesFetchResponse>;
}

export type GetMerchantsEmployeesFetchResponse = 
| FetchResponse<EntityListOfEmployeeDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsEmployeesPath = () => `/api/merchants/employees`;

export const getMerchantsEmployees = (Statuses?: string[] | undefined | null, FirstName?: string | undefined | null, LastName?: string | undefined | null, Email?: string | undefined | null, Phone?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetMerchantsEmployeesFetchResponse> => {
    const queryParams = {
      "Statuses": Statuses,
      "FirstName": FirstName,
      "LastName": LastName,
      "Email": Email,
      "Phone": Phone,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getMerchantsEmployeesPath()}`, options, queryParams) as Promise<GetMerchantsEmployeesFetchResponse>;
}

export type GetMerchantsFacilitiesFetchResponse = 
| FetchResponse<EntityListOfFacilityWithMerchantDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsFacilitiesPath = () => `/api/merchants/facilities`;

export const getMerchantsFacilities = (categoryCode?: string | undefined | null, municipality?: string | undefined | null, pageSize?: number, pageNumber?: number, options?: FetchArgsOptions):
  Promise<GetMerchantsFacilitiesFetchResponse> => {
    const queryParams = {
      "categoryCode": categoryCode,
      "municipality": municipality,
      "pageSize": pageSize,
      "pageNumber": pageNumber
    }
    return apiGet(`${getApiUrl()}${getMerchantsFacilitiesPath()}`, options, queryParams) as Promise<GetMerchantsFacilitiesFetchResponse>;
}

export type GetMerchantsFacilitiesPublicIDFetchResponse = 
| FetchResponse<FacilityDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsFacilitiesPublicIDPath = (publicID: string) => `/api/merchants/facilities/${publicID}`;

export const getMerchantsFacilitiesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsFacilitiesPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsFacilitiesPublicIDPath(publicID)}`, options, {}) as Promise<GetMerchantsFacilitiesPublicIDFetchResponse>;
}

export type GetMerchantsFacilitiesMunicipalitiesFetchResponse = 
| FetchResponse<EntityListOfMunicipalityDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsFacilitiesMunicipalitiesPath = () => `/api/merchants/facilities/municipalities`;

export const getMerchantsFacilitiesMunicipalities = (searchTerm?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetMerchantsFacilitiesMunicipalitiesFetchResponse> => {
    const queryParams = {
      "searchTerm": searchTerm
    }
    return apiGet(`${getApiUrl()}${getMerchantsFacilitiesMunicipalitiesPath()}`, options, queryParams) as Promise<GetMerchantsFacilitiesMunicipalitiesFetchResponse>;
}

export type GetMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse = 
| FetchResponse<EmployeeDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getMerchantsPublicIDEmployeesEmployeePublicIDPath = (publicID: string, employeePublicID: string) => `/api/merchants/${publicID}/employees/${employeePublicID}`;

export const getMerchantsPublicIDEmployeesEmployeePublicID = (publicID: string, employeePublicID: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDEmployeesEmployeePublicIDPath(publicID, employeePublicID)}`, options, {}) as Promise<GetMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse>;
}

export type DeleteMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteMerchantsPublicIDEmployeesEmployeePublicIDPath = (publicID: string, employeePublicID: string) => `/api/merchants/${publicID}/employees/${employeePublicID}`;

export const deleteMerchantsPublicIDEmployeesEmployeePublicID = (publicID: string, employeePublicID: string, options?: FetchArgsOptions):
  Promise<DeleteMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMerchantsPublicIDEmployeesEmployeePublicIDPath(publicID, employeePublicID)}`, options, {}) as Promise<DeleteMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse>;
}

export type PutMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse = 
| FetchResponse<EmployeeDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putMerchantsPublicIDEmployeesEmployeePublicIDPath = (publicID: string, employeePublicID: string) => `/api/merchants/${publicID}/employees/${employeePublicID}`;

export const putMerchantsPublicIDEmployeesEmployeePublicID = (requestContract: UpdateEmployeeRequest, publicID: string, employeePublicID: string, options?: FetchArgsOptions):
  Promise<PutMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse> => {
    const requestData = getApiRequestData<UpdateEmployeeRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putMerchantsPublicIDEmployeesEmployeePublicIDPath(publicID, employeePublicID)}`, requestData, options) as Promise<PutMerchantsPublicIDEmployeesEmployeePublicIDFetchResponse>;
}

export type GetMerchantsPublicIDEmployeesIdentityLookupFetchResponse = 
| FetchResponse<IdentityLookupDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<void, 429> 
| ErrorResponse;

export const getMerchantsPublicIDEmployeesIdentityLookupPath = (publicID: string) => `/api/merchants/${publicID}/employees/identity-lookup`;

export const getMerchantsPublicIDEmployeesIdentityLookup = (publicID: string, login?: string, options?: FetchArgsOptions):
  Promise<GetMerchantsPublicIDEmployeesIdentityLookupFetchResponse> => {
    const queryParams = {
      "login": login
    }
    return apiGet(`${getApiUrl()}${getMerchantsPublicIDEmployeesIdentityLookupPath(publicID)}`, options, queryParams) as Promise<GetMerchantsPublicIDEmployeesIdentityLookupFetchResponse>;
}

export type PostMerchantsPublicIDEmployeesEmployeePublicIDSendAccessFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postMerchantsPublicIDEmployeesEmployeePublicIDSendAccessPath = (publicID: string, employeePublicID: string) => `/api/merchants/${publicID}/employees/${employeePublicID}/send-access`;

export const postMerchantsPublicIDEmployeesEmployeePublicIDSendAccess = (requestContract: SendEmployeeAccessRequest, publicID: string, employeePublicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDEmployeesEmployeePublicIDSendAccessFetchResponse> => {
    const requestData = getApiRequestData<SendEmployeeAccessRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDEmployeesEmployeePublicIDSendAccessPath(publicID, employeePublicID)}`, requestData, options) as Promise<PostMerchantsPublicIDEmployeesEmployeePublicIDSendAccessFetchResponse>;
}

export type PostMerchantsPublicIDEmployeesEmployeePublicIDCancelAccessFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postMerchantsPublicIDEmployeesEmployeePublicIDCancelAccessPath = (publicID: string, employeePublicID: string) => `/api/merchants/${publicID}/employees/${employeePublicID}/cancel-access`;

export const postMerchantsPublicIDEmployeesEmployeePublicIDCancelAccess = (publicID: string, employeePublicID: string, options?: FetchArgsOptions):
  Promise<PostMerchantsPublicIDEmployeesEmployeePublicIDCancelAccessFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postMerchantsPublicIDEmployeesEmployeePublicIDCancelAccessPath(publicID, employeePublicID)}`, requestData, options) as Promise<PostMerchantsPublicIDEmployeesEmployeePublicIDCancelAccessFetchResponse>;
}

export type GetNfcNfcCardNoExchangeFetchResponse = 
| FetchResponse<NFCCardData, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getNfcNfcCardNoExchangePath = (nfcCardNo: string) => `/api/nfc/${nfcCardNo}/exchange`;

export const getNfcNfcCardNoExchange = (nfcCardNo: string, options?: FetchArgsOptions):
  Promise<GetNfcNfcCardNoExchangeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getNfcNfcCardNoExchangePath(nfcCardNo)}`, options, {}) as Promise<GetNfcNfcCardNoExchangeFetchResponse>;
}

export type PostNotificationGetNotificationSettingsFetchResponse = 
| FetchResponse<UserNotificationSettingsDto, 200> 
| ErrorResponse;

export const postNotificationGetNotificationSettingsPath = () => `/api/Notification/get-notification-settings`;

export const postNotificationGetNotificationSettings = (options?: FetchArgsOptions):
  Promise<PostNotificationGetNotificationSettingsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationGetNotificationSettingsPath()}`, requestData, options) as Promise<PostNotificationGetNotificationSettingsFetchResponse>;
}

export type PostNotificationSaveNotificationSettingsFetchResponse = 
| FetchResponse<SaveUserNotificationSettingsCommandResult, 200> 
| ErrorResponse;

export const postNotificationSaveNotificationSettingsPath = () => `/api/Notification/save-notification-settings`;

export const postNotificationSaveNotificationSettings = (requestContract: UserNotificationSettingsDto, options?: FetchArgsOptions):
  Promise<PostNotificationSaveNotificationSettingsFetchResponse> => {
    const requestData = getApiRequestData<UserNotificationSettingsDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationSaveNotificationSettingsPath()}`, requestData, options) as Promise<PostNotificationSaveNotificationSettingsFetchResponse>;
}

export type GetNotificationsFetchResponse = 
| FetchResponse<PagedNotificationResult, 200> 
| FetchResponse<ProblemDetails, 400> 
| ErrorResponse;

export const getNotificationsPath = () => `/api/notifications`;

export const getNotifications = (unseenOnly?: boolean, page?: number, pageSize?: number, options?: FetchArgsOptions):
  Promise<GetNotificationsFetchResponse> => {
    const queryParams = {
      "unseenOnly": unseenOnly,
      "page": page,
      "pageSize": pageSize
    }
    return apiGet(`${getApiUrl()}${getNotificationsPath()}`, options, queryParams) as Promise<GetNotificationsFetchResponse>;
}

export type PostNotificationsFetchResponse = 
| FetchResponse<NotificationDto, 201> 
| FetchResponse<ProblemDetails, 400> 
| ErrorResponse;

export const postNotificationsPath = () => `/api/notifications`;

export const postNotifications = (requestContract: CreateNotificationRequest, options?: FetchArgsOptions):
  Promise<PostNotificationsFetchResponse> => {
    const requestData = getApiRequestData<CreateNotificationRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationsPath()}`, requestData, options) as Promise<PostNotificationsFetchResponse>;
}

export type GetNotificationsUnreadCountFetchResponse = 
| FetchResponse<UnreadCountDto, 200> 
| ErrorResponse;

export const getNotificationsUnreadCountPath = () => `/api/notifications/unread-count`;

export const getNotificationsUnreadCount = (options?: FetchArgsOptions):
  Promise<GetNotificationsUnreadCountFetchResponse> => {
    return apiGet(`${getApiUrl()}${getNotificationsUnreadCountPath()}`, options, {}) as Promise<GetNotificationsUnreadCountFetchResponse>;
}

export type PostNotificationsUserNotificationsUserNotificationPublicIdSeenFetchResponse = 
| FetchResponse<UserNotificationDto, 200> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const postNotificationsUserNotificationsUserNotificationPublicIdSeenPath = (userNotificationPublicId: string) => `/api/notifications/user-notifications/${userNotificationPublicId}/seen`;

export const postNotificationsUserNotificationsUserNotificationPublicIdSeen = (userNotificationPublicId: string, options?: FetchArgsOptions):
  Promise<PostNotificationsUserNotificationsUserNotificationPublicIdSeenFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsUserNotificationsUserNotificationPublicIdSeenPath(userNotificationPublicId)}`, requestData, options) as Promise<PostNotificationsUserNotificationsUserNotificationPublicIdSeenFetchResponse>;
}

export type PostNotificationsSeenAllFetchResponse = 
| FetchResponse<number, 200> 
| ErrorResponse;

export const postNotificationsSeenAllPath = () => `/api/notifications/seen-all`;

export const postNotificationsSeenAll = (options?: FetchArgsOptions):
  Promise<PostNotificationsSeenAllFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsSeenAllPath()}`, requestData, options) as Promise<PostNotificationsSeenAllFetchResponse>;
}

export type GetNotificationsAdminAllFetchResponse = 
| FetchResponse<NotificationDto[], 200> 
| ErrorResponse;

export const getNotificationsAdminAllPath = () => `/api/notifications/admin/all`;

export const getNotificationsAdminAll = (options?: FetchArgsOptions):
  Promise<GetNotificationsAdminAllFetchResponse> => {
    return apiGet(`${getApiUrl()}${getNotificationsAdminAllPath()}`, options, {}) as Promise<GetNotificationsAdminAllFetchResponse>;
}

export type GetNotificationsAdminPublicIdFetchResponse = 
| FetchResponse<NotificationDto, 200> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const getNotificationsAdminPublicIdPath = (publicId: string) => `/api/notifications/admin/${publicId}`;

export const getNotificationsAdminPublicId = (publicId: string, options?: FetchArgsOptions):
  Promise<GetNotificationsAdminPublicIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getNotificationsAdminPublicIdPath(publicId)}`, options, {}) as Promise<GetNotificationsAdminPublicIdFetchResponse>;
}

export type DeleteNotificationsPublicIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const deleteNotificationsPublicIdPath = (publicId: string) => `/api/notifications/${publicId}`;

export const deleteNotificationsPublicId = (publicId: string, options?: FetchArgsOptions):
  Promise<DeleteNotificationsPublicIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteNotificationsPublicIdPath(publicId)}`, options, {}) as Promise<DeleteNotificationsPublicIdFetchResponse>;
}

export type PutNotificationsPublicIdFetchResponse = 
| FetchResponse<NotificationDto, 200> 
| FetchResponse<ProblemDetails, 400> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const putNotificationsPublicIdPath = (publicId: string) => `/api/notifications/${publicId}`;

export const putNotificationsPublicId = (requestContract: UpdateNotificationRequest, publicId: string, options?: FetchArgsOptions):
  Promise<PutNotificationsPublicIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateNotificationRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putNotificationsPublicIdPath(publicId)}`, requestData, options) as Promise<PutNotificationsPublicIdFetchResponse>;
}

export type PostNotificationsPublicIdRestoreFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const postNotificationsPublicIdRestorePath = (publicId: string) => `/api/notifications/${publicId}/restore`;

export const postNotificationsPublicIdRestore = (publicId: string, options?: FetchArgsOptions):
  Promise<PostNotificationsPublicIdRestoreFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsPublicIdRestorePath(publicId)}`, requestData, options) as Promise<PostNotificationsPublicIdRestoreFetchResponse>;
}

export type PostRateGetRateFetchResponse = 
| FetchResponse<GetRateQueryResult, 200> 
| ErrorResponse;

export const postRateGetRatePath = () => `/api/Rate/get-rate`;

export const postRateGetRate = (requestContract: GetRateQuery, options?: FetchArgsOptions):
  Promise<PostRateGetRateFetchResponse> => {
    const requestData = getApiRequestData<GetRateQuery>(requestContract, false);

    return apiPost(`${getApiUrl()}${postRateGetRatePath()}`, requestData, options) as Promise<PostRateGetRateFetchResponse>;
}

export type GetRateHistoryFetchResponse = 
| FetchResponse<GetRateHistoryQueryResult, 200> 
| ErrorResponse;

export const getRateHistoryPath = () => `/api/Rate/history`;

export const getRateHistory = (askCurrencyCode?: string, bidCurrencyCode?: string, startDate?: string, options?: FetchArgsOptions):
  Promise<GetRateHistoryFetchResponse> => {
    const queryParams = {
      "askCurrencyCode": askCurrencyCode,
      "bidCurrencyCode": bidCurrencyCode,
      "startDate": startDate
    }
    return apiGet(`${getApiUrl()}${getRateHistoryPath()}`, options, queryParams) as Promise<GetRateHistoryFetchResponse>;
}

export type PutSocialHandleFetchResponse = 
| FetchResponse<SetHandleCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putSocialHandlePath = () => `/api/social/handle`;

export const putSocialHandle = (requestContract: SetHandleRequest, options?: FetchArgsOptions):
  Promise<PutSocialHandleFetchResponse> => {
    const requestData = getApiRequestData<SetHandleRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putSocialHandlePath()}`, requestData, options) as Promise<PutSocialHandleFetchResponse>;
}

export type PostSocialChatTerminateFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postSocialChatTerminatePath = () => `/api/social/chat/terminate`;

export const postSocialChatTerminate = (options?: FetchArgsOptions):
  Promise<PostSocialChatTerminateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSocialChatTerminatePath()}`, requestData, options) as Promise<PostSocialChatTerminateFetchResponse>;
}

export type PutSocialProfileVisibilityFetchResponse = 
| FetchResponse<SetProfileVisibilityResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const putSocialProfileVisibilityPath = () => `/api/social/profile-visibility`;

export const putSocialProfileVisibility = (requestContract: SetProfileVisibilityRequest, options?: FetchArgsOptions):
  Promise<PutSocialProfileVisibilityFetchResponse> => {
    const requestData = getApiRequestData<SetProfileVisibilityRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putSocialProfileVisibilityPath()}`, requestData, options) as Promise<PutSocialProfileVisibilityFetchResponse>;
}

export type PutSocialBioFetchResponse = 
| FetchResponse<SetBioResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const putSocialBioPath = () => `/api/social/bio`;

export const putSocialBio = (requestContract: SetBioRequest, options?: FetchArgsOptions):
  Promise<PutSocialBioFetchResponse> => {
    const requestData = getApiRequestData<SetBioRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putSocialBioPath()}`, requestData, options) as Promise<PutSocialBioFetchResponse>;
}

export type GetSocialHandleAvailabilityFetchResponse = 
| FetchResponse<HandleAvailabilityDto, 200> 
| ErrorResponse;

export const getSocialHandleAvailabilityPath = () => `/api/social/handle/availability`;

export const getSocialHandleAvailability = (handle?: string, options?: FetchArgsOptions):
  Promise<GetSocialHandleAvailabilityFetchResponse> => {
    const queryParams = {
      "handle": handle
    }
    return apiGet(`${getApiUrl()}${getSocialHandleAvailabilityPath()}`, options, queryParams) as Promise<GetSocialHandleAvailabilityFetchResponse>;
}

export type GetSocialUsersSearchFetchResponse = 
| FetchResponse<SocialUserSearchDto[], 200> 
| ErrorResponse;

export const getSocialUsersSearchPath = () => `/api/social/users/search`;

export const getSocialUsersSearch = (query?: string, options?: FetchArgsOptions):
  Promise<GetSocialUsersSearchFetchResponse> => {
    const queryParams = {
      "query": query
    }
    return apiGet(`${getApiUrl()}${getSocialUsersSearchPath()}`, options, queryParams) as Promise<GetSocialUsersSearchFetchResponse>;
}

export type GetSocialProfilesHandleFetchResponse = 
| FetchResponse<PublicProfileDto, 200> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const getSocialProfilesHandlePath = (handle: string) => `/api/social/profiles/${handle}`;

export const getSocialProfilesHandle = (handle: string, options?: FetchArgsOptions):
  Promise<GetSocialProfilesHandleFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialProfilesHandlePath(handle)}`, options, {}) as Promise<GetSocialProfilesHandleFetchResponse>;
}

export type GetSocialProfilesByIdIdentityUserPublicIDFetchResponse = 
| FetchResponse<PublicProfileDto, 200> 
| FetchResponse<ProblemDetails, 404> 
| ErrorResponse;

export const getSocialProfilesByIdIdentityUserPublicIDPath = (identityUserPublicID: string) => `/api/social/profiles/by-id/${identityUserPublicID}`;

export const getSocialProfilesByIdIdentityUserPublicID = (identityUserPublicID: string, options?: FetchArgsOptions):
  Promise<GetSocialProfilesByIdIdentityUserPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialProfilesByIdIdentityUserPublicIDPath(identityUserPublicID)}`, options, {}) as Promise<GetSocialProfilesByIdIdentityUserPublicIDFetchResponse>;
}

export type GetSocialMutualsFetchResponse = 
| FetchResponse<EntityListOfSocialUserSummary, 200> 
| ErrorResponse;

export const getSocialMutualsPath = () => `/api/social/mutuals`;

export const getSocialMutuals = (pageSize?: number, pageNumber?: number, options?: FetchArgsOptions):
  Promise<GetSocialMutualsFetchResponse> => {
    const queryParams = {
      "pageSize": pageSize,
      "pageNumber": pageNumber
    }
    return apiGet(`${getApiUrl()}${getSocialMutualsPath()}`, options, queryParams) as Promise<GetSocialMutualsFetchResponse>;
}

export type GetSocialMutualsIdsFetchResponse = 
| FetchResponse<string[], 200> 
| ErrorResponse;

export const getSocialMutualsIdsPath = () => `/api/social/mutuals/ids`;

export const getSocialMutualsIds = (options?: FetchArgsOptions):
  Promise<GetSocialMutualsIdsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialMutualsIdsPath()}`, options, {}) as Promise<GetSocialMutualsIdsFetchResponse>;
}

export type GetSocialDisclosedNamesFetchResponse = 
| FetchResponse<DisclosedNameDto[], 200> 
| ErrorResponse;

export const getSocialDisclosedNamesPath = () => `/api/social/disclosed-names`;

export const getSocialDisclosedNames = (options?: FetchArgsOptions):
  Promise<GetSocialDisclosedNamesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialDisclosedNamesPath()}`, options, {}) as Promise<GetSocialDisclosedNamesFetchResponse>;
}

export type GetSocialFollowRequestsFetchResponse = 
| FetchResponse<FollowRequestDto[], 200> 
| ErrorResponse;

export const getSocialFollowRequestsPath = () => `/api/social/follow-requests`;

export const getSocialFollowRequests = (direction?: FollowRequestDirection, options?: FetchArgsOptions):
  Promise<GetSocialFollowRequestsFetchResponse> => {
    const queryParams = {
      "direction": direction
    }
    return apiGet(`${getApiUrl()}${getSocialFollowRequestsPath()}`, options, queryParams) as Promise<GetSocialFollowRequestsFetchResponse>;
}

export type GetSocialFollowRequestsCountFetchResponse = 
| FetchResponse<FollowRequestCountDto, 200> 
| ErrorResponse;

export const getSocialFollowRequestsCountPath = () => `/api/social/follow-requests/count`;

export const getSocialFollowRequestsCount = (options?: FetchArgsOptions):
  Promise<GetSocialFollowRequestsCountFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialFollowRequestsCountPath()}`, options, {}) as Promise<GetSocialFollowRequestsCountFetchResponse>;
}

export type GetSocialFollowRequestsSummaryFetchResponse = 
| FetchResponse<FollowRequestSummaryDto, 200> 
| ErrorResponse;

export const getSocialFollowRequestsSummaryPath = () => `/api/social/follow-requests/summary`;

export const getSocialFollowRequestsSummary = (options?: FetchArgsOptions):
  Promise<GetSocialFollowRequestsSummaryFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialFollowRequestsSummaryPath()}`, options, {}) as Promise<GetSocialFollowRequestsSummaryFetchResponse>;
}

export type PostSocialFollowRequestsRequesterIdentityUserPublicIDApproveFetchResponse = 
| FetchResponse<ApproveFollowRequestResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postSocialFollowRequestsRequesterIdentityUserPublicIDApprovePath = (requesterIdentityUserPublicID: string) => `/api/social/follow-requests/${requesterIdentityUserPublicID}/approve`;

export const postSocialFollowRequestsRequesterIdentityUserPublicIDApprove = (requesterIdentityUserPublicID: string, options?: FetchArgsOptions):
  Promise<PostSocialFollowRequestsRequesterIdentityUserPublicIDApproveFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSocialFollowRequestsRequesterIdentityUserPublicIDApprovePath(requesterIdentityUserPublicID)}`, requestData, options) as Promise<PostSocialFollowRequestsRequesterIdentityUserPublicIDApproveFetchResponse>;
}

export type DeleteSocialFollowRequestsRequesterIdentityUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const deleteSocialFollowRequestsRequesterIdentityUserPublicIDPath = (requesterIdentityUserPublicID: string) => `/api/social/follow-requests/${requesterIdentityUserPublicID}`;

export const deleteSocialFollowRequestsRequesterIdentityUserPublicID = (requesterIdentityUserPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteSocialFollowRequestsRequesterIdentityUserPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteSocialFollowRequestsRequesterIdentityUserPublicIDPath(requesterIdentityUserPublicID)}`, options, {}) as Promise<DeleteSocialFollowRequestsRequesterIdentityUserPublicIDFetchResponse>;
}

export type GetSocialFollowsFetchResponse = 
| FetchResponse<EntityListOfSocialUserSummary, 200> 
| ErrorResponse;

export const getSocialFollowsPath = () => `/api/social/follows`;

export const getSocialFollows = (pageSize?: number, pageNumber?: number, options?: FetchArgsOptions):
  Promise<GetSocialFollowsFetchResponse> => {
    const queryParams = {
      "pageSize": pageSize,
      "pageNumber": pageNumber
    }
    return apiGet(`${getApiUrl()}${getSocialFollowsPath()}`, options, queryParams) as Promise<GetSocialFollowsFetchResponse>;
}

export type PostSocialFollowsFetchResponse = 
| FetchResponse<FollowUserResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ProblemDetails, 429> 
| ErrorResponse;

export const postSocialFollowsPath = () => `/api/social/follows`;

export const postSocialFollows = (requestContract: FollowUserRequest, options?: FetchArgsOptions):
  Promise<PostSocialFollowsFetchResponse> => {
    const requestData = getApiRequestData<FollowUserRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postSocialFollowsPath()}`, requestData, options) as Promise<PostSocialFollowsFetchResponse>;
}

export type DeleteSocialFollowsTargetIdentityUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteSocialFollowsTargetIdentityUserPublicIDPath = (targetIdentityUserPublicID: string) => `/api/social/follows/${targetIdentityUserPublicID}`;

export const deleteSocialFollowsTargetIdentityUserPublicID = (targetIdentityUserPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteSocialFollowsTargetIdentityUserPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteSocialFollowsTargetIdentityUserPublicIDPath(targetIdentityUserPublicID)}`, options, {}) as Promise<DeleteSocialFollowsTargetIdentityUserPublicIDFetchResponse>;
}

export type GetSocialFollowersFetchResponse = 
| FetchResponse<EntityListOfFollowerDto, 200> 
| ErrorResponse;

export const getSocialFollowersPath = () => `/api/social/followers`;

export const getSocialFollowers = (pageSize?: number, pageNumber?: number, options?: FetchArgsOptions):
  Promise<GetSocialFollowersFetchResponse> => {
    const queryParams = {
      "pageSize": pageSize,
      "pageNumber": pageNumber
    }
    return apiGet(`${getApiUrl()}${getSocialFollowersPath()}`, options, queryParams) as Promise<GetSocialFollowersFetchResponse>;
}

export type GetSocialBlocksFetchResponse = 
| FetchResponse<EntityListOfSocialUserSummary, 200> 
| ErrorResponse;

export const getSocialBlocksPath = () => `/api/social/blocks`;

export const getSocialBlocks = (pageSize?: number, pageNumber?: number, options?: FetchArgsOptions):
  Promise<GetSocialBlocksFetchResponse> => {
    const queryParams = {
      "pageSize": pageSize,
      "pageNumber": pageNumber
    }
    return apiGet(`${getApiUrl()}${getSocialBlocksPath()}`, options, queryParams) as Promise<GetSocialBlocksFetchResponse>;
}

export type PostSocialBlocksFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postSocialBlocksPath = () => `/api/social/blocks`;

export const postSocialBlocks = (requestContract: BlockUserRequest, options?: FetchArgsOptions):
  Promise<PostSocialBlocksFetchResponse> => {
    const requestData = getApiRequestData<BlockUserRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postSocialBlocksPath()}`, requestData, options) as Promise<PostSocialBlocksFetchResponse>;
}

export type DeleteSocialBlocksTargetIdentityUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const deleteSocialBlocksTargetIdentityUserPublicIDPath = (targetIdentityUserPublicID: string) => `/api/social/blocks/${targetIdentityUserPublicID}`;

export const deleteSocialBlocksTargetIdentityUserPublicID = (targetIdentityUserPublicID: string, options?: FetchArgsOptions):
  Promise<DeleteSocialBlocksTargetIdentityUserPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteSocialBlocksTargetIdentityUserPublicIDPath(targetIdentityUserPublicID)}`, options, {}) as Promise<DeleteSocialBlocksTargetIdentityUserPublicIDFetchResponse>;
}

export type GetSocialRelationshipTargetIdentityUserPublicIDFetchResponse = 
| FetchResponse<SocialRelationshipDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getSocialRelationshipTargetIdentityUserPublicIDPath = (targetIdentityUserPublicID: string) => `/api/social/relationship/${targetIdentityUserPublicID}`;

export const getSocialRelationshipTargetIdentityUserPublicID = (targetIdentityUserPublicID: string, options?: FetchArgsOptions):
  Promise<GetSocialRelationshipTargetIdentityUserPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSocialRelationshipTargetIdentityUserPublicIDPath(targetIdentityUserPublicID)}`, options, {}) as Promise<GetSocialRelationshipTargetIdentityUserPublicIDFetchResponse>;
}

export type GetStoriesTokenFetchResponse = 
| FetchResponse<GetStoriesTokenQueryResult, 200> 
| ErrorResponse;

export const getStoriesTokenPath = () => `/api/Stories/token`;

export const getStoriesToken = (options?: FetchArgsOptions):
  Promise<GetStoriesTokenFetchResponse> => {
    return apiGet(`${getApiUrl()}${getStoriesTokenPath()}`, options, {}) as Promise<GetStoriesTokenFetchResponse>;
}

export type GetStoriesPostUsageFetchResponse = 
| FetchResponse<GetStoryPostUsageQueryResult, 200> 
| ErrorResponse;

export const getStoriesPostUsagePath = () => `/api/Stories/post-usage`;

export const getStoriesPostUsage = (options?: FetchArgsOptions):
  Promise<GetStoriesPostUsageFetchResponse> => {
    return apiGet(`${getApiUrl()}${getStoriesPostUsagePath()}`, options, {}) as Promise<GetStoriesPostUsageFetchResponse>;
}

export type GetStoriesFetchResponse = 
| FetchResponse<EntityListOfStoryListItemDto, 200> 
| ErrorResponse;

export const getStoriesPath = () => `/api/Stories`;

export const getStories = (State?: StoryState | undefined | null, AuthorName?: string | undefined | null, Text?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetStoriesFetchResponse> => {
    const queryParams = {
      "State": State,
      "AuthorName": AuthorName,
      "Text": Text,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getStoriesPath()}`, options, queryParams) as Promise<GetStoriesFetchResponse>;
}

export type PostStoriesFetchResponse = 
| FetchResponse<CreateStoryCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 429> 
| ErrorResponse;

export const postStoriesPath = () => `/api/Stories`;

export const postStories = (requestContract: CreateStoryRequest, options?: FetchArgsOptions):
  Promise<PostStoriesFetchResponse> => {
    const requestData = getApiRequestData<CreateStoryRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postStoriesPath()}`, requestData, options) as Promise<PostStoriesFetchResponse>;
}

export type GetStoriesPublicIDFetchResponse = 
| FetchResponse<StoryDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getStoriesPublicIDPath = (publicID: string) => `/api/Stories/${publicID}`;

export const getStoriesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetStoriesPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getStoriesPublicIDPath(publicID)}`, options, {}) as Promise<GetStoriesPublicIDFetchResponse>;
}

export type DeleteStoriesPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteStoriesPublicIDPath = (publicID: string) => `/api/Stories/${publicID}`;

export const deleteStoriesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<DeleteStoriesPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteStoriesPublicIDPath(publicID)}`, options, {}) as Promise<DeleteStoriesPublicIDFetchResponse>;
}

export type PutStoriesPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putStoriesPublicIDPath = (publicID: string) => `/api/Stories/${publicID}`;

export const putStoriesPublicID = (requestContract: StorySaveRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutStoriesPublicIDFetchResponse> => {
    const requestData = getApiRequestData<StorySaveRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putStoriesPublicIDPath(publicID)}`, requestData, options) as Promise<PutStoriesPublicIDFetchResponse>;
}

export type PostStoriesPublicIDPublishFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| FetchResponse<ApiProblemDetails, 429> 
| ErrorResponse;

export const postStoriesPublicIDPublishPath = (publicID: string) => `/api/Stories/${publicID}/publish`;

export const postStoriesPublicIDPublish = (publicID: string, options?: FetchArgsOptions):
  Promise<PostStoriesPublicIDPublishFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postStoriesPublicIDPublishPath(publicID)}`, requestData, options) as Promise<PostStoriesPublicIDPublishFetchResponse>;
}

export type PostStoriesPublicIDUnpublishFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postStoriesPublicIDUnpublishPath = (publicID: string) => `/api/Stories/${publicID}/unpublish`;

export const postStoriesPublicIDUnpublish = (publicID: string, options?: FetchArgsOptions):
  Promise<PostStoriesPublicIDUnpublishFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postStoriesPublicIDUnpublishPath(publicID)}`, requestData, options) as Promise<PostStoriesPublicIDUnpublishFetchResponse>;
}

export type PostStoriesUploadImageFetchResponse = 
| FetchResponse<UploadStoryMediaCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 429> 
| ErrorResponse;

export const postStoriesUploadImagePath = () => `/api/Stories/upload-image`;

export const postStoriesUploadImage = (options?: FetchArgsOptions):
  Promise<PostStoriesUploadImageFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postStoriesUploadImagePath()}`, requestData, options) as Promise<PostStoriesUploadImageFetchResponse>;
}

export type GetStoriesMediaAuthorPublicIDFileNameFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getStoriesMediaAuthorPublicIDFileNamePath = (authorPublicID: string, fileName: string) => `/api/Stories/media/${authorPublicID}/${fileName}`;

export const getStoriesMediaAuthorPublicIDFileName = (authorPublicID: string, fileName: string, options?: FetchArgsOptions):
  Promise<GetStoriesMediaAuthorPublicIDFileNameFetchResponse> => {
    return apiGet(`${getApiUrl()}${getStoriesMediaAuthorPublicIDFileNamePath(authorPublicID, fileName)}`, options, {}) as Promise<GetStoriesMediaAuthorPublicIDFileNameFetchResponse>;
}

export type PostStoriesUploadVideoFetchResponse = 
| FetchResponse<UploadStoryMediaCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 429> 
| ErrorResponse;

export const postStoriesUploadVideoPath = () => `/api/Stories/upload-video`;

export const postStoriesUploadVideo = (options?: FetchArgsOptions):
  Promise<PostStoriesUploadVideoFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postStoriesUploadVideoPath()}`, requestData, options) as Promise<PostStoriesUploadVideoFetchResponse>;
}

export type PostSupportRequestsFetchResponse = 
| FetchResponse<CreateSupportRequestResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ProblemDetails, 429> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const postSupportRequestsPath = () => `/api/support/requests`;

export const postSupportRequests = (options?: FetchArgsOptions):
  Promise<PostSupportRequestsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postSupportRequestsPath()}`, requestData, options) as Promise<PostSupportRequestsFetchResponse>;
}

export type PostSupportContentReportsFetchResponse = 
| FetchResponse<CreateContentReportResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 429> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const postSupportContentReportsPath = () => `/api/support/content-reports`;

export const postSupportContentReports = (requestContract: CreateContentReportRequest, options?: FetchArgsOptions):
  Promise<PostSupportContentReportsFetchResponse> => {
    const requestData = getApiRequestData<CreateContentReportRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postSupportContentReportsPath()}`, requestData, options) as Promise<PostSupportContentReportsFetchResponse>;
}

export type PostSystemGetSystemSettingFetchResponse = 
| FetchResponse<SystemSettingDto, 200> 
| ErrorResponse;

export const postSystemGetSystemSettingPath = () => `/api/System/get-system-setting`;

export const postSystemGetSystemSetting = (requestContract: GetSystemSettingQuery, options?: FetchArgsOptions):
  Promise<PostSystemGetSystemSettingFetchResponse> => {
    const requestData = getApiRequestData<GetSystemSettingQuery>(requestContract, false);

    return apiPost(`${getApiUrl()}${postSystemGetSystemSettingPath()}`, requestData, options) as Promise<PostSystemGetSystemSettingFetchResponse>;
}

export type PostSystemSaveSystemSettingFetchResponse = 
| FetchResponse<SaveSystemSettingCommandResult, 200> 
| ErrorResponse;

export const postSystemSaveSystemSettingPath = () => `/api/System/save-system-setting`;

export const postSystemSaveSystemSetting = (requestContract: SaveSystemSettingCommand, options?: FetchArgsOptions):
  Promise<PostSystemSaveSystemSettingFetchResponse> => {
    const requestData = getApiRequestData<SaveSystemSettingCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postSystemSaveSystemSettingPath()}`, requestData, options) as Promise<PostSystemSaveSystemSettingFetchResponse>;
}

export type GetTerminalInventoryFetchResponse = 
| FetchResponse<TerminalInventoryItemDto[], 200> 
| ErrorResponse;

export const getTerminalInventoryPath = () => `/api/terminal-inventory`;

export const getTerminalInventory = (hunterPartyID?: number | undefined | null, status?: TerminalInventoryStatus | undefined | null, includeUnassigned?: boolean, options?: FetchArgsOptions):
  Promise<GetTerminalInventoryFetchResponse> => {
    const queryParams = {
      "hunterPartyID": hunterPartyID,
      "status": status,
      "includeUnassigned": includeUnassigned
    }
    return apiGet(`${getApiUrl()}${getTerminalInventoryPath()}`, options, queryParams) as Promise<GetTerminalInventoryFetchResponse>;
}

export type PostTerminalInventoryFetchResponse = 
| FetchResponse<TerminalInventoryItemDto, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postTerminalInventoryPath = () => `/api/terminal-inventory`;

export const postTerminalInventory = (requestContract: AddTerminalInventoryItemCommand, options?: FetchArgsOptions):
  Promise<PostTerminalInventoryFetchResponse> => {
    const requestData = getApiRequestData<AddTerminalInventoryItemCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTerminalInventoryPath()}`, requestData, options) as Promise<PostTerminalInventoryFetchResponse>;
}

export type PostTerminalInventoryBulkFetchResponse = 
| FetchResponse<AddTerminalInventoryItemsBulkResult, 200> 
| ErrorResponse;

export const postTerminalInventoryBulkPath = () => `/api/terminal-inventory/bulk`;

export const postTerminalInventoryBulk = (requestContract: AddTerminalInventoryItemsBulkCommand, options?: FetchArgsOptions):
  Promise<PostTerminalInventoryBulkFetchResponse> => {
    const requestData = getApiRequestData<AddTerminalInventoryItemsBulkCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTerminalInventoryBulkPath()}`, requestData, options) as Promise<PostTerminalInventoryBulkFetchResponse>;
}

export type GetTerminalInventoryListFetchResponse = 
| FetchResponse<EntityListOfTerminalInventoryListItemDto, 200> 
| ErrorResponse;

export const getTerminalInventoryListPath = () => `/api/terminal-inventory/list`;

export const getTerminalInventoryList = (Status?: TerminalInventoryStatus | undefined | null, Financing?: TerminalFinancing | undefined | null, SerialNumber?: string | undefined | null, Tid?: string | undefined | null, Mid?: string | undefined | null, HardwareModel?: string | undefined | null, HunterName?: string | undefined | null, HunterPartyPublicID?: string | undefined | null, MerchantName?: string | undefined | null, FacilityName?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetTerminalInventoryListFetchResponse> => {
    const queryParams = {
      "Status": Status,
      "Financing": Financing,
      "SerialNumber": SerialNumber,
      "Tid": Tid,
      "Mid": Mid,
      "HardwareModel": HardwareModel,
      "HunterName": HunterName,
      "HunterPartyPublicID": HunterPartyPublicID,
      "MerchantName": MerchantName,
      "FacilityName": FacilityName,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getTerminalInventoryListPath()}`, options, queryParams) as Promise<GetTerminalInventoryListFetchResponse>;
}

export type GetTerminalInventoryPublicIDFetchResponse = 
| FetchResponse<TerminalInventoryItemDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTerminalInventoryPublicIDPath = (publicID: string) => `/api/terminal-inventory/${publicID}`;

export const getTerminalInventoryPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetTerminalInventoryPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTerminalInventoryPublicIDPath(publicID)}`, options, {}) as Promise<GetTerminalInventoryPublicIDFetchResponse>;
}

export type DeleteTerminalInventoryPublicIDFetchResponse = 
| FetchResponse<boolean, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteTerminalInventoryPublicIDPath = (publicID: string) => `/api/terminal-inventory/${publicID}`;

export const deleteTerminalInventoryPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<DeleteTerminalInventoryPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteTerminalInventoryPublicIDPath(publicID)}`, options, {}) as Promise<DeleteTerminalInventoryPublicIDFetchResponse>;
}

export type PutTerminalInventoryPublicIDFetchResponse = 
| FetchResponse<TerminalInventoryItemDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putTerminalInventoryPublicIDPath = (publicID: string) => `/api/terminal-inventory/${publicID}`;

export const putTerminalInventoryPublicID = (requestContract: UpdateTerminalInventoryItemRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutTerminalInventoryPublicIDFetchResponse> => {
    const requestData = getApiRequestData<UpdateTerminalInventoryItemRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putTerminalInventoryPublicIDPath(publicID)}`, requestData, options) as Promise<PutTerminalInventoryPublicIDFetchResponse>;
}

export type GetTerminalInventoryPublicIDAuditFetchResponse = 
| FetchResponse<TerminalAuditRecordDto[], 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTerminalInventoryPublicIDAuditPath = (publicID: string) => `/api/terminal-inventory/${publicID}/audit`;

export const getTerminalInventoryPublicIDAudit = (publicID: string, options?: FetchArgsOptions):
  Promise<GetTerminalInventoryPublicIDAuditFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTerminalInventoryPublicIDAuditPath(publicID)}`, options, {}) as Promise<GetTerminalInventoryPublicIDAuditFetchResponse>;
}

export type PutTerminalInventoryPublicIDShipFetchResponse = 
| FetchResponse<TerminalInventoryItemDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putTerminalInventoryPublicIDShipPath = (publicID: string) => `/api/terminal-inventory/${publicID}/ship`;

export const putTerminalInventoryPublicIDShip = (publicID: string, options?: FetchArgsOptions):
  Promise<PutTerminalInventoryPublicIDShipFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putTerminalInventoryPublicIDShipPath(publicID)}`, requestData, options) as Promise<PutTerminalInventoryPublicIDShipFetchResponse>;
}

export type PutTerminalInventoryPublicIDAssignMerchantFetchResponse = 
| FetchResponse<TerminalInventoryItemDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putTerminalInventoryPublicIDAssignMerchantPath = (publicID: string) => `/api/terminal-inventory/${publicID}/assign-merchant`;

export const putTerminalInventoryPublicIDAssignMerchant = (requestContract: AssignTerminalToMerchantRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutTerminalInventoryPublicIDAssignMerchantFetchResponse> => {
    const requestData = getApiRequestData<AssignTerminalToMerchantRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putTerminalInventoryPublicIDAssignMerchantPath(publicID)}`, requestData, options) as Promise<PutTerminalInventoryPublicIDAssignMerchantFetchResponse>;
}

export type GetUsersMeTerminalPinFetchResponse = 
| FetchResponse<TerminalPinResult, 200> 
| ErrorResponse;

export const getUsersMeTerminalPinPath = () => `/api/users/me/terminal-pin`;

export const getUsersMeTerminalPin = (options?: FetchArgsOptions):
  Promise<GetUsersMeTerminalPinFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersMeTerminalPinPath()}`, options, {}) as Promise<GetUsersMeTerminalPinFetchResponse>;
}

export type PostUsersMeTerminalPinRegenerateFetchResponse = 
| FetchResponse<TerminalPinRegeneratedResult, 200> 
| ErrorResponse;

export const postUsersMeTerminalPinRegeneratePath = () => `/api/users/me/terminal-pin/regenerate`;

export const postUsersMeTerminalPinRegenerate = (options?: FetchArgsOptions):
  Promise<PostUsersMeTerminalPinRegenerateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postUsersMeTerminalPinRegeneratePath()}`, requestData, options) as Promise<PostUsersMeTerminalPinRegenerateFetchResponse>;
}

export type GetUserBankAccountsAddressesFetchResponse = 
| FetchResponse<EntityListOfUserBankAccountListDto, 200> 
| ErrorResponse;

export const getUserBankAccountsAddressesPath = () => `/api/user-bank-accounts/addresses`;

export const getUserBankAccountsAddresses = (options?: FetchArgsOptions):
  Promise<GetUserBankAccountsAddressesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUserBankAccountsAddressesPath()}`, options, {}) as Promise<GetUserBankAccountsAddressesFetchResponse>;
}

export type GetUsersFetchResponse = 
| FetchResponse<EntityListOfUserDto, 200> 
| ErrorResponse;

export const getUsersPath = () => `/api/users`;

export const getUsers = (ExcludedAnonymous?: boolean, Verification?: string | undefined | null, RoleCodes?: string[] | undefined | null, Statuses?: string[] | undefined | null, FirstName?: string | undefined | null, LastName?: string | undefined | null, CompanyName?: string | undefined | null, Login?: string | undefined | null, DateCreatedFrom?: string | undefined | null, DocumentExpiration?: string | undefined | null, Version?: string | undefined | null, SettlementStatus?: SettlementStatus | undefined | null, IsAdmin?: boolean | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetUsersFetchResponse> => {
    const queryParams = {
      "ExcludedAnonymous": ExcludedAnonymous,
      "Verification": Verification,
      "RoleCodes": RoleCodes,
      "Statuses": Statuses,
      "FirstName": FirstName,
      "LastName": LastName,
      "CompanyName": CompanyName,
      "Login": Login,
      "DateCreatedFrom": DateCreatedFrom,
      "DocumentExpiration": DocumentExpiration,
      "Version": Version,
      "SettlementStatus": SettlementStatus,
      "IsAdmin": IsAdmin,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getUsersPath()}`, options, queryParams) as Promise<GetUsersFetchResponse>;
}

export type GetUsersHuntersFetchResponse = 
| FetchResponse<EntityListOfHunterListDto, 200> 
| ErrorResponse;

export const getUsersHuntersPath = () => `/api/users/hunters`;

export const getUsersHunters = (Prerequisites?: string | undefined | null, Search?: string | undefined | null, Login?: string | undefined | null, FirstName?: string | undefined | null, LastName?: string | undefined | null, CompanyName?: string | undefined | null, AffiliatedTo?: string | undefined | null, DateCreatedFrom?: string | undefined | null, Statuses?: string[] | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetUsersHuntersFetchResponse> => {
    const queryParams = {
      "Prerequisites": Prerequisites,
      "Search": Search,
      "Login": Login,
      "FirstName": FirstName,
      "LastName": LastName,
      "CompanyName": CompanyName,
      "AffiliatedTo": AffiliatedTo,
      "DateCreatedFrom": DateCreatedFrom,
      "Statuses": Statuses,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getUsersHuntersPath()}`, options, queryParams) as Promise<GetUsersHuntersFetchResponse>;
}

export type GetUsersAwaitingVerificationFetchResponse = 
| FetchResponse<EntityListOfUserAwaitingVerificationDto, 200> 
| FetchResponse<ProblemDetails, 403> 
| ErrorResponse;

export const getUsersAwaitingVerificationPath = () => `/api/users/awaiting-verification`;

export const getUsersAwaitingVerification = (FilterType?: VerificationFilterType, Login?: string | undefined | null, FirstName?: string | undefined | null, LastName?: string | undefined | null, CompanyName?: string | undefined | null, CompanyNumber?: string | undefined | null, RoleCodes?: string[] | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetUsersAwaitingVerificationFetchResponse> => {
    const queryParams = {
      "FilterType": FilterType,
      "Login": Login,
      "FirstName": FirstName,
      "LastName": LastName,
      "CompanyName": CompanyName,
      "CompanyNumber": CompanyNumber,
      "RoleCodes": RoleCodes,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getUsersAwaitingVerificationPath()}`, options, queryParams) as Promise<GetUsersAwaitingVerificationFetchResponse>;
}

export type GetUsersAdminDetailUserIDFetchResponse = 
| FetchResponse<UserAdminDetailDto, 200> 
| ErrorResponse;

export const getUsersAdminDetailUserIDPath = (userID: number) => `/api/users/admin-detail/${userID}`;

export const getUsersAdminDetailUserID = (userID: number, options?: FetchArgsOptions):
  Promise<GetUsersAdminDetailUserIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersAdminDetailUserIDPath(userID)}`, options, {}) as Promise<GetUsersAdminDetailUserIDFetchResponse>;
}

export type GetUsersHunterDetailHunterUserIDFetchResponse = 
| FetchResponse<HunterDetailDto, 200> 
| ErrorResponse;

export const getUsersHunterDetailHunterUserIDPath = (hunterUserID: number) => `/api/users/hunter-detail/${hunterUserID}`;

export const getUsersHunterDetailHunterUserID = (hunterUserID: number, options?: FetchArgsOptions):
  Promise<GetUsersHunterDetailHunterUserIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersHunterDetailHunterUserIDPath(hunterUserID)}`, options, {}) as Promise<GetUsersHunterDetailHunterUserIDFetchResponse>;
}

export type PostUsersAdminDetailFetchResponse = 
| FetchResponse<SaveUserAdminDetailCommandResult, 200> 
| ErrorResponse;

export const postUsersAdminDetailPath = () => `/api/users/admin-detail`;

export const postUsersAdminDetail = (requestContract: UserAdminDetailDto, options?: FetchArgsOptions):
  Promise<PostUsersAdminDetailFetchResponse> => {
    const requestData = getApiRequestData<UserAdminDetailDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUsersAdminDetailPath()}`, requestData, options) as Promise<PostUsersAdminDetailFetchResponse>;
}

export type PutUsersRiskProfileFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putUsersRiskProfilePath = () => `/api/users/risk-profile`;

export const putUsersRiskProfile = (requestContract: SetRiskProfileCommand, options?: FetchArgsOptions):
  Promise<PutUsersRiskProfileFetchResponse> => {
    const requestData = getApiRequestData<SetRiskProfileCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putUsersRiskProfilePath()}`, requestData, options) as Promise<PutUsersRiskProfileFetchResponse>;
}

export type PutUsersIdentityVerificationStatusFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putUsersIdentityVerificationStatusPath = () => `/api/users/identity-verification-status`;

export const putUsersIdentityVerificationStatus = (requestContract: SetIdentityVerificationStatusCommand, options?: FetchArgsOptions):
  Promise<PutUsersIdentityVerificationStatusFetchResponse> => {
    const requestData = getApiRequestData<SetIdentityVerificationStatusCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putUsersIdentityVerificationStatusPath()}`, requestData, options) as Promise<PutUsersIdentityVerificationStatusFetchResponse>;
}

export type PutUsersDeactivateFetchResponse = 
| FetchResponse<DeactivateUserCommandResult, 200> 
| ErrorResponse;

export const putUsersDeactivatePath = () => `/api/users/deactivate`;

export const putUsersDeactivate = (options?: FetchArgsOptions):
  Promise<PutUsersDeactivateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putUsersDeactivatePath()}`, requestData, options) as Promise<PutUsersDeactivateFetchResponse>;
}

export type PutUsersUserSettingsFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putUsersUserSettingsPath = () => `/api/users/user-settings`;

export const putUsersUserSettings = (requestContract: UserSettingsDto, options?: FetchArgsOptions):
  Promise<PutUsersUserSettingsFetchResponse> => {
    const requestData = getApiRequestData<UserSettingsDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putUsersUserSettingsPath()}`, requestData, options) as Promise<PutUsersUserSettingsFetchResponse>;
}

export type PutUsersChangePasswordFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 429> 
| ErrorResponse;

export const putUsersChangePasswordPath = () => `/api/users/change-password`;

export const putUsersChangePassword = (requestContract: ChangePasswordRequest, options?: FetchArgsOptions):
  Promise<PutUsersChangePasswordFetchResponse> => {
    const requestData = getApiRequestData<ChangePasswordRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putUsersChangePasswordPath()}`, requestData, options) as Promise<PutUsersChangePasswordFetchResponse>;
}

export type PatchUsersUserSettingsQuickPaymentFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const patchUsersUserSettingsQuickPaymentPath = () => `/api/users/user-settings/quick-payment`;

export const patchUsersUserSettingsQuickPayment = (requestContract: UpdateQuickPaymentEnabledRequest, options?: FetchArgsOptions):
  Promise<PatchUsersUserSettingsQuickPaymentFetchResponse> => {
    const requestData = getApiRequestData<UpdateQuickPaymentEnabledRequest>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchUsersUserSettingsQuickPaymentPath()}`, requestData, options) as Promise<PatchUsersUserSettingsQuickPaymentFetchResponse>;
}

export type PatchUsersUserSettingsBalanceVisibilityFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const patchUsersUserSettingsBalanceVisibilityPath = () => `/api/users/user-settings/balance-visibility`;

export const patchUsersUserSettingsBalanceVisibility = (requestContract: UpdateBalanceVisibilityRequest, options?: FetchArgsOptions):
  Promise<PatchUsersUserSettingsBalanceVisibilityFetchResponse> => {
    const requestData = getApiRequestData<UpdateBalanceVisibilityRequest>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchUsersUserSettingsBalanceVisibilityPath()}`, requestData, options) as Promise<PatchUsersUserSettingsBalanceVisibilityFetchResponse>;
}

export type GetUsersCsvExportFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ProblemDetails, 403> 
| ErrorResponse;

export const getUsersCsvExportPath = () => `/api/users/csv-export`;

export const getUsersCsvExport = (options?: FetchArgsOptions):
  Promise<GetUsersCsvExportFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersCsvExportPath()}`, options, {}) as Promise<GetUsersCsvExportFetchResponse>;
}

export type GetUsersSearchHuntersFetchResponse = 
| FetchResponse<HunterSearchDto[], 200> 
| ErrorResponse;

export const getUsersSearchHuntersPath = () => `/api/users/search/hunters`;

export const getUsersSearchHunters = (query?: string, region?: Region | undefined | null, includeHuntersWithoutLicense?: boolean, options?: FetchArgsOptions):
  Promise<GetUsersSearchHuntersFetchResponse> => {
    const queryParams = {
      "query": query,
      "region": region,
      "includeHuntersWithoutLicense": includeHuntersWithoutLicense
    }
    return apiGet(`${getApiUrl()}${getUsersSearchHuntersPath()}`, options, queryParams) as Promise<GetUsersSearchHuntersFetchResponse>;
}

export type DeleteUsersProfilePhotoFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteUsersProfilePhotoPath = () => `/api/users/profile-photo`;

export const deleteUsersProfilePhoto = (options?: FetchArgsOptions):
  Promise<DeleteUsersProfilePhotoFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteUsersProfilePhotoPath()}`, options, {}) as Promise<DeleteUsersProfilePhotoFetchResponse>;
}

export type PutUsersProfilePhotoFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putUsersProfilePhotoPath = () => `/api/users/profile-photo`;

export const putUsersProfilePhoto = (options?: FetchArgsOptions):
  Promise<PutUsersProfilePhotoFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putUsersProfilePhotoPath()}`, requestData, options) as Promise<PutUsersProfilePhotoFetchResponse>;
}

export type GetUsersProfilePhotoUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getUsersProfilePhotoUserPublicIDPath = (userPublicID: string) => `/api/users/profile-photo/${userPublicID}`;

export const getUsersProfilePhotoUserPublicID = (userPublicID: string, options?: FetchArgsOptions):
  Promise<GetUsersProfilePhotoUserPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersProfilePhotoUserPublicIDPath(userPublicID)}`, options, {}) as Promise<GetUsersProfilePhotoUserPublicIDFetchResponse>;
}

export type GetUsersProfilePhotoContextIdentityUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getUsersProfilePhotoContextIdentityUserPublicIDPath = (identityUserPublicID: string) => `/api/users/profile-photo/context/${identityUserPublicID}`;

export const getUsersProfilePhotoContextIdentityUserPublicID = (identityUserPublicID: string, options?: FetchArgsOptions):
  Promise<GetUsersProfilePhotoContextIdentityUserPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersProfilePhotoContextIdentityUserPublicIDPath(identityUserPublicID)}`, options, {}) as Promise<GetUsersProfilePhotoContextIdentityUserPublicIDFetchResponse>;
}

export type GetUsersProfilePhotoIdentityUserIdentityUserPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getUsersProfilePhotoIdentityUserIdentityUserPublicIDPath = (identityUserPublicID: string) => `/api/users/profile-photo/identity-user/${identityUserPublicID}`;

export const getUsersProfilePhotoIdentityUserIdentityUserPublicID = (identityUserPublicID: string, options?: FetchArgsOptions):
  Promise<GetUsersProfilePhotoIdentityUserIdentityUserPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersProfilePhotoIdentityUserIdentityUserPublicIDPath(identityUserPublicID)}`, options, {}) as Promise<GetUsersProfilePhotoIdentityUserIdentityUserPublicIDFetchResponse>;
}

export type PostVerificationGetUserVerificationDetailFetchResponse = 
| FetchResponse<UserVerificationDetailDto, 200> 
| ErrorResponse;

export const postVerificationGetUserVerificationDetailPath = () => `/api/Verification/get-user-verification-detail`;

export const postVerificationGetUserVerificationDetail = (options?: FetchArgsOptions):
  Promise<PostVerificationGetUserVerificationDetailFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postVerificationGetUserVerificationDetailPath()}`, requestData, options) as Promise<PostVerificationGetUserVerificationDetailFetchResponse>;
}

export type PostVerificationVerifyBankIdFetchResponse = 
| FetchResponse<ProcessBankIDVerificationCommandResult, 200> 
| ErrorResponse;

export const postVerificationVerifyBankIdPath = () => `/api/Verification/verify-bank-id`;

export const postVerificationVerifyBankId = (requestContract: BankIDVerificationRequest, options?: FetchArgsOptions):
  Promise<PostVerificationVerifyBankIdFetchResponse> => {
    const requestData = getApiRequestData<BankIDVerificationRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postVerificationVerifyBankIdPath()}`, requestData, options) as Promise<PostVerificationVerifyBankIdFetchResponse>;
}

export type PostVerificationVerifyAdditionalInfoFetchResponse = 
| FetchResponse<SetAdditionalInfoCommandResult, 200> 
| ErrorResponse;

export const postVerificationVerifyAdditionalInfoPath = () => `/api/Verification/verify-additional-info`;

export const postVerificationVerifyAdditionalInfo = (requestContract: SetAdditionalInfoRequest, options?: FetchArgsOptions):
  Promise<PostVerificationVerifyAdditionalInfoFetchResponse> => {
    const requestData = getApiRequestData<SetAdditionalInfoRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postVerificationVerifyAdditionalInfoPath()}`, requestData, options) as Promise<PostVerificationVerifyAdditionalInfoFetchResponse>;
}

export type PostVerificationUploadIdentificationFetchResponse = 
| FetchResponse<UploadIdentificationCommandResult, 200> 
| ErrorResponse;

export const postVerificationUploadIdentificationPath = () => `/api/Verification/upload-identification`;

export const postVerificationUploadIdentification = (options?: FetchArgsOptions):
  Promise<PostVerificationUploadIdentificationFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postVerificationUploadIdentificationPath()}`, requestData, options) as Promise<PostVerificationUploadIdentificationFetchResponse>;
}

export type PostVerificationSetBankIdentificationInProgressFetchResponse = 
| FetchResponse<SetBankIdentificationInProgressCommandResult, 200> 
| ErrorResponse;

export const postVerificationSetBankIdentificationInProgressPath = () => `/api/Verification/set-bank-identification-in-progress`;

export const postVerificationSetBankIdentificationInProgress = (options?: FetchArgsOptions):
  Promise<PostVerificationSetBankIdentificationInProgressFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postVerificationSetBankIdentificationInProgressPath()}`, requestData, options) as Promise<PostVerificationSetBankIdentificationInProgressFetchResponse>;
}

export type GetVerificationsFetchResponse = 
| FetchResponse<UserVerificationDto, 200> 
| ErrorResponse;

export const getVerificationsPath = () => `/api/verifications`;

export const getVerifications = (userID?: number | undefined | null, options?: FetchArgsOptions):
  Promise<GetVerificationsFetchResponse> => {
    const queryParams = {
      "userID": userID
    }
    return apiGet(`${getApiUrl()}${getVerificationsPath()}`, options, queryParams) as Promise<GetVerificationsFetchResponse>;
}

export type PostVerificationsFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postVerificationsPath = () => `/api/verifications`;

export const postVerifications = (options?: FetchArgsOptions):
  Promise<PostVerificationsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postVerificationsPath()}`, requestData, options) as Promise<PostVerificationsFetchResponse>;
}

export type PutVerificationsFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<UserVerificationDto, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putVerificationsPath = () => `/api/verifications`;

export const putVerifications = (requestContract: UserVerificationUpdateDto, options?: FetchArgsOptions):
  Promise<PutVerificationsFetchResponse> => {
    const requestData = getApiRequestData<UserVerificationUpdateDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putVerificationsPath()}`, requestData, options) as Promise<PutVerificationsFetchResponse>;
}

export type GetCardTransactionsAvailabilityFetchResponse = 
| FetchResponse<CardTransactionsAvailabilityResponse, 200> 
| ErrorResponse;

export const getCardTransactionsAvailabilityPath = () => `/api/card-transactions/availability`;

export const getCardTransactionsAvailability = (options?: FetchArgsOptions):
  Promise<GetCardTransactionsAvailabilityFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCardTransactionsAvailabilityPath()}`, options, {}) as Promise<GetCardTransactionsAvailabilityFetchResponse>;
}

export type GetCardTransactionsFetchResponse = 
| FetchResponse<EntityListOfCardTransactionItem, 200> 
| ErrorResponse;

export const getCardTransactionsPath = () => `/api/card-transactions`;

export const getCardTransactions = (Offset?: number, Limit?: number, DateFrom?: string | undefined | null, DateTo?: string | undefined | null, PayPointPublicID?: string | undefined | null, EmployeePublicID?: string | undefined | null, Status?: CardTransactionStatus | undefined | null, IsRefundOrCancellation?: boolean | undefined | null, options?: FetchArgsOptions):
  Promise<GetCardTransactionsFetchResponse> => {
    const queryParams = {
      "Offset": Offset,
      "Limit": Limit,
      "DateFrom": DateFrom,
      "DateTo": DateTo,
      "PayPointPublicID": PayPointPublicID,
      "EmployeePublicID": EmployeePublicID,
      "Status": Status,
      "IsRefundOrCancellation": IsRefundOrCancellation
    }
    return apiGet(`${getApiUrl()}${getCardTransactionsPath()}`, options, queryParams) as Promise<GetCardTransactionsFetchResponse>;
}

export type GetCardTransactionsSumFetchResponse = 
| FetchResponse<CardTransactionsSumResponse, 200> 
| ErrorResponse;

export const getCardTransactionsSumPath = () => `/api/card-transactions/sum`;

export const getCardTransactionsSum = (dateFrom?: string | undefined | null, dateTo?: string | undefined | null, payPointPublicID?: string | undefined | null, employeePublicID?: string | undefined | null, status?: CardTransactionStatus | undefined | null, options?: FetchArgsOptions):
  Promise<GetCardTransactionsSumFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "payPointPublicID": payPointPublicID,
      "employeePublicID": employeePublicID,
      "status": status
    }
    return apiGet(`${getApiUrl()}${getCardTransactionsSumPath()}`, options, queryParams) as Promise<GetCardTransactionsSumFetchResponse>;
}

export type GetCardTransactionsExportFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const getCardTransactionsExportPath = () => `/api/card-transactions/export`;

export const getCardTransactionsExport = (Format?: TransactionExportFormat, Email?: string | undefined | null, DateFrom?: string | undefined | null, DateTo?: string | undefined | null, PayPointPublicID?: string | undefined | null, EmployeePublicID?: string | undefined | null, Status?: CardTransactionStatus | undefined | null, IsRefundOrCancellation?: boolean | undefined | null, options?: FetchArgsOptions):
  Promise<GetCardTransactionsExportFetchResponse> => {
    const queryParams = {
      "Format": Format,
      "Email": Email,
      "DateFrom": DateFrom,
      "DateTo": DateTo,
      "PayPointPublicID": PayPointPublicID,
      "EmployeePublicID": EmployeePublicID,
      "Status": Status,
      "IsRefundOrCancellation": IsRefundOrCancellation
    }
    return apiGet(`${getApiUrl()}${getCardTransactionsExportPath()}`, options, queryParams) as Promise<GetCardTransactionsExportFetchResponse>;
}

export type PostCardTransactionsExportFetchResponse = 
| FetchResponse<ExportCardTransactionsCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const postCardTransactionsExportPath = () => `/api/card-transactions/export`;

export const postCardTransactionsExport = (requestContract: ExportCardTransactionsRequest, options?: FetchArgsOptions):
  Promise<PostCardTransactionsExportFetchResponse> => {
    const requestData = getApiRequestData<ExportCardTransactionsRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCardTransactionsExportPath()}`, requestData, options) as Promise<PostCardTransactionsExportFetchResponse>;
}

export type GetPayPointsFetchResponse = 
| FetchResponse<EntityListOfPayPointBaseDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPath = () => `/api/pay-points`;

export const getPayPoints = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetPayPointsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getPayPointsPath()}`, options, queryParams) as Promise<GetPayPointsFetchResponse>;
}

export type PostPayPointsFetchResponse = 
| FetchResponse<InternalPayPointDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postPayPointsPath = () => `/api/pay-points`;

export const postPayPoints = (requestContract: CreateInternalPayPointRequest, options?: FetchArgsOptions):
  Promise<PostPayPointsFetchResponse> => {
    const requestData = getApiRequestData<CreateInternalPayPointRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPayPointsPath()}`, requestData, options) as Promise<PostPayPointsFetchResponse>;
}

export type GetPayPointsPublicIDFetchResponse = 
| FetchResponse<InternalPayPointDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPublicIDPath = (publicID: string) => `/api/pay-points/${publicID}`;

export const getPayPointsPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPayPointsPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPayPointsPublicIDPath(publicID)}`, options, {}) as Promise<GetPayPointsPublicIDFetchResponse>;
}

export type PutPayPointsPublicIDFetchResponse = 
| FetchResponse<InternalPayPointDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const putPayPointsPublicIDPath = (publicID: string) => `/api/pay-points/${publicID}`;

export const putPayPointsPublicID = (requestContract: UpdateInternalPayPointRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutPayPointsPublicIDFetchResponse> => {
    const requestData = getApiRequestData<UpdateInternalPayPointRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPayPointsPublicIDPath(publicID)}`, requestData, options) as Promise<PutPayPointsPublicIDFetchResponse>;
}

export type PutPayPointsPublicIDAssignNfcCardFetchResponse = 
| FetchResponse<PayPointBaseDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const putPayPointsPublicIDAssignNfcCardPath = (publicID: string) => `/api/pay-points/${publicID}/assign-nfc-card`;

export const putPayPointsPublicIDAssignNfcCard = (requestContract: AssignPayPointRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutPayPointsPublicIDAssignNfcCardFetchResponse> => {
    const requestData = getApiRequestData<AssignPayPointRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPayPointsPublicIDAssignNfcCardPath(publicID)}`, requestData, options) as Promise<PutPayPointsPublicIDAssignNfcCardFetchResponse>;
}

export type GetPayPointsPublicIDTerminalActivationFetchResponse = 
| FetchResponse<TerminalActivationCodeDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPublicIDTerminalActivationPath = (publicID: string) => `/api/pay-points/${publicID}/terminal-activation`;

export const getPayPointsPublicIDTerminalActivation = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPayPointsPublicIDTerminalActivationFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPayPointsPublicIDTerminalActivationPath(publicID)}`, options, {}) as Promise<GetPayPointsPublicIDTerminalActivationFetchResponse>;
}

export type GetPayPointsMerchantMerchantPublicIDFetchResponse = 
| FetchResponse<EntityListOfPayPointBaseDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsMerchantMerchantPublicIDPath = (merchantPublicID: string) => `/api/pay-points/merchant/${merchantPublicID}`;

export const getPayPointsMerchantMerchantPublicID = (merchantPublicID: string, offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetPayPointsMerchantMerchantPublicIDFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getPayPointsMerchantMerchantPublicIDPath(merchantPublicID)}`, options, queryParams) as Promise<GetPayPointsMerchantMerchantPublicIDFetchResponse>;
}

export type PostPayPointsMerchantMerchantPublicIDFetchResponse = 
| FetchResponse<InternalPayPointDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postPayPointsMerchantMerchantPublicIDPath = (merchantPublicID: string) => `/api/pay-points/merchant/${merchantPublicID}`;

export const postPayPointsMerchantMerchantPublicID = (requestContract: CreateInternalPayPointRequest, merchantPublicID: string, options?: FetchArgsOptions):
  Promise<PostPayPointsMerchantMerchantPublicIDFetchResponse> => {
    const requestData = getApiRequestData<CreateInternalPayPointRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPayPointsMerchantMerchantPublicIDPath(merchantPublicID)}`, requestData, options) as Promise<PostPayPointsMerchantMerchantPublicIDFetchResponse>;
}

export type GetPayPointsPublicIDTransactionsLatestFetchResponse = 
| FetchResponse<TransactionDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPublicIDTransactionsLatestPath = (publicID: string) => `/api/pay-points/${publicID}/transactions/latest`;

export const getPayPointsPublicIDTransactionsLatest = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPayPointsPublicIDTransactionsLatestFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPayPointsPublicIDTransactionsLatestPath(publicID)}`, options, {}) as Promise<GetPayPointsPublicIDTransactionsLatestFetchResponse>;
}

export type GetPayPointsPublicIDOwnerFetchResponse = 
| FetchResponse<PayPointOwnerDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPublicIDOwnerPath = (publicID: string) => `/api/pay-points/${publicID}/owner`;

export const getPayPointsPublicIDOwner = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPayPointsPublicIDOwnerFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPayPointsPublicIDOwnerPath(publicID)}`, options, {}) as Promise<GetPayPointsPublicIDOwnerFetchResponse>;
}

export type GetPayPointsPublicIDScanViewFetchResponse = 
| FetchResponse<PayPointScanViewDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPublicIDScanViewPath = (publicID: string) => `/api/pay-points/${publicID}/scan-view`;

export const getPayPointsPublicIDScanView = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPayPointsPublicIDScanViewFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPayPointsPublicIDScanViewPath(publicID)}`, options, {}) as Promise<GetPayPointsPublicIDScanViewFetchResponse>;
}

export type PostPayPointsPublicIDScanFetchResponse = 
| FetchResponse<StartPayPointTransactionResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<void, 429> 
| ErrorResponse;

export const postPayPointsPublicIDScanPath = (publicID: string) => `/api/pay-points/${publicID}/scan`;

export const postPayPointsPublicIDScan = (requestContract: StartPayPointTransactionRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostPayPointsPublicIDScanFetchResponse> => {
    const requestData = getApiRequestData<StartPayPointTransactionRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPayPointsPublicIDScanPath(publicID)}`, requestData, options) as Promise<PostPayPointsPublicIDScanFetchResponse>;
}

export type GetPayPointsPublicIDCredentialFetchResponse = 
| FetchResponse<PayPointCredentialDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPayPointsPublicIDCredentialPath = (publicID: string) => `/api/pay-points/${publicID}/credential`;

export const getPayPointsPublicIDCredential = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPayPointsPublicIDCredentialFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPayPointsPublicIDCredentialPath(publicID)}`, options, {}) as Promise<GetPayPointsPublicIDCredentialFetchResponse>;
}

export type DeletePayPointsPublicIDCredentialFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deletePayPointsPublicIDCredentialPath = (publicID: string) => `/api/pay-points/${publicID}/credential`;

export const deletePayPointsPublicIDCredential = (publicID: string, options?: FetchArgsOptions):
  Promise<DeletePayPointsPublicIDCredentialFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePayPointsPublicIDCredentialPath(publicID)}`, options, {}) as Promise<DeletePayPointsPublicIDCredentialFetchResponse>;
}

export type PostPayPointsPublicIDCredentialFetchResponse = 
| FetchResponse<GatewayCredentialSecretResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postPayPointsPublicIDCredentialPath = (publicID: string) => `/api/pay-points/${publicID}/credential`;

export const postPayPointsPublicIDCredential = (publicID: string, options?: FetchArgsOptions):
  Promise<PostPayPointsPublicIDCredentialFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPayPointsPublicIDCredentialPath(publicID)}`, requestData, options) as Promise<PostPayPointsPublicIDCredentialFetchResponse>;
}

export type PostPayPointsPublicIDCredentialRegenerateFetchResponse = 
| FetchResponse<GatewayCredentialSecretResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postPayPointsPublicIDCredentialRegeneratePath = (publicID: string) => `/api/pay-points/${publicID}/credential/regenerate`;

export const postPayPointsPublicIDCredentialRegenerate = (publicID: string, options?: FetchArgsOptions):
  Promise<PostPayPointsPublicIDCredentialRegenerateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPayPointsPublicIDCredentialRegeneratePath(publicID)}`, requestData, options) as Promise<PostPayPointsPublicIDCredentialRegenerateFetchResponse>;
}

export type GetSettlementPoolBoostsFetchResponse = 
| FetchResponse<GetSettlementPoolBoostsQueryResult, 200> 
| ErrorResponse;

export const getSettlementPoolBoostsPath = () => `/api/settlement-pool-boosts`;

export const getSettlementPoolBoosts = (region?: Region | undefined | null, options?: FetchArgsOptions):
  Promise<GetSettlementPoolBoostsFetchResponse> => {
    const queryParams = {
      "region": region
    }
    return apiGet(`${getApiUrl()}${getSettlementPoolBoostsPath()}`, options, queryParams) as Promise<GetSettlementPoolBoostsFetchResponse>;
}

export type GetSettlementPoolBoostsPoolTotalRegionLoyaltyPointTypeFetchResponse = 
| FetchResponse<GetCurrentMonthlyPoolTotalQueryResult, 200> 
| ErrorResponse;

export const getSettlementPoolBoostsPoolTotalRegionLoyaltyPointTypePath = (region: Region, loyaltyPointType: LoyaltyPointType) => `/api/settlement-pool-boosts/pool-total/${region}/${loyaltyPointType}`;

export const getSettlementPoolBoostsPoolTotalRegionLoyaltyPointType = (region: Region, loyaltyPointType: LoyaltyPointType, options?: FetchArgsOptions):
  Promise<GetSettlementPoolBoostsPoolTotalRegionLoyaltyPointTypeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSettlementPoolBoostsPoolTotalRegionLoyaltyPointTypePath(region, loyaltyPointType)}`, options, {}) as Promise<GetSettlementPoolBoostsPoolTotalRegionLoyaltyPointTypeFetchResponse>;
}

export type PutSettlementPoolBoostsIdFetchResponse = 
| FetchResponse<UpdateSettlementPoolBoostCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putSettlementPoolBoostsIdPath = (id: number) => `/api/settlement-pool-boosts/${id}`;

export const putSettlementPoolBoostsId = (requestContract: UpdateSettlementPoolBoostRequest, id: number, options?: FetchArgsOptions):
  Promise<PutSettlementPoolBoostsIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateSettlementPoolBoostRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putSettlementPoolBoostsIdPath(id)}`, requestData, options) as Promise<PutSettlementPoolBoostsIdFetchResponse>;
}

export type GetSettlementReportsSettlementsFetchResponse = 
| FetchResponse<GetSettlementsQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getSettlementReportsSettlementsPath = () => `/api/settlement-reports/settlements`;

export const getSettlementReportsSettlements = (partyPublicId?: string | undefined | null, filters?: SettlementFilter[] | undefined | null, sortBy?: SettlementSortBy, options?: FetchArgsOptions):
  Promise<GetSettlementReportsSettlementsFetchResponse> => {
    const queryParams = {
      "partyPublicId": partyPublicId,
      "filters": filters,
      "sortBy": sortBy
    }
    return apiGet(`${getApiUrl()}${getSettlementReportsSettlementsPath()}`, options, queryParams) as Promise<GetSettlementReportsSettlementsFetchResponse>;
}

export type GetSettlementReportsMerchantPartyPublicIdFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getSettlementReportsMerchantPartyPublicIdPath = (partyPublicId: string) => `/api/settlement-reports/merchant/${partyPublicId}`;

export const getSettlementReportsMerchantPartyPublicId = (partyPublicId: string, settlementPeriodID?: number, options?: FetchArgsOptions):
  Promise<GetSettlementReportsMerchantPartyPublicIdFetchResponse> => {
    const queryParams = {
      "settlementPeriodID": settlementPeriodID
    }
    return apiGet(`${getApiUrl()}${getSettlementReportsMerchantPartyPublicIdPath(partyPublicId)}`, options, queryParams) as Promise<GetSettlementReportsMerchantPartyPublicIdFetchResponse>;
}

export type GetSettlementReportsHunterPartyPublicIdFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getSettlementReportsHunterPartyPublicIdPath = (partyPublicId: string) => `/api/settlement-reports/hunter/${partyPublicId}`;

export const getSettlementReportsHunterPartyPublicId = (partyPublicId: string, region: Region, settlementPeriodID?: number, options?: FetchArgsOptions):
  Promise<GetSettlementReportsHunterPartyPublicIdFetchResponse> => {
    const queryParams = {
      "region": region,
      "settlementPeriodID": settlementPeriodID
    }
    return apiGet(`${getApiUrl()}${getSettlementReportsHunterPartyPublicIdPath(partyPublicId)}`, options, queryParams) as Promise<GetSettlementReportsHunterPartyPublicIdFetchResponse>;
}

export type GetSettlementReportsSettlementPeriodsFetchResponse = 
| FetchResponse<SettlementPeriod[], 200> 
| ErrorResponse;

export const getSettlementReportsSettlementPeriodsPath = () => `/api/settlement-reports/settlement-periods`;

export const getSettlementReportsSettlementPeriods = (options?: FetchArgsOptions):
  Promise<GetSettlementReportsSettlementPeriodsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSettlementReportsSettlementPeriodsPath()}`, options, {}) as Promise<GetSettlementReportsSettlementPeriodsFetchResponse>;
}

export type PostSettlementReportsTriggerSettlementFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postSettlementReportsTriggerSettlementPath = () => `/api/settlement-reports/trigger-settlement`;

export const postSettlementReportsTriggerSettlement = (options?: FetchArgsOptions):
  Promise<PostSettlementReportsTriggerSettlementFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSettlementReportsTriggerSettlementPath()}`, requestData, options) as Promise<PostSettlementReportsTriggerSettlementFetchResponse>;
}

export type PostSettlementReportsTriggerHunterPaymentsFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postSettlementReportsTriggerHunterPaymentsPath = () => `/api/settlement-reports/trigger-hunter-payments`;

export const postSettlementReportsTriggerHunterPayments = (options?: FetchArgsOptions):
  Promise<PostSettlementReportsTriggerHunterPaymentsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSettlementReportsTriggerHunterPaymentsPath()}`, requestData, options) as Promise<PostSettlementReportsTriggerHunterPaymentsFetchResponse>;
}

export type PutSettlementReportsSettlementsPartyRecordSettlementIDStatusFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putSettlementReportsSettlementsPartyRecordSettlementIDStatusPath = (partyRecordSettlementID: number) => `/api/settlement-reports/settlements/${partyRecordSettlementID}/status`;

export const putSettlementReportsSettlementsPartyRecordSettlementIDStatus = (requestContract: UpdateSettlementStatusRequest, partyRecordSettlementID: number, options?: FetchArgsOptions):
  Promise<PutSettlementReportsSettlementsPartyRecordSettlementIDStatusFetchResponse> => {
    const requestData = getApiRequestData<UpdateSettlementStatusRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putSettlementReportsSettlementsPartyRecordSettlementIDStatusPath(partyRecordSettlementID)}`, requestData, options) as Promise<PutSettlementReportsSettlementsPartyRecordSettlementIDStatusFetchResponse>;
}

export type GetTransactionFeesFetchResponse = 
| FetchResponse<TotalMonthlyFeesResponse, 200> 
| ErrorResponse;

export const getTransactionFeesPath = () => `/api/transaction-fees`;

export const getTransactionFees = (dateFrom?: string | undefined | null, dateTo?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionFeesFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getTransactionFeesPath()}`, options, queryParams) as Promise<GetTransactionFeesFetchResponse>;
}

export type GetTransactionFeesUserPartyPublicIDFetchResponse = 
| FetchResponse<TotalMonthlyFeesResponse, 200> 
| ErrorResponse;

export const getTransactionFeesUserPartyPublicIDPath = (partyPublicID: string) => `/api/transaction-fees/user/${partyPublicID}`;

export const getTransactionFeesUserPartyPublicID = (partyPublicID: string, dateFrom?: string | undefined | null, dateTo?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionFeesUserPartyPublicIDFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getTransactionFeesUserPartyPublicIDPath(partyPublicID)}`, options, queryParams) as Promise<GetTransactionFeesUserPartyPublicIDFetchResponse>;
}

export type GetTransactionFeesPublicIDFetchResponse = 
| FetchResponse<TransactionTotalFeeResponse, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTransactionFeesPublicIDPath = (publicID: string) => `/api/transaction-fees/${publicID}`;

export const getTransactionFeesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetTransactionFeesPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTransactionFeesPublicIDPath(publicID)}`, options, {}) as Promise<GetTransactionFeesPublicIDFetchResponse>;
}

export type GetTransactionFeesHunterEarningsFetchResponse = 
| FetchResponse<TotalMonthlyFeesResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTransactionFeesHunterEarningsPath = () => `/api/transaction-fees/hunter/earnings`;

export const getTransactionFeesHunterEarnings = (dateFrom?: string | undefined | null, dateTo?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionFeesHunterEarningsFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getTransactionFeesHunterEarningsPath()}`, options, queryParams) as Promise<GetTransactionFeesHunterEarningsFetchResponse>;
}

export type GetTransactionFeesHunterCardEarningsFetchResponse = 
| FetchResponse<HunterCardCommissionResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTransactionFeesHunterCardEarningsPath = () => `/api/transaction-fees/hunter/card-earnings`;

export const getTransactionFeesHunterCardEarnings = (options?: FetchArgsOptions):
  Promise<GetTransactionFeesHunterCardEarningsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTransactionFeesHunterCardEarningsPath()}`, options, {}) as Promise<GetTransactionFeesHunterCardEarningsFetchResponse>;
}

export type GetTransactionFeesHunterUserIDCardEarningsFetchResponse = 
| FetchResponse<HunterCardCommissionResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTransactionFeesHunterUserIDCardEarningsPath = (userID: number) => `/api/transaction-fees/hunter/${userID}/card-earnings`;

export const getTransactionFeesHunterUserIDCardEarnings = (userID: number, options?: FetchArgsOptions):
  Promise<GetTransactionFeesHunterUserIDCardEarningsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTransactionFeesHunterUserIDCardEarningsPath(userID)}`, options, {}) as Promise<GetTransactionFeesHunterUserIDCardEarningsFetchResponse>;
}

export type GetTransactionFeesHunterUserIDEarningsFetchResponse = 
| FetchResponse<TotalMonthlyFeesResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTransactionFeesHunterUserIDEarningsPath = (userID: number) => `/api/transaction-fees/hunter/${userID}/earnings`;

export const getTransactionFeesHunterUserIDEarnings = (userID: number, dateFrom?: string | undefined | null, dateTo?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionFeesHunterUserIDEarningsFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getTransactionFeesHunterUserIDEarningsPath(userID)}`, options, queryParams) as Promise<GetTransactionFeesHunterUserIDEarningsFetchResponse>;
}

export type GetTransactionFeesEarningsFetchResponse = 
| FetchResponse<TotalMonthlyFeesResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getTransactionFeesEarningsPath = () => `/api/transaction-fees/earnings`;

export const getTransactionFeesEarnings = (dateFrom?: string | undefined | null, dateTo?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionFeesEarningsFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getTransactionFeesEarningsPath()}`, options, queryParams) as Promise<GetTransactionFeesEarningsFetchResponse>;
}

export type PostTransactionsInitiateFetchResponse = 
| FetchResponse<InitiateTransactionResponse, 200> 
| ErrorResponse;

export const postTransactionsInitiatePath = () => `/api/transactions/initiate`;

export const postTransactionsInitiate = (requestContract: InitiateTransactionRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsInitiateFetchResponse> => {
    const requestData = getApiRequestData<InitiateTransactionRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsInitiatePath()}`, requestData, options) as Promise<PostTransactionsInitiateFetchResponse>;
}

export type GetTransactionsStatusFetchResponse = 
| FetchResponse<TransactionStatusResponse, 200> 
| ErrorResponse;

export const getTransactionsStatusPath = () => `/api/transactions/status`;

export const getTransactionsStatus = (publicID?: string, options?: FetchArgsOptions):
  Promise<GetTransactionsStatusFetchResponse> => {
    const queryParams = {
      "publicID": publicID
    }
    return apiGet(`${getApiUrl()}${getTransactionsStatusPath()}`, options, queryParams) as Promise<GetTransactionsStatusFetchResponse>;
}

export type PostTransactionsPaymentAuthorizationFetchResponse = 
| FetchResponse<string, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postTransactionsPaymentAuthorizationPath = (transactionPublicID?: string) => `/api/transactions/payment-authorization`;

export const postTransactionsPaymentAuthorization = (transactionPublicID?: string, options?: FetchArgsOptions):
  Promise<PostTransactionsPaymentAuthorizationFetchResponse> => {
    const queryParams = {
      "transactionPublicID": transactionPublicID
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postTransactionsPaymentAuthorizationPath()}`, requestData, options, queryParams) as Promise<PostTransactionsPaymentAuthorizationFetchResponse>;
}

export type PostTransactionsPayFetchResponse = 
| FetchResponse<PayTransactionResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const postTransactionsPayPath = () => `/api/transactions/pay`;

export const postTransactionsPay = (requestContract: PayTransactionRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsPayFetchResponse> => {
    const requestData = getApiRequestData<PayTransactionRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsPayPath()}`, requestData, options) as Promise<PostTransactionsPayFetchResponse>;
}

export type PostTransactionsDirectPayFetchResponse = 
| FetchResponse<SendDirectPaymentResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postTransactionsDirectPayPath = () => `/api/transactions/direct-pay`;

export const postTransactionsDirectPay = (requestContract: SendDirectPaymentRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsDirectPayFetchResponse> => {
    const requestData = getApiRequestData<SendDirectPaymentRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsDirectPayPath()}`, requestData, options) as Promise<PostTransactionsDirectPayFetchResponse>;
}

export type PostTransactionsQuickPayFetchResponse = 
| FetchResponse<PayTransactionResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const postTransactionsQuickPayPath = () => `/api/transactions/quick-pay`;

export const postTransactionsQuickPay = (requestContract: PayTransactionQuickRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsQuickPayFetchResponse> => {
    const requestData = getApiRequestData<PayTransactionQuickRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsQuickPayPath()}`, requestData, options) as Promise<PostTransactionsQuickPayFetchResponse>;
}

export type GetTransactionsFetchResponse = 
| FetchResponse<EntityListOfTransactionItem, 200> 
| ErrorResponse;

export const getTransactionsPath = () => `/api/transactions`;

export const getTransactions = (Offset?: number, Limit?: number, SearchPublicID?: string | undefined | null, Status?: TransactionStatus | undefined | null, DateFrom?: string | undefined | null, DateTo?: string | undefined | null, PayPointPublicID?: string | undefined | null, EmployeePublicID?: string | undefined | null, Direction?: TransactionDirection | undefined | null, IsRefundOrCancellation?: boolean | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionsFetchResponse> => {
    const queryParams = {
      "Offset": Offset,
      "Limit": Limit,
      "SearchPublicID": SearchPublicID,
      "Status": Status,
      "DateFrom": DateFrom,
      "DateTo": DateTo,
      "PayPointPublicID": PayPointPublicID,
      "EmployeePublicID": EmployeePublicID,
      "Direction": Direction,
      "IsRefundOrCancellation": IsRefundOrCancellation
    }
    return apiGet(`${getApiUrl()}${getTransactionsPath()}`, options, queryParams) as Promise<GetTransactionsFetchResponse>;
}

export type GetTransactionsExportFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const getTransactionsExportPath = () => `/api/transactions/export`;

export const getTransactionsExport = (Format?: TransactionExportFormat, Email?: string | undefined | null, SearchPublicID?: string | undefined | null, Status?: TransactionStatus | undefined | null, DateFrom?: string | undefined | null, DateTo?: string | undefined | null, PayPointPublicID?: string | undefined | null, EmployeePublicID?: string | undefined | null, TargetUserID?: number | undefined | null, Direction?: TransactionDirection | undefined | null, IsRefundOrCancellation?: boolean | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionsExportFetchResponse> => {
    const queryParams = {
      "Format": Format,
      "Email": Email,
      "SearchPublicID": SearchPublicID,
      "Status": Status,
      "DateFrom": DateFrom,
      "DateTo": DateTo,
      "PayPointPublicID": PayPointPublicID,
      "EmployeePublicID": EmployeePublicID,
      "TargetUserID": TargetUserID,
      "Direction": Direction,
      "IsRefundOrCancellation": IsRefundOrCancellation
    }
    return apiGet(`${getApiUrl()}${getTransactionsExportPath()}`, options, queryParams) as Promise<GetTransactionsExportFetchResponse>;
}

export type PostTransactionsExportFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const postTransactionsExportPath = () => `/api/transactions/export`;

export const postTransactionsExport = (requestContract: ExportTransactionsRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsExportFetchResponse> => {
    const requestData = getApiRequestData<ExportTransactionsRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsExportPath()}`, requestData, options) as Promise<PostTransactionsExportFetchResponse>;
}

export type GetTransactionsPublicIDFetchResponse = 
| FetchResponse<TransactionDetailDto, 200> 
| ErrorResponse;

export const getTransactionsPublicIDPath = (publicID: string) => `/api/transactions/${publicID}`;

export const getTransactionsPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetTransactionsPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getTransactionsPublicIDPath(publicID)}`, options, {}) as Promise<GetTransactionsPublicIDFetchResponse>;
}

export type GetTransactionsSumFetchResponse = 
| FetchResponse<TransactionSumResponse, 200> 
| ErrorResponse;

export const getTransactionsSumPath = () => `/api/transactions/sum`;

export const getTransactionsSum = (startDate?: string | undefined | null, endDate?: string | undefined | null, allowedStatuses?: TransactionStatus[] | undefined | null, isCredit?: boolean, payPointPublicID?: string | undefined | null, employeePublicID?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionsSumFetchResponse> => {
    const queryParams = {
      "startDate": startDate,
      "endDate": endDate,
      "allowedStatuses": allowedStatuses,
      "isCredit": isCredit,
      "payPointPublicID": payPointPublicID,
      "employeePublicID": employeePublicID
    }
    return apiGet(`${getApiUrl()}${getTransactionsSumPath()}`, options, queryParams) as Promise<GetTransactionsSumFetchResponse>;
}

export type PostTransactionsInvoiceSendFetchResponse = 
| FetchResponse<TransactionSumResponse, 200> 
| ErrorResponse;

export const postTransactionsInvoiceSendPath = () => `/api/transactions/invoice/send`;

export const postTransactionsInvoiceSend = (requestContract: SendInvoiceRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsInvoiceSendFetchResponse> => {
    const requestData = getApiRequestData<SendInvoiceRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsInvoiceSendPath()}`, requestData, options) as Promise<PostTransactionsInvoiceSendFetchResponse>;
}

export type PostTransactionsPublicIDBankReturnFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postTransactionsPublicIDBankReturnPath = (publicID: string) => `/api/transactions/${publicID}/bank-return`;

export const postTransactionsPublicIDBankReturn = (requestContract: RecordBankReturnRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostTransactionsPublicIDBankReturnFetchResponse> => {
    const requestData = getApiRequestData<RecordBankReturnRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsPublicIDBankReturnPath(publicID)}`, requestData, options) as Promise<PostTransactionsPublicIDBankReturnFetchResponse>;
}

export type PutTransactionsPublicIDCancelFetchResponse = 
| FetchResponse<CancelTransactionCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putTransactionsPublicIDCancelPath = (publicID: string) => `/api/transactions/${publicID}/cancel`;

export const putTransactionsPublicIDCancel = (publicID: string, options?: FetchArgsOptions):
  Promise<PutTransactionsPublicIDCancelFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putTransactionsPublicIDCancelPath(publicID)}`, requestData, options) as Promise<PutTransactionsPublicIDCancelFetchResponse>;
}

export type PutTransactionsPublicIDTipFetchResponse = 
| FetchResponse<TransactionDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| FetchResponse<ApiProblemDetails, 429> 
| ErrorResponse;

export const putTransactionsPublicIDTipPath = (publicID: string) => `/api/transactions/${publicID}/tip`;

export const putTransactionsPublicIDTip = (requestContract: UpdateTransactionTipRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutTransactionsPublicIDTipFetchResponse> => {
    const requestData = getApiRequestData<UpdateTransactionTipRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putTransactionsPublicIDTipPath(publicID)}`, requestData, options) as Promise<PutTransactionsPublicIDTipFetchResponse>;
}

export type GetTransactionsRefundsFetchResponse = 
| FetchResponse<EntityListOfTransactionItem, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getTransactionsRefundsPath = () => `/api/transactions/refunds`;

export const getTransactionsRefunds = (offset?: number, limit?: number, allowedStatuses?: TransactionStatus[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetTransactionsRefundsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "allowedStatuses": allowedStatuses
    }
    return apiGet(`${getApiUrl()}${getTransactionsRefundsPath()}`, options, queryParams) as Promise<GetTransactionsRefundsFetchResponse>;
}

export type PostTransactionsCampaignTransactionsInitiateFetchResponse = 
| FetchResponse<InitiateCampaignTransactionResponse, 200> 
| ErrorResponse;

export const postTransactionsCampaignTransactionsInitiatePath = () => `/api/transactions/campaign-transactions/initiate`;

export const postTransactionsCampaignTransactionsInitiate = (requestContract: InitiateCampaignTransactionRequest, options?: FetchArgsOptions):
  Promise<PostTransactionsCampaignTransactionsInitiateFetchResponse> => {
    const requestData = getApiRequestData<InitiateCampaignTransactionRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postTransactionsCampaignTransactionsInitiatePath()}`, requestData, options) as Promise<PostTransactionsCampaignTransactionsInitiateFetchResponse>;
}

export type GetSsoClientsFetchResponse = 
| FetchResponse<SsoClientDto[], 200> 
| ErrorResponse;

export const getSsoClientsPath = () => `/api/sso/clients`;

export const getSsoClients = (options?: FetchArgsOptions):
  Promise<GetSsoClientsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSsoClientsPath()}`, options, {}) as Promise<GetSsoClientsFetchResponse>;
}

export type PostSsoClientsFetchResponse = 
| FetchResponse<SsoClientRegisteredDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postSsoClientsPath = () => `/api/sso/clients`;

export const postSsoClients = (requestContract: SsoClientRequest, options?: FetchArgsOptions):
  Promise<PostSsoClientsFetchResponse> => {
    const requestData = getApiRequestData<SsoClientRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postSsoClientsPath()}`, requestData, options) as Promise<PostSsoClientsFetchResponse>;
}

export type DeleteSsoClientsClientIdFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteSsoClientsClientIdPath = (clientId: string) => `/api/sso/clients/${clientId}`;

export const deleteSsoClientsClientId = (clientId: string, options?: FetchArgsOptions):
  Promise<DeleteSsoClientsClientIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteSsoClientsClientIdPath(clientId)}`, options, {}) as Promise<DeleteSsoClientsClientIdFetchResponse>;
}

export type PutSsoClientsClientIdFetchResponse = 
| FetchResponse<SsoClientDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putSsoClientsClientIdPath = (clientId: string) => `/api/sso/clients/${clientId}`;

export const putSsoClientsClientId = (requestContract: SsoClientRequest, clientId: string, options?: FetchArgsOptions):
  Promise<PutSsoClientsClientIdFetchResponse> => {
    const requestData = getApiRequestData<SsoClientRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putSsoClientsClientIdPath(clientId)}`, requestData, options) as Promise<PutSsoClientsClientIdFetchResponse>;
}

export type PostSsoClientsClientIdSecretFetchResponse = 
| FetchResponse<SsoClientSecretDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postSsoClientsClientIdSecretPath = (clientId: string) => `/api/sso/clients/${clientId}/secret`;

export const postSsoClientsClientIdSecret = (clientId: string, options?: FetchArgsOptions):
  Promise<PostSsoClientsClientIdSecretFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSsoClientsClientIdSecretPath(clientId)}`, requestData, options) as Promise<PostSsoClientsClientIdSecretFetchResponse>;
}

export type GetSsoAuthorizationRequestsPublicIDFetchResponse = 
| FetchResponse<SsoAuthorizationRequestDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getSsoAuthorizationRequestsPublicIDPath = (publicID: string) => `/api/sso/authorization-requests/${publicID}`;

export const getSsoAuthorizationRequestsPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetSsoAuthorizationRequestsPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSsoAuthorizationRequestsPublicIDPath(publicID)}`, options, {}) as Promise<GetSsoAuthorizationRequestsPublicIDFetchResponse>;
}

export type PostSsoAuthorizationRequestsPublicIDApproveFetchResponse = 
| FetchResponse<SsoAuthorizationDecisionResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postSsoAuthorizationRequestsPublicIDApprovePath = (publicID: string) => `/api/sso/authorization-requests/${publicID}/approve`;

export const postSsoAuthorizationRequestsPublicIDApprove = (publicID: string, options?: FetchArgsOptions):
  Promise<PostSsoAuthorizationRequestsPublicIDApproveFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSsoAuthorizationRequestsPublicIDApprovePath(publicID)}`, requestData, options) as Promise<PostSsoAuthorizationRequestsPublicIDApproveFetchResponse>;
}

export type PostSsoAuthorizationRequestsPublicIDDenyFetchResponse = 
| FetchResponse<SsoAuthorizationDecisionResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postSsoAuthorizationRequestsPublicIDDenyPath = (publicID: string) => `/api/sso/authorization-requests/${publicID}/deny`;

export const postSsoAuthorizationRequestsPublicIDDeny = (publicID: string, options?: FetchArgsOptions):
  Promise<PostSsoAuthorizationRequestsPublicIDDenyFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postSsoAuthorizationRequestsPublicIDDenyPath(publicID)}`, requestData, options) as Promise<PostSsoAuthorizationRequestsPublicIDDenyFetchResponse>;
}

export type GetSsoConnectedAppsFetchResponse = 
| FetchResponse<ConnectedAppDto[], 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getSsoConnectedAppsPath = () => `/api/sso/connected-apps`;

export const getSsoConnectedApps = (options?: FetchArgsOptions):
  Promise<GetSsoConnectedAppsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getSsoConnectedAppsPath()}`, options, {}) as Promise<GetSsoConnectedAppsFetchResponse>;
}

export type DeleteSsoConnectedAppsClientIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteSsoConnectedAppsClientIdPath = (clientId: string) => `/api/sso/connected-apps/${clientId}`;

export const deleteSsoConnectedAppsClientId = (clientId: string, options?: FetchArgsOptions):
  Promise<DeleteSsoConnectedAppsClientIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteSsoConnectedAppsClientIdPath(clientId)}`, options, {}) as Promise<DeleteSsoConnectedAppsClientIdFetchResponse>;
}

export type GetAdminRaffleRoundsFetchResponse = 
| FetchResponse<RaffleRoundDto[], 200> 
| ErrorResponse;

export const getAdminRaffleRoundsPath = () => `/api/admin/raffle/rounds`;

export const getAdminRaffleRounds = (region?: Region | undefined | null, status?: RaffleRoundStatus | undefined | null, options?: FetchArgsOptions):
  Promise<GetAdminRaffleRoundsFetchResponse> => {
    const queryParams = {
      "region": region,
      "status": status
    }
    return apiGet(`${getApiUrl()}${getAdminRaffleRoundsPath()}`, options, queryParams) as Promise<GetAdminRaffleRoundsFetchResponse>;
}

export type PostAdminRaffleRoundsFetchResponse = 
| FetchResponse<RaffleRoundDto, 201> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const postAdminRaffleRoundsPath = () => `/api/admin/raffle/rounds`;

export const postAdminRaffleRounds = (requestContract: CreateRaffleRoundRequest, options?: FetchArgsOptions):
  Promise<PostAdminRaffleRoundsFetchResponse> => {
    const requestData = getApiRequestData<CreateRaffleRoundRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdminRaffleRoundsPath()}`, requestData, options) as Promise<PostAdminRaffleRoundsFetchResponse>;
}

export type PutAdminRaffleRoundsPublicIdFetchResponse = 
| FetchResponse<RaffleRoundDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putAdminRaffleRoundsPublicIdPath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}`;

export const putAdminRaffleRoundsPublicId = (requestContract: UpdateRaffleRoundRequest, publicId: string, options?: FetchArgsOptions):
  Promise<PutAdminRaffleRoundsPublicIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateRaffleRoundRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAdminRaffleRoundsPublicIdPath(publicId)}`, requestData, options) as Promise<PutAdminRaffleRoundsPublicIdFetchResponse>;
}

export type PostAdminRaffleRoundsPublicIdAnnounceFetchResponse = 
| FetchResponse<RaffleRoundDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminRaffleRoundsPublicIdAnnouncePath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}/announce`;

export const postAdminRaffleRoundsPublicIdAnnounce = (publicId: string, options?: FetchArgsOptions):
  Promise<PostAdminRaffleRoundsPublicIdAnnounceFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminRaffleRoundsPublicIdAnnouncePath(publicId)}`, requestData, options) as Promise<PostAdminRaffleRoundsPublicIdAnnounceFetchResponse>;
}

export type PostAdminRaffleRoundsPublicIdCloseFetchResponse = 
| FetchResponse<RaffleRoundDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminRaffleRoundsPublicIdClosePath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}/close`;

export const postAdminRaffleRoundsPublicIdClose = (publicId: string, options?: FetchArgsOptions):
  Promise<PostAdminRaffleRoundsPublicIdCloseFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminRaffleRoundsPublicIdClosePath(publicId)}`, requestData, options) as Promise<PostAdminRaffleRoundsPublicIdCloseFetchResponse>;
}

export type PostAdminRaffleRoundsPublicIdSetDefaultFetchResponse = 
| FetchResponse<RaffleRoundDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminRaffleRoundsPublicIdSetDefaultPath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}/set-default`;

export const postAdminRaffleRoundsPublicIdSetDefault = (publicId: string, options?: FetchArgsOptions):
  Promise<PostAdminRaffleRoundsPublicIdSetDefaultFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminRaffleRoundsPublicIdSetDefaultPath(publicId)}`, requestData, options) as Promise<PostAdminRaffleRoundsPublicIdSetDefaultFetchResponse>;
}

export type PostAdminRaffleRoundsPublicIdCancelFetchResponse = 
| FetchResponse<RaffleRoundDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminRaffleRoundsPublicIdCancelPath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}/cancel`;

export const postAdminRaffleRoundsPublicIdCancel = (publicId: string, options?: FetchArgsOptions):
  Promise<PostAdminRaffleRoundsPublicIdCancelFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminRaffleRoundsPublicIdCancelPath(publicId)}`, requestData, options) as Promise<PostAdminRaffleRoundsPublicIdCancelFetchResponse>;
}

export type PostAdminRaffleRoundsPublicIdCompleteFetchResponse = 
| FetchResponse<RaffleRoundDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminRaffleRoundsPublicIdCompletePath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}/complete`;

export const postAdminRaffleRoundsPublicIdComplete = (publicId: string, options?: FetchArgsOptions):
  Promise<PostAdminRaffleRoundsPublicIdCompleteFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminRaffleRoundsPublicIdCompletePath(publicId)}`, requestData, options) as Promise<PostAdminRaffleRoundsPublicIdCompleteFetchResponse>;
}

export type GetAdminRaffleRoundsPublicIdExportFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getAdminRaffleRoundsPublicIdExportPath = (publicId: string) => `/api/admin/raffle/rounds/${publicId}/export`;

export const getAdminRaffleRoundsPublicIdExport = (publicId: string, options?: FetchArgsOptions):
  Promise<GetAdminRaffleRoundsPublicIdExportFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAdminRaffleRoundsPublicIdExportPath(publicId)}`, options, {}) as Promise<GetAdminRaffleRoundsPublicIdExportFetchResponse>;
}

export type GetAdminRaffleRoundsPublicIdTicketsTicketNumberHolderFetchResponse = 
| FetchResponse<RaffleTicketHolderDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getAdminRaffleRoundsPublicIdTicketsTicketNumberHolderPath = (publicId: string, ticketNumber: number) => `/api/admin/raffle/rounds/${publicId}/tickets/${ticketNumber}/holder`;

export const getAdminRaffleRoundsPublicIdTicketsTicketNumberHolder = (publicId: string, ticketNumber: number, options?: FetchArgsOptions):
  Promise<GetAdminRaffleRoundsPublicIdTicketsTicketNumberHolderFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAdminRaffleRoundsPublicIdTicketsTicketNumberHolderPath(publicId, ticketNumber)}`, options, {}) as Promise<GetAdminRaffleRoundsPublicIdTicketsTicketNumberHolderFetchResponse>;
}

export type GetRaffleCurrentFetchResponse = 
| FetchResponse<RaffleCurrentDto, 200> 
| ErrorResponse;

export const getRaffleCurrentPath = () => `/api/raffle/current`;

export const getRaffleCurrent = (options?: FetchArgsOptions):
  Promise<GetRaffleCurrentFetchResponse> => {
    return apiGet(`${getApiUrl()}${getRaffleCurrentPath()}`, options, {}) as Promise<GetRaffleCurrentFetchResponse>;
}

export type GetRaffleHistoryFetchResponse = 
| FetchResponse<RaffleHistoryItemDto[], 200> 
| ErrorResponse;

export const getRaffleHistoryPath = () => `/api/raffle/history`;

export const getRaffleHistory = (options?: FetchArgsOptions):
  Promise<GetRaffleHistoryFetchResponse> => {
    return apiGet(`${getApiUrl()}${getRaffleHistoryPath()}`, options, {}) as Promise<GetRaffleHistoryFetchResponse>;
}

export type PostRaffleTicketsMoveFetchResponse = 
| FetchResponse<RaffleTicketMoveResultDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postRaffleTicketsMovePath = () => `/api/raffle/tickets/move`;

export const postRaffleTicketsMove = (requestContract: MoveRaffleTicketsRequest, options?: FetchArgsOptions):
  Promise<PostRaffleTicketsMoveFetchResponse> => {
    const requestData = getApiRequestData<MoveRaffleTicketsRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postRaffleTicketsMovePath()}`, requestData, options) as Promise<PostRaffleTicketsMoveFetchResponse>;
}

export type GetPublicCampaignsCodeFetchResponse = 
| FetchResponse<CampaignDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPublicCampaignsCodePath = (code: string) => `/api/public/campaigns/${code}`;

export const getPublicCampaignsCode = (code: string, options?: FetchArgsOptions):
  Promise<GetPublicCampaignsCodeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPublicCampaignsCodePath(code)}`, options, {}) as Promise<GetPublicCampaignsCodeFetchResponse>;
}

export type GetPublicCampaignsCodeImagesImageTypeFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPublicCampaignsCodeImagesImageTypePath = (code: string, imageType: CampaignImageType) => `/api/public/campaigns/${code}/images/${imageType}`;

export const getPublicCampaignsCodeImagesImageType = (code: string, imageType: CampaignImageType, options?: FetchArgsOptions):
  Promise<GetPublicCampaignsCodeImagesImageTypeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPublicCampaignsCodeImagesImageTypePath(code, imageType)}`, options, {}) as Promise<GetPublicCampaignsCodeImagesImageTypeFetchResponse>;
}

export type PostPartiesFetchResponse = 
| FetchResponse<CreatePartyCommandResult, 201> 
| ErrorResponse;

export const postPartiesPath = () => `/api/parties`;

export const postParties = (requestContract: CreatePartyDto, options?: FetchArgsOptions):
  Promise<PostPartiesFetchResponse> => {
    const requestData = getApiRequestData<CreatePartyDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartiesPath()}`, requestData, options) as Promise<PostPartiesFetchResponse>;
}

export type GetPartiesPublicIDFetchResponse = 
| FetchResponse<PartyDto, 200> 
| ErrorResponse;

export const getPartiesPublicIDPath = (publicID: string) => `/api/parties/${publicID}`;

export const getPartiesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPartiesPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesPublicIDPath(publicID)}`, options, {}) as Promise<GetPartiesPublicIDFetchResponse>;
}

export type DeletePartiesPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deletePartiesPublicIDPath = (publicID: string) => `/api/parties/${publicID}`;

export const deletePartiesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<DeletePartiesPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePartiesPublicIDPath(publicID)}`, options, {}) as Promise<DeletePartiesPublicIDFetchResponse>;
}

export type PutPartiesPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const putPartiesPublicIDPath = (publicID: string) => `/api/parties/${publicID}`;

export const putPartiesPublicID = (requestContract: PartyDto, publicID: string, options?: FetchArgsOptions):
  Promise<PutPartiesPublicIDFetchResponse> => {
    const requestData = getApiRequestData<PartyDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPartiesPublicIDPath(publicID)}`, requestData, options) as Promise<PutPartiesPublicIDFetchResponse>;
}

export type GetPartiesSearchAresFetchResponse = 
| FetchResponse<PartyDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPartiesSearchAresPath = () => `/api/parties/search/ares`;

export const getPartiesSearchAres = (query?: string, partyType?: PartyType | undefined | null, region?: Region, options?: FetchArgsOptions):
  Promise<GetPartiesSearchAresFetchResponse> => {
    const queryParams = {
      "query": query,
      "partyType": partyType,
      "region": region
    }
    return apiGet(`${getApiUrl()}${getPartiesSearchAresPath()}`, options, queryParams) as Promise<GetPartiesSearchAresFetchResponse>;
}

export type GetPartiesVatRegistrationFetchResponse = 
| FetchResponse<VatRegistrationDto, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const getPartiesVatRegistrationPath = () => `/api/parties/vat-registration`;

export const getPartiesVatRegistration = (region?: Region, taxNumber?: string | undefined | null, vatNumber?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetPartiesVatRegistrationFetchResponse> => {
    const queryParams = {
      "region": region,
      "taxNumber": taxNumber,
      "vatNumber": vatNumber
    }
    return apiGet(`${getApiUrl()}${getPartiesVatRegistrationPath()}`, options, queryParams) as Promise<GetPartiesVatRegistrationFetchResponse>;
}

export type PostPartiesPublicIDUploadDocumentsFetchResponse = 
| FetchResponse<UploadDocumentsCommandResult, 200> 
| ErrorResponse;

export const postPartiesPublicIDUploadDocumentsPath = (publicID: string) => `/api/parties/${publicID}/upload-documents`;

export const postPartiesPublicIDUploadDocuments = (publicID: string, options?: FetchArgsOptions):
  Promise<PostPartiesPublicIDUploadDocumentsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postPartiesPublicIDUploadDocumentsPath(publicID)}`, requestData, options) as Promise<PostPartiesPublicIDUploadDocumentsFetchResponse>;
}

export type PostPartiesPartyPublicIDRelationsFetchResponse = 
| FetchResponse<CreateRelatedPartyCommandResult, 200> 
| ErrorResponse;

export const postPartiesPartyPublicIDRelationsPath = (partyPublicID: string) => `/api/parties/${partyPublicID}/relations`;

export const postPartiesPartyPublicIDRelations = (requestContract: RelatedPartyDto, partyPublicID: string, options?: FetchArgsOptions):
  Promise<PostPartiesPartyPublicIDRelationsFetchResponse> => {
    const requestData = getApiRequestData<RelatedPartyDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartiesPartyPublicIDRelationsPath(partyPublicID)}`, requestData, options) as Promise<PostPartiesPartyPublicIDRelationsFetchResponse>;
}

export type PutPartiesCompanyPartyPublicIDActingPersonFetchResponse = 
| FetchResponse<SetActingPersonRelationCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const putPartiesCompanyPartyPublicIDActingPersonPath = (companyPartyPublicID: string) => `/api/parties/${companyPartyPublicID}/acting-person`;

export const putPartiesCompanyPartyPublicIDActingPerson = (requestContract: SetActingPersonRequest, companyPartyPublicID: string, options?: FetchArgsOptions):
  Promise<PutPartiesCompanyPartyPublicIDActingPersonFetchResponse> => {
    const requestData = getApiRequestData<SetActingPersonRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPartiesCompanyPartyPublicIDActingPersonPath(companyPartyPublicID)}`, requestData, options) as Promise<PutPartiesCompanyPartyPublicIDActingPersonFetchResponse>;
}

export type DeletePartiesRelationsPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deletePartiesRelationsPublicIDPath = (publicID: string) => `/api/parties/relations/${publicID}`;

export const deletePartiesRelationsPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<DeletePartiesRelationsPublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePartiesRelationsPublicIDPath(publicID)}`, options, {}) as Promise<DeletePartiesRelationsPublicIDFetchResponse>;
}

export type PutPartiesRelationsPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const putPartiesRelationsPublicIDPath = (publicID: string) => `/api/parties/relations/${publicID}`;

export const putPartiesRelationsPublicID = (requestContract: RelatedPartyDto, publicID: string, options?: FetchArgsOptions):
  Promise<PutPartiesRelationsPublicIDFetchResponse> => {
    const requestData = getApiRequestData<RelatedPartyDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPartiesRelationsPublicIDPath(publicID)}`, requestData, options) as Promise<PutPartiesRelationsPublicIDFetchResponse>;
}

export type DeletePartiesPublicIDAddressesAddressIDFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deletePartiesPublicIDAddressesAddressIDPath = (publicID: string, addressID: number) => `/api/parties/${publicID}/addresses/${addressID}`;

export const deletePartiesPublicIDAddressesAddressID = (publicID: string, addressID: number, options?: FetchArgsOptions):
  Promise<DeletePartiesPublicIDAddressesAddressIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePartiesPublicIDAddressesAddressIDPath(publicID, addressID)}`, options, {}) as Promise<DeletePartiesPublicIDAddressesAddressIDFetchResponse>;
}

export type GetPartiesPersonalNumberPersonalNumberAvailabilityFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getPartiesPersonalNumberPersonalNumberAvailabilityPath = (personalNumber: string) => `/api/parties/personal-number/${personalNumber}/availability`;

export const getPartiesPersonalNumberPersonalNumberAvailability = (personalNumber: string, options?: FetchArgsOptions):
  Promise<GetPartiesPersonalNumberPersonalNumberAvailabilityFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesPersonalNumberPersonalNumberAvailabilityPath(personalNumber)}`, options, {}) as Promise<GetPartiesPersonalNumberPersonalNumberAvailabilityFetchResponse>;
}

export type GetPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailabilityFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailabilityPath = (accessRoleCode: string, companyNumber: string) => `/api/parties/${accessRoleCode}/company-number/${companyNumber}/availability`;

export const getPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailability = (accessRoleCode: string, companyNumber: string, region?: Region | undefined | null, options?: FetchArgsOptions):
  Promise<GetPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailabilityFetchResponse> => {
    const queryParams = {
      "region": region
    }
    return apiGet(`${getApiUrl()}${getPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailabilityPath(accessRoleCode, companyNumber)}`, options, queryParams) as Promise<GetPartiesAccessRoleCodeCompanyNumberCompanyNumberAvailabilityFetchResponse>;
}

export type GetPartiesCompanyNumberCompanyNumberAvailabilityFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getPartiesCompanyNumberCompanyNumberAvailabilityPath = (companyNumber: string) => `/api/parties/company-number/${companyNumber}/availability`;

export const getPartiesCompanyNumberCompanyNumberAvailability = (companyNumber: string, options?: FetchArgsOptions):
  Promise<GetPartiesCompanyNumberCompanyNumberAvailabilityFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesCompanyNumberCompanyNumberAvailabilityPath(companyNumber)}`, options, {}) as Promise<GetPartiesCompanyNumberCompanyNumberAvailabilityFetchResponse>;
}

export type GetPartiesPartyIdentificationsZipPublicIDFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const getPartiesPartyIdentificationsZipPublicIDPath = (publicID: string) => `/api/parties/party-identifications-zip/${publicID}`;

export const getPartiesPartyIdentificationsZipPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPartiesPartyIdentificationsZipPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesPartyIdentificationsZipPublicIDPath(publicID)}`, options, {}) as Promise<GetPartiesPartyIdentificationsZipPublicIDFetchResponse>;
}

export type GetPartiesPartyIdentificationImagesPublicIDFetchResponse = 
| FetchResponse<GetPartyIdentificationImagesQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPartiesPartyIdentificationImagesPublicIDPath = (publicID: string) => `/api/parties/party-identification-images/${publicID}`;

export const getPartiesPartyIdentificationImagesPublicID = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPartiesPartyIdentificationImagesPublicIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesPartyIdentificationImagesPublicIDPath(publicID)}`, options, {}) as Promise<GetPartiesPartyIdentificationImagesPublicIDFetchResponse>;
}

export type GetPartiesPublicIDIdentityDocumentVerificationsFetchResponse = 
| FetchResponse<IdentityDocumentVerificationDto[], 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPartiesPublicIDIdentityDocumentVerificationsPath = (publicID: string) => `/api/parties/${publicID}/identity-document-verifications`;

export const getPartiesPublicIDIdentityDocumentVerifications = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPartiesPublicIDIdentityDocumentVerificationsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesPublicIDIdentityDocumentVerificationsPath(publicID)}`, options, {}) as Promise<GetPartiesPublicIDIdentityDocumentVerificationsFetchResponse>;
}

export type GetPartiesPublicIDActingPersonPartyFetchResponse = 
| FetchResponse<PartyDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getPartiesPublicIDActingPersonPartyPath = (publicID: string) => `/api/parties/${publicID}/acting-person-party`;

export const getPartiesPublicIDActingPersonParty = (publicID: string, options?: FetchArgsOptions):
  Promise<GetPartiesPublicIDActingPersonPartyFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesPublicIDActingPersonPartyPath(publicID)}`, options, {}) as Promise<GetPartiesPublicIDActingPersonPartyFetchResponse>;
}

export type GetPartiesRelatedPartiesExpiringDocumentsFetchResponse = 
| FetchResponse<GetExpiringRelatedPartyDocumentsQueryResult, 200> 
| ErrorResponse;

export const getPartiesRelatedPartiesExpiringDocumentsPath = () => `/api/parties/related-parties/expiring-documents`;

export const getPartiesRelatedPartiesExpiringDocuments = (options?: FetchArgsOptions):
  Promise<GetPartiesRelatedPartiesExpiringDocumentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartiesRelatedPartiesExpiringDocumentsPath()}`, options, {}) as Promise<GetPartiesRelatedPartiesExpiringDocumentsFetchResponse>;
}

export type GetLoyaltiesEventRecordsFetchResponse = 
| FetchResponse<GetStardustRecordQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLoyaltiesEventRecordsPath = () => `/api/loyalties/event-records`;

export const getLoyaltiesEventRecords = (limit?: number, offset?: number, pointType?: LoyaltyPointType | undefined | null, settlementPeriodId?: number | undefined | null, options?: FetchArgsOptions):
  Promise<GetLoyaltiesEventRecordsFetchResponse> => {
    const queryParams = {
      "limit": limit,
      "offset": offset,
      "pointType": pointType,
      "settlementPeriodId": settlementPeriodId
    }
    return apiGet(`${getApiUrl()}${getLoyaltiesEventRecordsPath()}`, options, queryParams) as Promise<GetLoyaltiesEventRecordsFetchResponse>;
}

export type PostLoyaltiesEventRecordsFetchResponse = 
| FetchResponse<ProcessLoyaltyEventCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postLoyaltiesEventRecordsPath = () => `/api/loyalties/event-records`;

export const postLoyaltiesEventRecords = (requestContract: ProcessLoyaltyEventRequest, options?: FetchArgsOptions):
  Promise<PostLoyaltiesEventRecordsFetchResponse> => {
    const requestData = getApiRequestData<ProcessLoyaltyEventRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLoyaltiesEventRecordsPath()}`, requestData, options) as Promise<PostLoyaltiesEventRecordsFetchResponse>;
}

export type PutLoyaltiesStardustParticipationFetchResponse = 
| FetchResponse<SetStardustParticipationResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putLoyaltiesStardustParticipationPath = () => `/api/loyalties/stardust-participation`;

export const putLoyaltiesStardustParticipation = (requestContract: SetStardustParticipationRequest, options?: FetchArgsOptions):
  Promise<PutLoyaltiesStardustParticipationFetchResponse> => {
    const requestData = getApiRequestData<SetStardustParticipationRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putLoyaltiesStardustParticipationPath()}`, requestData, options) as Promise<PutLoyaltiesStardustParticipationFetchResponse>;
}

export type GetLoyaltiesEventsFetchResponse = 
| FetchResponse<GetLoyaltyEventListQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLoyaltiesEventsPath = () => `/api/loyalties/events`;

export const getLoyaltiesEvents = (options?: FetchArgsOptions):
  Promise<GetLoyaltiesEventsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLoyaltiesEventsPath()}`, options, {}) as Promise<GetLoyaltiesEventsFetchResponse>;
}

export type GetLoyaltiesOverviewFetchResponse = 
| FetchResponse<GetLoyaltyOverviewQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLoyaltiesOverviewPath = () => `/api/loyalties/overview`;

export const getLoyaltiesOverview = (options?: FetchArgsOptions):
  Promise<GetLoyaltiesOverviewFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLoyaltiesOverviewPath()}`, options, {}) as Promise<GetLoyaltiesOverviewFetchResponse>;
}

export type GetLoyaltiesLeaderboardFetchResponse = 
| FetchResponse<GetStardustLeaderboardQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLoyaltiesLeaderboardPath = () => `/api/loyalties/leaderboard`;

export const getLoyaltiesLeaderboard = (limit?: number, offset?: number, pointType?: LoyaltyPointType | undefined | null, settlementPeriodId?: number | undefined | null, region?: Region | undefined | null, options?: FetchArgsOptions):
  Promise<GetLoyaltiesLeaderboardFetchResponse> => {
    const queryParams = {
      "limit": limit,
      "offset": offset,
      "pointType": pointType,
      "settlementPeriodId": settlementPeriodId,
      "region": region
    }
    return apiGet(`${getApiUrl()}${getLoyaltiesLeaderboardPath()}`, options, queryParams) as Promise<GetLoyaltiesLeaderboardFetchResponse>;
}

export type GetLoyaltiesPeriodsFetchResponse = 
| FetchResponse<GetLoyaltyPeriodsQueryResult, 200> 
| ErrorResponse;

export const getLoyaltiesPeriodsPath = () => `/api/loyalties/periods`;

export const getLoyaltiesPeriods = (options?: FetchArgsOptions):
  Promise<GetLoyaltiesPeriodsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLoyaltiesPeriodsPath()}`, options, {}) as Promise<GetLoyaltiesPeriodsFetchResponse>;
}

export type GetLicensesPublicPartyIDFetchResponse = 
| FetchResponse<EntityListOfPartyLicenseDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLicensesPublicPartyIDPath = (publicPartyID: string) => `/api/licenses/${publicPartyID}`;

export const getLicensesPublicPartyID = (publicPartyID: string, options?: FetchArgsOptions):
  Promise<GetLicensesPublicPartyIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLicensesPublicPartyIDPath(publicPartyID)}`, options, {}) as Promise<GetLicensesPublicPartyIDFetchResponse>;
}

export type GetLicensesTypesFetchResponse = 
| FetchResponse<EntityListOfLicenseTypeListItem, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLicensesTypesPath = () => `/api/licenses/types`;

export const getLicensesTypes = (region?: Region | undefined | null, code?: LicenseCode | undefined | null, options?: FetchArgsOptions):
  Promise<GetLicensesTypesFetchResponse> => {
    const queryParams = {
      "region": region,
      "code": code
    }
    return apiGet(`${getApiUrl()}${getLicensesTypesPath()}`, options, queryParams) as Promise<GetLicensesTypesFetchResponse>;
}

export type PutLicensesPublicIDPaymentStatusFetchResponse = 
| FetchResponse<UpdateLicensePaymentStatusCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putLicensesPublicIDPaymentStatusPath = (publicID: string) => `/api/licenses/${publicID}/payment-status`;

export const putLicensesPublicIDPaymentStatus = (requestContract: UpdateLicensePaymentStatusRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutLicensesPublicIDPaymentStatusFetchResponse> => {
    const requestData = getApiRequestData<UpdateLicensePaymentStatusRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putLicensesPublicIDPaymentStatusPath(publicID)}`, requestData, options) as Promise<PutLicensesPublicIDPaymentStatusFetchResponse>;
}

export type PutLicensesPublicIDFetchResponse = 
| FetchResponse<UpdateLicenseCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putLicensesPublicIDPath = (publicID: string) => `/api/licenses/${publicID}`;

export const putLicensesPublicID = (requestContract: UpdateLicenseRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutLicensesPublicIDFetchResponse> => {
    const requestData = getApiRequestData<UpdateLicenseRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putLicensesPublicIDPath(publicID)}`, requestData, options) as Promise<PutLicensesPublicIDFetchResponse>;
}

export type PostLicensesFetchResponse = 
| FetchResponse<CreateLicenseCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postLicensesPath = () => `/api/licenses`;

export const postLicenses = (requestContract: CreateLicenseRequest, options?: FetchArgsOptions):
  Promise<PostLicensesFetchResponse> => {
    const requestData = getApiRequestData<CreateLicenseRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLicensesPath()}`, requestData, options) as Promise<PostLicensesFetchResponse>;
}

export type DeleteLicensesLicensePublicIDFetchResponse = 
| FetchResponse<void, 204> 
| ErrorResponse;

export const deleteLicensesLicensePublicIDPath = (licensePublicID: string) => `/api/licenses/${licensePublicID}`;

export const deleteLicensesLicensePublicID = (licensePublicID: string, options?: FetchArgsOptions):
  Promise<DeleteLicensesLicensePublicIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteLicensesLicensePublicIDPath(licensePublicID)}`, options, {}) as Promise<DeleteLicensesLicensePublicIDFetchResponse>;
}

export type PostLicensesPublicIDTransferFetchResponse = 
| FetchResponse<TransferLicenseCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postLicensesPublicIDTransferPath = (publicID: string) => `/api/licenses/${publicID}/transfer`;

export const postLicensesPublicIDTransfer = (requestContract: TransferLicenseRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PostLicensesPublicIDTransferFetchResponse> => {
    const requestData = getApiRequestData<TransferLicenseRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLicensesPublicIDTransferPath(publicID)}`, requestData, options) as Promise<PostLicensesPublicIDTransferFetchResponse>;
}

export type GetLicensesSharesFetchResponse = 
| FetchResponse<EntityListOfLicenseShareDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getLicensesSharesPath = () => `/api/licenses/shares`;

export const getLicensesShares = (options?: FetchArgsOptions):
  Promise<GetLicensesSharesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getLicensesSharesPath()}`, options, {}) as Promise<GetLicensesSharesFetchResponse>;
}

export type PostLicensesRecreateInvoicesFetchResponse = 
| FetchResponse<RecreateInvoicesCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postLicensesRecreateInvoicesPath = () => `/api/licenses/recreate-invoices`;

export const postLicensesRecreateInvoices = (requestContract: RecreateLicensesInvoicesRequest, options?: FetchArgsOptions):
  Promise<PostLicensesRecreateInvoicesFetchResponse> => {
    const requestData = getApiRequestData<RecreateLicensesInvoicesRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postLicensesRecreateInvoicesPath()}`, requestData, options) as Promise<PostLicensesRecreateInvoicesFetchResponse>;
}

export type GetCouponsFetchResponse = 
| FetchResponse<EntityListOfCouponDto, 200> 
| ErrorResponse;

export const getCouponsPath = () => `/api/coupons`;

export const getCoupons = (Code?: string | undefined | null, Status?: CouponStatusFilter | undefined | null, DiscountType?: CouponDiscountType | undefined | null, ExpirationDateFrom?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetCouponsFetchResponse> => {
    const queryParams = {
      "Code": Code,
      "Status": Status,
      "DiscountType": DiscountType,
      "ExpirationDateFrom": ExpirationDateFrom,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getCouponsPath()}`, options, queryParams) as Promise<GetCouponsFetchResponse>;
}

export type PostCouponsFetchResponse = 
| FetchResponse<CreateCouponCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postCouponsPath = () => `/api/coupons`;

export const postCoupons = (requestContract: CreateCouponRequest, options?: FetchArgsOptions):
  Promise<PostCouponsFetchResponse> => {
    const requestData = getApiRequestData<CreateCouponRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCouponsPath()}`, requestData, options) as Promise<PostCouponsFetchResponse>;
}

export type PostCouponsValidateFetchResponse = 
| FetchResponse<ValidateCouponResult, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postCouponsValidatePath = () => `/api/coupons/validate`;

export const postCouponsValidate = (requestContract: ValidateCouponRequest, options?: FetchArgsOptions):
  Promise<PostCouponsValidateFetchResponse> => {
    const requestData = getApiRequestData<ValidateCouponRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCouponsValidatePath()}`, requestData, options) as Promise<PostCouponsValidateFetchResponse>;
}

export type DeleteCouponsCouponIDFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteCouponsCouponIDPath = (couponID: number) => `/api/coupons/${couponID}`;

export const deleteCouponsCouponID = (couponID: number, options?: FetchArgsOptions):
  Promise<DeleteCouponsCouponIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteCouponsCouponIDPath(couponID)}`, options, {}) as Promise<DeleteCouponsCouponIDFetchResponse>;
}

export type PutCouponsCouponIDFetchResponse = 
| FetchResponse<boolean, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putCouponsCouponIDPath = (couponID: number) => `/api/coupons/${couponID}`;

export const putCouponsCouponID = (requestContract: UpdateCouponRequest, couponID: number, options?: FetchArgsOptions):
  Promise<PutCouponsCouponIDFetchResponse> => {
    const requestData = getApiRequestData<UpdateCouponRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putCouponsCouponIDPath(couponID)}`, requestData, options) as Promise<PutCouponsCouponIDFetchResponse>;
}

export type GetBankingAccountsFetchResponse = 
| FetchResponse<EntityListOfBankAccountListItem, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getBankingAccountsPath = () => `/api/banking/accounts`;

export const getBankingAccounts = (userID?: number | undefined | null, options?: FetchArgsOptions):
  Promise<GetBankingAccountsFetchResponse> => {
    const queryParams = {
      "userID": userID
    }
    return apiGet(`${getApiUrl()}${getBankingAccountsPath()}`, options, queryParams) as Promise<GetBankingAccountsFetchResponse>;
}

export type GetBankingAccountsEnvironmentFetchResponse = 
| FetchResponse<EntityListOfBankAccountListItem, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getBankingAccountsEnvironmentPath = () => `/api/banking/accounts/environment`;

export const getBankingAccountsEnvironment = (bankEnvironment?: BankEnvironment, options?: FetchArgsOptions):
  Promise<GetBankingAccountsEnvironmentFetchResponse> => {
    const queryParams = {
      "bankEnvironment": bankEnvironment
    }
    return apiGet(`${getApiUrl()}${getBankingAccountsEnvironmentPath()}`, options, queryParams) as Promise<GetBankingAccountsEnvironmentFetchResponse>;
}

export type PostBankingAccountsSyncFetchResponse = 
| FetchResponse<boolean, 200> 
| FetchResponse<ApiProblemDetails, 500> 
| ErrorResponse;

export const postBankingAccountsSyncPath = () => `/api/banking/accounts/sync`;

export const postBankingAccountsSync = (options?: FetchArgsOptions):
  Promise<PostBankingAccountsSyncFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postBankingAccountsSyncPath()}`, requestData, options) as Promise<PostBankingAccountsSyncFetchResponse>;
}

export type PostBankingAccountsTransactionsSyncFetchResponse = 
| FetchResponse<SyncBankTransactionsCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const postBankingAccountsTransactionsSyncPath = (bankEnvironment?: BankEnvironment | undefined | null, identityUserID?: number | undefined | null) => `/api/banking/accounts/transactions/sync`;

export const postBankingAccountsTransactionsSync = (bankEnvironment?: BankEnvironment | undefined | null, identityUserID?: number | undefined | null, options?: FetchArgsOptions):
  Promise<PostBankingAccountsTransactionsSyncFetchResponse> => {
    const queryParams = {
      "bankEnvironment": bankEnvironment,
      "identityUserID": identityUserID
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postBankingAccountsTransactionsSyncPath()}`, requestData, options, queryParams) as Promise<PostBankingAccountsTransactionsSyncFetchResponse>;
}

export type GetBankingAccountsRbStandingOrdersFetchResponse = 
| FetchResponse<RBStandingOrdersResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| ErrorResponse;

export const getBankingAccountsRbStandingOrdersPath = () => `/api/banking/accounts/rb/standing-orders`;

export const getBankingAccountsRbStandingOrders = (bankEnvironment?: BankEnvironment, options?: FetchArgsOptions):
  Promise<GetBankingAccountsRbStandingOrdersFetchResponse> => {
    const queryParams = {
      "bankEnvironment": bankEnvironment
    }
    return apiGet(`${getApiUrl()}${getBankingAccountsRbStandingOrdersPath()}`, options, queryParams) as Promise<GetBankingAccountsRbStandingOrdersFetchResponse>;
}

export type PutBankingAccountsRankFetchResponse = 
| FetchResponse<RankBankAccountsResponse, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putBankingAccountsRankPath = () => `/api/banking/accounts/rank`;

export const putBankingAccountsRank = (requestContract: RankBankAccountsRequest, options?: FetchArgsOptions):
  Promise<PutBankingAccountsRankFetchResponse> => {
    const requestData = getApiRequestData<RankBankAccountsRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putBankingAccountsRankPath()}`, requestData, options) as Promise<PutBankingAccountsRankFetchResponse>;
}

export type DeleteBankingAccountsAccountIDFetchResponse = 
| FetchResponse<DeleteBankAccountResponse, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteBankingAccountsAccountIDPath = (accountID: number) => `/api/banking/accounts/${accountID}`;

export const deleteBankingAccountsAccountID = (accountID: number, options?: FetchArgsOptions):
  Promise<DeleteBankingAccountsAccountIDFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteBankingAccountsAccountIDPath(accountID)}`, options, {}) as Promise<DeleteBankingAccountsAccountIDFetchResponse>;
}

export type PutBankingAccountsPublicIDPrimaryFetchResponse = 
| FetchResponse<SetPrimaryBankAccountCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putBankingAccountsPublicIDPrimaryPath = (publicID: string) => `/api/banking/accounts/${publicID}/primary`;

export const putBankingAccountsPublicIDPrimary = (publicID: string, options?: FetchArgsOptions):
  Promise<PutBankingAccountsPublicIDPrimaryFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putBankingAccountsPublicIDPrimaryPath(publicID)}`, requestData, options) as Promise<PutBankingAccountsPublicIDPrimaryFetchResponse>;
}

export type PutBankingAccountsPublicIDStatusFetchResponse = 
| FetchResponse<UpdateBankAccountStatusResponse, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putBankingAccountsPublicIDStatusPath = (publicID: string) => `/api/banking/accounts/${publicID}/status`;

export const putBankingAccountsPublicIDStatus = (requestContract: UpdateBankAccountStatusRequest, publicID: string, options?: FetchArgsOptions):
  Promise<PutBankingAccountsPublicIDStatusFetchResponse> => {
    const requestData = getApiRequestData<UpdateBankAccountStatusRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putBankingAccountsPublicIDStatusPath(publicID)}`, requestData, options) as Promise<PutBankingAccountsPublicIDStatusFetchResponse>;
}

export type GetBankingAuthAuthenticateFetchResponse = 
| FetchResponse<AuthenticationUrl, 200> 
| ErrorResponse;

export const getBankingAuthAuthenticatePath = () => `/api/banking/auth/authenticate`;

export const getBankingAuthAuthenticate = (environment?: BankEnvironment, transactionPublicID?: string, options?: FetchArgsOptions):
  Promise<GetBankingAuthAuthenticateFetchResponse> => {
    const queryParams = {
      "environment": environment,
      "transactionPublicID": transactionPublicID
    }
    return apiGet(`${getApiUrl()}${getBankingAuthAuthenticatePath()}`, options, queryParams) as Promise<GetBankingAuthAuthenticateFetchResponse>;
}

export type GetBankingAuthAuthenticatePispFetchResponse = 
| FetchResponse<AuthenticationUrl, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const getBankingAuthAuthenticatePispPath = () => `/api/banking/auth/authenticate-pisp`;

export const getBankingAuthAuthenticatePisp = (environment?: BankEnvironment, transactionPublicID?: string, options?: FetchArgsOptions):
  Promise<GetBankingAuthAuthenticatePispFetchResponse> => {
    const queryParams = {
      "environment": environment,
      "transactionPublicID": transactionPublicID
    }
    return apiGet(`${getApiUrl()}${getBankingAuthAuthenticatePispPath()}`, options, queryParams) as Promise<GetBankingAuthAuthenticatePispFetchResponse>;
}

export type PostBankingAuthWarmUpFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postBankingAuthWarmUpPath = (bankAccountPublicID?: string) => `/api/banking/auth/warm-up`;

export const postBankingAuthWarmUp = (bankAccountPublicID?: string, options?: FetchArgsOptions):
  Promise<PostBankingAuthWarmUpFetchResponse> => {
    const queryParams = {
      "bankAccountPublicID": bankAccountPublicID
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postBankingAuthWarmUpPath()}`, requestData, options, queryParams) as Promise<PostBankingAuthWarmUpFetchResponse>;
}

export type GetBankingAuthCallbackFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getBankingAuthCallbackPath = () => `/api/banking/auth/callback`;

export const getBankingAuthCallback = (code?: string | undefined | null, state?: string, error?: string | undefined | null, error_description?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetBankingAuthCallbackFetchResponse> => {
    const queryParams = {
      "code": code,
      "state": state,
      "error": error,
      "error_description": error_description
    }
    return apiGet(`${getApiUrl()}${getBankingAuthCallbackPath()}`, options, queryParams) as Promise<GetBankingAuthCallbackFetchResponse>;
}

export type GetBankingAuthCheckExpirationFetchResponse = 
| FetchResponse<ExpiringRefreshTokenBanksResult, 200> 
| ErrorResponse;

export const getBankingAuthCheckExpirationPath = () => `/api/banking/auth/check-expiration`;

export const getBankingAuthCheckExpiration = (options?: FetchArgsOptions):
  Promise<GetBankingAuthCheckExpirationFetchResponse> => {
    return apiGet(`${getApiUrl()}${getBankingAuthCheckExpirationPath()}`, options, {}) as Promise<GetBankingAuthCheckExpirationFetchResponse>;
}

export type GetBankingBanksEnvironmentsFetchResponse = 
| FetchResponse<EntityListOfBankEnvironmentDto, 200> 
| ErrorResponse;

export const getBankingBanksEnvironmentsPath = () => `/api/banking/banks/environments`;

export const getBankingBanksEnvironments = (options?: FetchArgsOptions):
  Promise<GetBankingBanksEnvironmentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getBankingBanksEnvironmentsPath()}`, options, {}) as Promise<GetBankingBanksEnvironmentsFetchResponse>;
}

export type GetBankingBatchPaymentsFetchResponse = 
| FetchResponse<EntityListOfBatchPaymentListItemDto, 200> 
| ErrorResponse;

export const getBankingBatchPaymentsPath = () => `/api/banking/batch-payments`;

export const getBankingBatchPayments = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetBankingBatchPaymentsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getBankingBatchPaymentsPath()}`, options, queryParams) as Promise<GetBankingBatchPaymentsFetchResponse>;
}

export type PostBankingBatchPaymentsFetchResponse = 
| FetchResponse<CreateBatchPaymentResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postBankingBatchPaymentsPath = () => `/api/banking/batch-payments`;

export const postBankingBatchPayments = (requestContract: CreateBatchPaymentCommand, options?: FetchArgsOptions):
  Promise<PostBankingBatchPaymentsFetchResponse> => {
    const requestData = getApiRequestData<CreateBatchPaymentCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postBankingBatchPaymentsPath()}`, requestData, options) as Promise<PostBankingBatchPaymentsFetchResponse>;
}

export type GetBankingBatchPaymentsPublicIdFetchResponse = 
| FetchResponse<BatchPaymentDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getBankingBatchPaymentsPublicIdPath = (publicId: string) => `/api/banking/batch-payments/${publicId}`;

export const getBankingBatchPaymentsPublicId = (publicId: string, options?: FetchArgsOptions):
  Promise<GetBankingBatchPaymentsPublicIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getBankingBatchPaymentsPublicIdPath(publicId)}`, options, {}) as Promise<GetBankingBatchPaymentsPublicIdFetchResponse>;
}

export type GetBankingPaymentsCallbackFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 500> 
| ErrorResponse;

export const getBankingPaymentsCallbackPath = () => `/api/banking/payments/callback`;

export const getBankingPaymentsCallback = (instructionIdentification?: string | undefined | null, batchPublicId?: string | undefined | null, error?: string | undefined | null, error_description?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetBankingPaymentsCallbackFetchResponse> => {
    const queryParams = {
      "instructionIdentification": instructionIdentification,
      "batchPublicId": batchPublicId,
      "error": error,
      "error_description": error_description
    }
    return apiGet(`${getApiUrl()}${getBankingPaymentsCallbackPath()}`, options, queryParams) as Promise<GetBankingPaymentsCallbackFetchResponse>;
}

export type GetAdminCampaignsFetchResponse = 
| FetchResponse<EntityListOfAdminCampaignDto, 200> 
| ErrorResponse;

export const getAdminCampaignsPath = () => `/api/admin/campaigns`;

export const getAdminCampaigns = (Status?: string | undefined | null, Name?: string | undefined | null, Code?: string | undefined | null, ReceiverCompanyName?: string | undefined | null, DisplayStatus?: CampaignDisplayStatus | undefined | null, StartDateFrom?: string | undefined | null, EndDateFrom?: string | undefined | null, DateCreatedFrom?: string | undefined | null, DateUpdatedFrom?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetAdminCampaignsFetchResponse> => {
    const queryParams = {
      "Status": Status,
      "Name": Name,
      "Code": Code,
      "ReceiverCompanyName": ReceiverCompanyName,
      "DisplayStatus": DisplayStatus,
      "StartDateFrom": StartDateFrom,
      "EndDateFrom": EndDateFrom,
      "DateCreatedFrom": DateCreatedFrom,
      "DateUpdatedFrom": DateUpdatedFrom,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getAdminCampaignsPath()}`, options, queryParams) as Promise<GetAdminCampaignsFetchResponse>;
}

export type PostAdminCampaignsFetchResponse = 
| FetchResponse<CreateCampaignCommandResult, 201> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminCampaignsPath = () => `/api/admin/campaigns`;

export const postAdminCampaigns = (requestContract: CreateCampaignRequest, options?: FetchArgsOptions):
  Promise<PostAdminCampaignsFetchResponse> => {
    const requestData = getApiRequestData<CreateCampaignRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdminCampaignsPath()}`, requestData, options) as Promise<PostAdminCampaignsFetchResponse>;
}

export type GetAdminCampaignsIdFetchResponse = 
| FetchResponse<AdminCampaignDto, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getAdminCampaignsIdPath = (id: number) => `/api/admin/campaigns/${id}`;

export const getAdminCampaignsId = (id: number, options?: FetchArgsOptions):
  Promise<GetAdminCampaignsIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAdminCampaignsIdPath(id)}`, options, {}) as Promise<GetAdminCampaignsIdFetchResponse>;
}

export type DeleteAdminCampaignsIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteAdminCampaignsIdPath = (id: number) => `/api/admin/campaigns/${id}`;

export const deleteAdminCampaignsId = (id: number, options?: FetchArgsOptions):
  Promise<DeleteAdminCampaignsIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteAdminCampaignsIdPath(id)}`, options, {}) as Promise<DeleteAdminCampaignsIdFetchResponse>;
}

export type PutAdminCampaignsIdFetchResponse = 
| FetchResponse<UpdateCampaignCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const putAdminCampaignsIdPath = (id: number) => `/api/admin/campaigns/${id}`;

export const putAdminCampaignsId = (requestContract: UpdateCampaignRequest, id: number, options?: FetchArgsOptions):
  Promise<PutAdminCampaignsIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateCampaignRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAdminCampaignsIdPath(id)}`, requestData, options) as Promise<PutAdminCampaignsIdFetchResponse>;
}

export type PostAdminCampaignsIdRestoreFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const postAdminCampaignsIdRestorePath = (id: number) => `/api/admin/campaigns/${id}/restore`;

export const postAdminCampaignsIdRestore = (id: number, options?: FetchArgsOptions):
  Promise<PostAdminCampaignsIdRestoreFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminCampaignsIdRestorePath(id)}`, requestData, options) as Promise<PostAdminCampaignsIdRestoreFetchResponse>;
}

export type GetAdminCampaignsIdImagesImageTypeFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const getAdminCampaignsIdImagesImageTypePath = (id: number, imageType: CampaignImageType) => `/api/admin/campaigns/${id}/images/${imageType}`;

export const getAdminCampaignsIdImagesImageType = (id: number, imageType: CampaignImageType, options?: FetchArgsOptions):
  Promise<GetAdminCampaignsIdImagesImageTypeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAdminCampaignsIdImagesImageTypePath(id, imageType)}`, options, {}) as Promise<GetAdminCampaignsIdImagesImageTypeFetchResponse>;
}

export type DeleteAdminCampaignsIdImagesImageTypeFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const deleteAdminCampaignsIdImagesImageTypePath = (id: number, imageType: CampaignImageType) => `/api/admin/campaigns/${id}/images/${imageType}`;

export const deleteAdminCampaignsIdImagesImageType = (id: number, imageType: CampaignImageType, options?: FetchArgsOptions):
  Promise<DeleteAdminCampaignsIdImagesImageTypeFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteAdminCampaignsIdImagesImageTypePath(id, imageType)}`, options, {}) as Promise<DeleteAdminCampaignsIdImagesImageTypeFetchResponse>;
}

export type PutAdminCampaignsIdImagesImageTypeFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| ErrorResponse;

export const putAdminCampaignsIdImagesImageTypePath = (id: number, imageType: CampaignImageType) => `/api/admin/campaigns/${id}/images/${imageType}`;

export const putAdminCampaignsIdImagesImageType = (id: number, imageType: CampaignImageType, options?: FetchArgsOptions):
  Promise<PutAdminCampaignsIdImagesImageTypeFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPut(`${getApiUrl()}${putAdminCampaignsIdImagesImageTypePath(id, imageType)}`, requestData, options) as Promise<PutAdminCampaignsIdImagesImageTypeFetchResponse>;
}

export type PostAdminCardTransactionsBackfillFetchResponse = 
| FetchResponse<EnqueueCardTransactionBackfillCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| ErrorResponse;

export const postAdminCardTransactionsBackfillPath = () => `/api/admin/card-transactions/backfill`;

export const postAdminCardTransactionsBackfill = (requestContract: EnqueueCardTransactionBackfillCommand, options?: FetchArgsOptions):
  Promise<PostAdminCardTransactionsBackfillFetchResponse> => {
    const requestData = getApiRequestData<EnqueueCardTransactionBackfillCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdminCardTransactionsBackfillPath()}`, requestData, options) as Promise<PostAdminCardTransactionsBackfillFetchResponse>;
}

export type PostAdminCardTransactionsRecomputeRollupsFetchResponse = 
| FetchResponse<RecomputeCardCommissionRollupsCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 409> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const postAdminCardTransactionsRecomputeRollupsPath = () => `/api/admin/card-transactions/recompute-rollups`;

export const postAdminCardTransactionsRecomputeRollups = (options?: FetchArgsOptions):
  Promise<PostAdminCardTransactionsRecomputeRollupsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminCardTransactionsRecomputeRollupsPath()}`, requestData, options) as Promise<PostAdminCardTransactionsRecomputeRollupsFetchResponse>;
}

export type PostAdminJobsVatStatusRefreshFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postAdminJobsVatStatusRefreshPath = () => `/api/admin/jobs/vat-status-refresh`;

export const postAdminJobsVatStatusRefresh = (options?: FetchArgsOptions):
  Promise<PostAdminJobsVatStatusRefreshFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminJobsVatStatusRefreshPath()}`, requestData, options) as Promise<PostAdminJobsVatStatusRefreshFetchResponse>;
}

export type GetAdminMerchantUsersSearchFetchResponse = 
| FetchResponse<MerchantUserDto[], 200> 
| ErrorResponse;

export const getAdminMerchantUsersSearchPath = () => `/api/admin/merchant-users/search`;

export const getAdminMerchantUsersSearch = (query?: string, options?: FetchArgsOptions):
  Promise<GetAdminMerchantUsersSearchFetchResponse> => {
    const queryParams = {
      "query": query
    }
    return apiGet(`${getApiUrl()}${getAdminMerchantUsersSearchPath()}`, options, queryParams) as Promise<GetAdminMerchantUsersSearchFetchResponse>;
}

export type GetAdminMerchantUsersFetchResponse = 
| FetchResponse<EntityListOfMerchantUserDto, 200> 
| ErrorResponse;

export const getAdminMerchantUsersPath = () => `/api/admin/merchant-users`;

export const getAdminMerchantUsers = (CompanyName?: string | undefined | null, CompanyNumber?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetAdminMerchantUsersFetchResponse> => {
    const queryParams = {
      "CompanyName": CompanyName,
      "CompanyNumber": CompanyNumber,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getAdminMerchantUsersPath()}`, options, queryParams) as Promise<GetAdminMerchantUsersFetchResponse>;
}

export type PostAdminTransactionsPublicIDSimulateSuccessFetchResponse = 
| FetchResponse<SimulatePaymentSuccessResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 403> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminTransactionsPublicIDSimulateSuccessPath = (publicID: string) => `/api/admin/transactions/${publicID}/simulate-success`;

export const postAdminTransactionsPublicIDSimulateSuccess = (publicID: string, options?: FetchArgsOptions):
  Promise<PostAdminTransactionsPublicIDSimulateSuccessFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdminTransactionsPublicIDSimulateSuccessPath(publicID)}`, requestData, options) as Promise<PostAdminTransactionsPublicIDSimulateSuccessFetchResponse>;
}

export type GetAdminMerchantsUnassignedFetchResponse = 
| FetchResponse<EntityListOfUnassignedMerchantListItemDto, 200> 
| ErrorResponse;

export const getAdminMerchantsUnassignedPath = () => `/api/admin/merchants/unassigned`;

export const getAdminMerchantsUnassigned = (Statuses?: string[] | undefined | null, CompanyName?: string | undefined | null, CompanyNumber?: string | undefined | null, DateCreatedFrom?: string | undefined | null, DateCreatedTo?: string | undefined | null, Offset?: number, Limit?: number, SortBy?: string | undefined | null, SortDirection?: SortDirection, options?: FetchArgsOptions):
  Promise<GetAdminMerchantsUnassignedFetchResponse> => {
    const queryParams = {
      "Statuses": Statuses,
      "CompanyName": CompanyName,
      "CompanyNumber": CompanyNumber,
      "DateCreatedFrom": DateCreatedFrom,
      "DateCreatedTo": DateCreatedTo,
      "Offset": Offset,
      "Limit": Limit,
      "SortBy": SortBy,
      "SortDirection": SortDirection
    }
    return apiGet(`${getApiUrl()}${getAdminMerchantsUnassignedPath()}`, options, queryParams) as Promise<GetAdminMerchantsUnassignedFetchResponse>;
}

export type PostAdminMerchantsUnassignedMerchantPublicIDAssignHunterFetchResponse = 
| FetchResponse<AssignHunterToUnassignedMerchantResult, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| ErrorResponse;

export const postAdminMerchantsUnassignedMerchantPublicIDAssignHunterPath = (merchantPublicID: string) => `/api/admin/merchants/unassigned/${merchantPublicID}/assign-hunter`;

export const postAdminMerchantsUnassignedMerchantPublicIDAssignHunter = (requestContract: AssignHunterToUnassignedMerchantRequest, merchantPublicID: string, options?: FetchArgsOptions):
  Promise<PostAdminMerchantsUnassignedMerchantPublicIDAssignHunterFetchResponse> => {
    const requestData = getApiRequestData<AssignHunterToUnassignedMerchantRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdminMerchantsUnassignedMerchantPublicIDAssignHunterPath(merchantPublicID)}`, requestData, options) as Promise<PostAdminMerchantsUnassignedMerchantPublicIDAssignHunterFetchResponse>;
}

export type GetAddressesSearchFetchResponse = 
| FetchResponse<AddressSuggestionDto[], 200> 
| ErrorResponse;

export const getAddressesSearchPath = () => `/api/addresses/search`;

export const getAddressesSearch = (query?: string | undefined | null, limit?: number | undefined | null, options?: FetchArgsOptions):
  Promise<GetAddressesSearchFetchResponse> => {
    const queryParams = {
      "query": query,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getAddressesSearchPath()}`, options, queryParams) as Promise<GetAddressesSearchFetchResponse>;
}
